import React from 'react';

type Props = {
  color?: string;
};

const IconReportCard: React.FC<Props> = ({ color = '#73E2A3' }: Props) => (
  <svg
    width="148"
    height="80"
    viewBox="0 0 148 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1220_174861"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="-53"
      width="204"
      height="178"
    >
      <path
        d="M5.73642 -50.4783C5.73642 -49.0855 4.45228 -47.9565 2.86821 -47.9565C1.28414 -47.9565 0 -49.0855 0 -50.4783C0 -51.871 1.28414 -53 2.86821 -53C4.45228 -53 5.73642 -51.871 5.73642 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -50.4783C57.3642 -49.0855 56.0801 -47.9565 54.496 -47.9565C52.912 -47.9565 51.6278 -49.0855 51.6278 -50.4783C51.6278 -51.871 52.912 -53 54.496 -53C56.0801 -53 57.3642 -51.871 57.3642 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M5.73642 -20.2174C5.73642 -18.8247 4.45228 -17.6957 2.86821 -17.6957C1.28414 -17.6957 0 -18.8247 0 -20.2174C0 -21.6101 1.28414 -22.7391 2.86821 -22.7391C4.45228 -22.7391 5.73642 -21.6101 5.73642 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -20.2174C57.3642 -18.8247 56.0801 -17.6957 54.496 -17.6957C52.912 -17.6957 51.6278 -18.8247 51.6278 -20.2174C51.6278 -21.6101 52.912 -22.7391 54.496 -22.7391C56.0801 -22.7391 57.3642 -21.6101 57.3642 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M5.73642 -35.3478C5.73642 -33.9551 4.45228 -32.8261 2.86821 -32.8261C1.28414 -32.8261 0 -33.9551 0 -35.3478C0 -36.7405 1.28414 -37.8696 2.86821 -37.8696C4.45228 -37.8696 5.73642 -36.7405 5.73642 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -35.3478C57.3642 -33.9551 56.0801 -32.8261 54.496 -32.8261C52.912 -32.8261 51.6278 -33.9551 51.6278 -35.3478C51.6278 -36.7405 52.912 -37.8696 54.496 -37.8696C56.0801 -37.8696 57.3642 -36.7405 57.3642 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M5.73642 -5.08696C5.73642 -3.69424 4.45228 -2.56522 2.86821 -2.56522C1.28414 -2.56522 0 -3.69424 0 -5.08696C0 -6.47968 1.28414 -7.60869 2.86821 -7.60869C4.45228 -7.60869 5.73642 -6.47968 5.73642 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -5.08696C57.3642 -3.69424 56.0801 -2.56522 54.496 -2.56522C52.912 -2.56522 51.6278 -3.69424 51.6278 -5.08696C51.6278 -6.47968 52.912 -7.60869 54.496 -7.60869C56.0801 -7.60869 57.3642 -6.47968 57.3642 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M5.73642 -42.913C5.73642 -41.5203 4.45228 -40.3913 2.86821 -40.3913C1.28414 -40.3913 0 -41.5203 0 -42.913C0 -44.3058 1.28414 -45.4348 2.86821 -45.4348C4.45228 -45.4348 5.73642 -44.3058 5.73642 -42.913Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -42.913C57.3642 -41.5203 56.0801 -40.3913 54.496 -40.3913C52.912 -40.3913 51.6278 -41.5203 51.6278 -42.913C51.6278 -44.3058 52.912 -45.4348 54.496 -45.4348C56.0801 -45.4348 57.3642 -44.3058 57.3642 -42.913Z"
        fill="#060606"
      />
      <path
        d="M5.73642 -12.6522C5.73642 -11.2595 4.45228 -10.1304 2.86821 -10.1304C1.28414 -10.1304 0 -11.2595 0 -12.6522C0 -14.0449 1.28414 -15.1739 2.86821 -15.1739C4.45228 -15.1739 5.73642 -14.0449 5.73642 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -12.6522C57.3642 -11.2595 56.0801 -10.1304 54.496 -10.1304C52.912 -10.1304 51.6278 -11.2595 51.6278 -12.6522C51.6278 -14.0449 52.912 -15.1739 54.496 -15.1739C56.0801 -15.1739 57.3642 -14.0449 57.3642 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M5.73642 -27.7826C5.73642 -26.3899 4.45228 -25.2609 2.86821 -25.2609C1.28414 -25.2609 0 -26.3899 0 -27.7826C0 -29.1753 1.28414 -30.3043 2.86821 -30.3043C4.45228 -30.3043 5.73642 -29.1753 5.73642 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M57.3642 -27.7826C57.3642 -26.3899 56.0801 -25.2609 54.496 -25.2609C52.912 -25.2609 51.6278 -26.3899 51.6278 -27.7826C51.6278 -29.1753 52.912 -30.3043 54.496 -30.3043C56.0801 -30.3043 57.3642 -29.1753 57.3642 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M5.73642 2.47826C5.73642 3.87098 4.45228 5 2.86821 5C1.28414 5 0 3.87098 0 2.47826C0 1.08554 1.28414 -0.0434761 2.86821 -0.0434761C4.45228 -0.0434761 5.73642 1.08554 5.73642 2.47826Z"
        fill="#060606"
      />
      <path
        d="M57.3642 2.47826C57.3642 3.87098 56.0801 5 54.496 5C52.912 5 51.6278 3.87098 51.6278 2.47826C51.6278 1.08554 52.912 -0.0434761 54.496 -0.0434761C56.0801 -0.0434761 57.3642 1.08554 57.3642 2.47826Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -50.4783C22.9457 -49.0855 21.6616 -47.9565 20.0775 -47.9565C18.4934 -47.9565 17.2093 -49.0855 17.2093 -50.4783C17.2093 -51.871 18.4934 -53 20.0775 -53C21.6616 -53 22.9457 -51.871 22.9457 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -50.4783C74.5735 -49.0855 73.2894 -47.9565 71.7053 -47.9565C70.1212 -47.9565 68.8371 -49.0855 68.8371 -50.4783C68.8371 -51.871 70.1212 -53 71.7053 -53C73.2894 -53 74.5735 -51.871 74.5735 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -20.2174C22.9457 -18.8247 21.6616 -17.6957 20.0775 -17.6957C18.4934 -17.6957 17.2093 -18.8247 17.2093 -20.2174C17.2093 -21.6101 18.4934 -22.7391 20.0775 -22.7391C21.6616 -22.7391 22.9457 -21.6101 22.9457 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -20.2174C74.5735 -18.8247 73.2894 -17.6957 71.7053 -17.6957C70.1212 -17.6957 68.8371 -18.8247 68.8371 -20.2174C68.8371 -21.6101 70.1212 -22.7391 71.7053 -22.7391C73.2894 -22.7391 74.5735 -21.6101 74.5735 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -35.3478C22.9457 -33.9551 21.6616 -32.8261 20.0775 -32.8261C18.4934 -32.8261 17.2093 -33.9551 17.2093 -35.3478C17.2093 -36.7405 18.4934 -37.8696 20.0775 -37.8696C21.6616 -37.8696 22.9457 -36.7405 22.9457 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -35.3478C74.5735 -33.9551 73.2894 -32.8261 71.7053 -32.8261C70.1212 -32.8261 68.8371 -33.9551 68.8371 -35.3478C68.8371 -36.7405 70.1212 -37.8696 71.7053 -37.8696C73.2894 -37.8696 74.5735 -36.7405 74.5735 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -5.08696C22.9457 -3.69424 21.6616 -2.56522 20.0775 -2.56522C18.4934 -2.56522 17.2093 -3.69424 17.2093 -5.08696C17.2093 -6.47968 18.4934 -7.60869 20.0775 -7.60869C21.6616 -7.60869 22.9457 -6.47968 22.9457 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -5.08696C74.5735 -3.69424 73.2894 -2.56522 71.7053 -2.56522C70.1212 -2.56522 68.8371 -3.69424 68.8371 -5.08696C68.8371 -6.47968 70.1212 -7.60869 71.7053 -7.60869C73.2894 -7.60869 74.5735 -6.47968 74.5735 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -42.913C22.9457 -41.5203 21.6616 -40.3913 20.0775 -40.3913C18.4934 -40.3913 17.2093 -41.5203 17.2093 -42.913C17.2093 -44.3058 18.4934 -45.4348 20.0775 -45.4348C21.6616 -45.4348 22.9457 -44.3058 22.9457 -42.913Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -42.913C74.5735 -41.5203 73.2894 -40.3913 71.7053 -40.3913C70.1212 -40.3913 68.8371 -41.5203 68.8371 -42.913C68.8371 -44.3058 70.1212 -45.4348 71.7053 -45.4348C73.2894 -45.4348 74.5735 -44.3058 74.5735 -42.913Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -12.6522C22.9457 -11.2595 21.6616 -10.1304 20.0775 -10.1304C18.4934 -10.1304 17.2093 -11.2595 17.2093 -12.6522C17.2093 -14.0449 18.4934 -15.1739 20.0775 -15.1739C21.6616 -15.1739 22.9457 -14.0449 22.9457 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -12.6522C74.5735 -11.2595 73.2894 -10.1304 71.7053 -10.1304C70.1212 -10.1304 68.8371 -11.2595 68.8371 -12.6522C68.8371 -14.0449 70.1212 -15.1739 71.7053 -15.1739C73.2894 -15.1739 74.5735 -14.0449 74.5735 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M22.9457 -27.7826C22.9457 -26.3899 21.6616 -25.2609 20.0775 -25.2609C18.4934 -25.2609 17.2093 -26.3899 17.2093 -27.7826C17.2093 -29.1753 18.4934 -30.3043 20.0775 -30.3043C21.6616 -30.3043 22.9457 -29.1753 22.9457 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M74.5735 -27.7826C74.5735 -26.3899 73.2894 -25.2609 71.7053 -25.2609C70.1212 -25.2609 68.8371 -26.3899 68.8371 -27.7826C68.8371 -29.1753 70.1212 -30.3043 71.7053 -30.3043C73.2894 -30.3043 74.5735 -29.1753 74.5735 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M22.9457 2.47826C22.9457 3.87098 21.6616 5 20.0775 5C18.4934 5 17.2093 3.87098 17.2093 2.47826C17.2093 1.08554 18.4934 -0.0434761 20.0775 -0.0434761C21.6616 -0.0434761 22.9457 1.08554 22.9457 2.47826Z"
        fill="#060606"
      />
      <path
        d="M74.5735 2.47826C74.5735 3.87098 73.2894 5 71.7053 5C70.1212 5 68.8371 3.87098 68.8371 2.47826C68.8371 1.08554 70.1212 -0.0434761 71.7053 -0.0434761C73.2894 -0.0434761 74.5735 1.08554 74.5735 2.47826Z"
        fill="#060606"
      />
      <path
        d="M40.155 -50.4783C40.155 -49.0855 38.8708 -47.9565 37.2868 -47.9565C35.7027 -47.9565 34.4185 -49.0855 34.4185 -50.4783C34.4185 -51.871 35.7027 -53 37.2868 -53C38.8708 -53 40.155 -51.871 40.155 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -50.4783C91.7828 -49.0855 90.4986 -47.9565 88.9146 -47.9565C87.3305 -47.9565 86.0464 -49.0855 86.0464 -50.4783C86.0464 -51.871 87.3305 -53 88.9146 -53C90.4986 -53 91.7828 -51.871 91.7828 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M40.155 -20.2174C40.155 -18.8247 38.8708 -17.6957 37.2868 -17.6957C35.7027 -17.6957 34.4185 -18.8247 34.4185 -20.2174C34.4185 -21.6101 35.7027 -22.7391 37.2868 -22.7391C38.8708 -22.7391 40.155 -21.6101 40.155 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -20.2174C91.7828 -18.8247 90.4986 -17.6957 88.9146 -17.6957C87.3305 -17.6957 86.0464 -18.8247 86.0464 -20.2174C86.0464 -21.6101 87.3305 -22.7391 88.9146 -22.7391C90.4986 -22.7391 91.7828 -21.6101 91.7828 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M40.155 -35.3478C40.155 -33.9551 38.8708 -32.8261 37.2868 -32.8261C35.7027 -32.8261 34.4185 -33.9551 34.4185 -35.3478C34.4185 -36.7405 35.7027 -37.8696 37.2868 -37.8696C38.8708 -37.8696 40.155 -36.7405 40.155 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -35.3478C91.7828 -33.9551 90.4986 -32.8261 88.9146 -32.8261C87.3305 -32.8261 86.0464 -33.9551 86.0464 -35.3478C86.0464 -36.7405 87.3305 -37.8696 88.9146 -37.8696C90.4986 -37.8696 91.7828 -36.7405 91.7828 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M40.155 -5.08696C40.155 -3.69424 38.8708 -2.56522 37.2868 -2.56522C35.7027 -2.56522 34.4185 -3.69424 34.4185 -5.08696C34.4185 -6.47968 35.7027 -7.60869 37.2868 -7.60869C38.8708 -7.60869 40.155 -6.47968 40.155 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -5.08696C91.7828 -3.69424 90.4986 -2.56522 88.9146 -2.56522C87.3305 -2.56522 86.0464 -3.69424 86.0464 -5.08696C86.0464 -6.47968 87.3305 -7.60869 88.9146 -7.60869C90.4986 -7.60869 91.7828 -6.47968 91.7828 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M40.155 -42.913C40.155 -41.5203 38.8708 -40.3913 37.2868 -40.3913C35.7027 -40.3913 34.4185 -41.5203 34.4185 -42.913C34.4185 -44.3058 35.7027 -45.4348 37.2868 -45.4348C38.8708 -45.4348 40.155 -44.3058 40.155 -42.913Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -42.913C91.7828 -41.5203 90.4986 -40.3913 88.9146 -40.3913C87.3305 -40.3913 86.0464 -41.5203 86.0464 -42.913C86.0464 -44.3058 87.3305 -45.4348 88.9146 -45.4348C90.4986 -45.4348 91.7828 -44.3058 91.7828 -42.913Z"
        fill="#060606"
      />
      <path
        d="M40.155 -12.6522C40.155 -11.2595 38.8708 -10.1304 37.2868 -10.1304C35.7027 -10.1304 34.4185 -11.2595 34.4185 -12.6522C34.4185 -14.0449 35.7027 -15.1739 37.2868 -15.1739C38.8708 -15.1739 40.155 -14.0449 40.155 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -12.6522C91.7828 -11.2595 90.4986 -10.1304 88.9146 -10.1304C87.3305 -10.1304 86.0464 -11.2595 86.0464 -12.6522C86.0464 -14.0449 87.3305 -15.1739 88.9146 -15.1739C90.4986 -15.1739 91.7828 -14.0449 91.7828 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M40.155 -27.7826C40.155 -26.3899 38.8708 -25.2609 37.2868 -25.2609C35.7027 -25.2609 34.4185 -26.3899 34.4185 -27.7826C34.4185 -29.1753 35.7027 -30.3043 37.2868 -30.3043C38.8708 -30.3043 40.155 -29.1753 40.155 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M91.7828 -27.7826C91.7828 -26.3899 90.4986 -25.2609 88.9146 -25.2609C87.3305 -25.2609 86.0464 -26.3899 86.0464 -27.7826C86.0464 -29.1753 87.3305 -30.3043 88.9146 -30.3043C90.4986 -30.3043 91.7828 -29.1753 91.7828 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M40.155 2.47826C40.155 3.87098 38.8708 5 37.2868 5C35.7027 5 34.4185 3.87098 34.4185 2.47826C34.4185 1.08554 35.7027 -0.0434761 37.2868 -0.0434761C38.8708 -0.0434761 40.155 1.08554 40.155 2.47826Z"
        fill="#060606"
      />
      <path
        d="M91.7828 2.47826C91.7828 3.87098 90.4986 5 88.9146 5C87.3305 5 86.0464 3.87098 86.0464 2.47826C86.0464 1.08554 87.3305 -0.0434761 88.9146 -0.0434761C90.4986 -0.0434761 91.7828 1.08554 91.7828 2.47826Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -50.4783C14.3411 -49.0855 13.0569 -47.9565 11.4728 -47.9565C9.88878 -47.9565 8.60464 -49.0855 8.60464 -50.4783C8.60464 -51.871 9.88878 -53 11.4728 -53C13.0569 -53 14.3411 -51.871 14.3411 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -50.4783C65.9689 -49.0855 64.6847 -47.9565 63.1007 -47.9565C61.5166 -47.9565 60.2325 -49.0855 60.2325 -50.4783C60.2325 -51.871 61.5166 -53 63.1007 -53C64.6847 -53 65.9689 -51.871 65.9689 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -20.2174C14.3411 -18.8247 13.0569 -17.6957 11.4728 -17.6957C9.88878 -17.6957 8.60464 -18.8247 8.60464 -20.2174C8.60464 -21.6101 9.88878 -22.7391 11.4728 -22.7391C13.0569 -22.7391 14.3411 -21.6101 14.3411 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -20.2174C65.9689 -18.8247 64.6847 -17.6957 63.1007 -17.6957C61.5166 -17.6957 60.2325 -18.8247 60.2325 -20.2174C60.2325 -21.6101 61.5166 -22.7391 63.1007 -22.7391C64.6847 -22.7391 65.9689 -21.6101 65.9689 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -35.3478C14.3411 -33.9551 13.0569 -32.8261 11.4728 -32.8261C9.88878 -32.8261 8.60464 -33.9551 8.60464 -35.3478C8.60464 -36.7405 9.88878 -37.8696 11.4728 -37.8696C13.0569 -37.8696 14.3411 -36.7405 14.3411 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -35.3478C65.9689 -33.9551 64.6847 -32.8261 63.1007 -32.8261C61.5166 -32.8261 60.2325 -33.9551 60.2325 -35.3478C60.2325 -36.7405 61.5166 -37.8696 63.1007 -37.8696C64.6847 -37.8696 65.9689 -36.7405 65.9689 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -5.08696C14.3411 -3.69424 13.0569 -2.56522 11.4728 -2.56522C9.88878 -2.56522 8.60464 -3.69424 8.60464 -5.08696C8.60464 -6.47968 9.88878 -7.60869 11.4728 -7.60869C13.0569 -7.60869 14.3411 -6.47968 14.3411 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -5.08696C65.9689 -3.69424 64.6847 -2.56522 63.1007 -2.56522C61.5166 -2.56522 60.2325 -3.69424 60.2325 -5.08696C60.2325 -6.47968 61.5166 -7.60869 63.1007 -7.60869C64.6847 -7.60869 65.9689 -6.47968 65.9689 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -42.913C14.3411 -41.5203 13.0569 -40.3913 11.4728 -40.3913C9.88878 -40.3913 8.60464 -41.5203 8.60464 -42.913C8.60464 -44.3058 9.88878 -45.4348 11.4728 -45.4348C13.0569 -45.4348 14.3411 -44.3058 14.3411 -42.913Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -42.913C65.9689 -41.5203 64.6847 -40.3913 63.1007 -40.3913C61.5166 -40.3913 60.2325 -41.5203 60.2325 -42.913C60.2325 -44.3058 61.5166 -45.4348 63.1007 -45.4348C64.6847 -45.4348 65.9689 -44.3058 65.9689 -42.913Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -12.6522C14.3411 -11.2595 13.0569 -10.1304 11.4728 -10.1304C9.88878 -10.1304 8.60464 -11.2595 8.60464 -12.6522C8.60464 -14.0449 9.88878 -15.1739 11.4728 -15.1739C13.0569 -15.1739 14.3411 -14.0449 14.3411 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -12.6522C65.9689 -11.2595 64.6847 -10.1304 63.1007 -10.1304C61.5166 -10.1304 60.2325 -11.2595 60.2325 -12.6522C60.2325 -14.0449 61.5166 -15.1739 63.1007 -15.1739C64.6847 -15.1739 65.9689 -14.0449 65.9689 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M14.3411 -27.7826C14.3411 -26.3899 13.0569 -25.2609 11.4728 -25.2609C9.88878 -25.2609 8.60464 -26.3899 8.60464 -27.7826C8.60464 -29.1753 9.88878 -30.3043 11.4728 -30.3043C13.0569 -30.3043 14.3411 -29.1753 14.3411 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M65.9689 -27.7826C65.9689 -26.3899 64.6847 -25.2609 63.1007 -25.2609C61.5166 -25.2609 60.2325 -26.3899 60.2325 -27.7826C60.2325 -29.1753 61.5166 -30.3043 63.1007 -30.3043C64.6847 -30.3043 65.9689 -29.1753 65.9689 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M14.3411 2.47826C14.3411 3.87098 13.0569 5 11.4728 5C9.88878 5 8.60464 3.87098 8.60464 2.47826C8.60464 1.08554 9.88878 -0.0434761 11.4728 -0.0434761C13.0569 -0.0434761 14.3411 1.08554 14.3411 2.47826Z"
        fill="#060606"
      />
      <path
        d="M65.9689 2.47826C65.9689 3.87098 64.6847 5 63.1007 5C61.5166 5 60.2325 3.87098 60.2325 2.47826C60.2325 1.08554 61.5166 -0.0434761 63.1007 -0.0434761C64.6847 -0.0434761 65.9689 1.08554 65.9689 2.47826Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -50.4783C31.5503 -49.0855 30.2662 -47.9565 28.6821 -47.9565C27.0981 -47.9565 25.8139 -49.0855 25.8139 -50.4783C25.8139 -51.871 27.0981 -53 28.6821 -53C30.2662 -53 31.5503 -51.871 31.5503 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -50.4783C83.1782 -49.0855 81.894 -47.9565 80.3099 -47.9565C78.7259 -47.9565 77.4417 -49.0855 77.4417 -50.4783C77.4417 -51.871 78.7259 -53 80.3099 -53C81.894 -53 83.1782 -51.871 83.1782 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -20.2174C31.5503 -18.8247 30.2662 -17.6957 28.6821 -17.6957C27.0981 -17.6957 25.8139 -18.8247 25.8139 -20.2174C25.8139 -21.6101 27.0981 -22.7391 28.6821 -22.7391C30.2662 -22.7391 31.5503 -21.6101 31.5503 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -20.2174C83.1782 -18.8247 81.894 -17.6957 80.3099 -17.6957C78.7259 -17.6957 77.4417 -18.8247 77.4417 -20.2174C77.4417 -21.6101 78.7259 -22.7391 80.3099 -22.7391C81.894 -22.7391 83.1782 -21.6101 83.1782 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -35.3478C31.5503 -33.9551 30.2662 -32.8261 28.6821 -32.8261C27.0981 -32.8261 25.8139 -33.9551 25.8139 -35.3478C25.8139 -36.7405 27.0981 -37.8696 28.6821 -37.8696C30.2662 -37.8696 31.5503 -36.7405 31.5503 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -35.3478C83.1782 -33.9551 81.894 -32.8261 80.3099 -32.8261C78.7259 -32.8261 77.4417 -33.9551 77.4417 -35.3478C77.4417 -36.7405 78.7259 -37.8696 80.3099 -37.8696C81.894 -37.8696 83.1782 -36.7405 83.1782 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -5.08696C31.5503 -3.69424 30.2662 -2.56522 28.6821 -2.56522C27.0981 -2.56522 25.8139 -3.69424 25.8139 -5.08696C25.8139 -6.47968 27.0981 -7.60869 28.6821 -7.60869C30.2662 -7.60869 31.5503 -6.47968 31.5503 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -5.08696C83.1782 -3.69424 81.894 -2.56522 80.3099 -2.56522C78.7259 -2.56522 77.4417 -3.69424 77.4417 -5.08696C77.4417 -6.47968 78.7259 -7.60869 80.3099 -7.60869C81.894 -7.60869 83.1782 -6.47968 83.1782 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -42.913C31.5503 -41.5203 30.2662 -40.3913 28.6821 -40.3913C27.0981 -40.3913 25.8139 -41.5203 25.8139 -42.913C25.8139 -44.3058 27.0981 -45.4348 28.6821 -45.4348C30.2662 -45.4348 31.5503 -44.3058 31.5503 -42.913Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -42.913C83.1782 -41.5203 81.894 -40.3913 80.3099 -40.3913C78.7259 -40.3913 77.4417 -41.5203 77.4417 -42.913C77.4417 -44.3058 78.7259 -45.4348 80.3099 -45.4348C81.894 -45.4348 83.1782 -44.3058 83.1782 -42.913Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -12.6522C31.5503 -11.2595 30.2662 -10.1304 28.6821 -10.1304C27.0981 -10.1304 25.8139 -11.2595 25.8139 -12.6522C25.8139 -14.0449 27.0981 -15.1739 28.6821 -15.1739C30.2662 -15.1739 31.5503 -14.0449 31.5503 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -12.6522C83.1782 -11.2595 81.894 -10.1304 80.3099 -10.1304C78.7259 -10.1304 77.4417 -11.2595 77.4417 -12.6522C77.4417 -14.0449 78.7259 -15.1739 80.3099 -15.1739C81.894 -15.1739 83.1782 -14.0449 83.1782 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M31.5503 -27.7826C31.5503 -26.3899 30.2662 -25.2609 28.6821 -25.2609C27.0981 -25.2609 25.8139 -26.3899 25.8139 -27.7826C25.8139 -29.1753 27.0981 -30.3043 28.6821 -30.3043C30.2662 -30.3043 31.5503 -29.1753 31.5503 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M83.1782 -27.7826C83.1782 -26.3899 81.894 -25.2609 80.3099 -25.2609C78.7259 -25.2609 77.4417 -26.3899 77.4417 -27.7826C77.4417 -29.1753 78.7259 -30.3043 80.3099 -30.3043C81.894 -30.3043 83.1782 -29.1753 83.1782 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M31.5503 2.47826C31.5503 3.87098 30.2662 5 28.6821 5C27.0981 5 25.8139 3.87098 25.8139 2.47826C25.8139 1.08554 27.0981 -0.0434761 28.6821 -0.0434761C30.2662 -0.0434761 31.5503 1.08554 31.5503 2.47826Z"
        fill="#060606"
      />
      <path
        d="M83.1782 2.47826C83.1782 3.87098 81.894 5 80.3099 5C78.7259 5 77.4417 3.87098 77.4417 2.47826C77.4417 1.08554 78.7259 -0.0434761 80.3099 -0.0434761C81.894 -0.0434761 83.1782 1.08554 83.1782 2.47826Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -50.4783C48.7596 -49.0855 47.4755 -47.9565 45.8914 -47.9565C44.3073 -47.9565 43.0232 -49.0855 43.0232 -50.4783C43.0232 -51.871 44.3073 -53 45.8914 -53C47.4755 -53 48.7596 -51.871 48.7596 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M100.387 -50.4783C100.387 -49.0855 99.1033 -47.9565 97.5192 -47.9565C95.9351 -47.9565 94.651 -49.0855 94.651 -50.4783C94.651 -51.871 95.9351 -53 97.5192 -53C99.1033 -53 100.387 -51.871 100.387 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -20.2174C48.7596 -18.8247 47.4755 -17.6957 45.8914 -17.6957C44.3073 -17.6957 43.0232 -18.8247 43.0232 -20.2174C43.0232 -21.6101 44.3073 -22.7391 45.8914 -22.7391C47.4755 -22.7391 48.7596 -21.6101 48.7596 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M100.387 -20.2174C100.387 -18.8247 99.1033 -17.6957 97.5192 -17.6957C95.9351 -17.6957 94.651 -18.8247 94.651 -20.2174C94.651 -21.6101 95.9351 -22.7391 97.5192 -22.7391C99.1033 -22.7391 100.387 -21.6101 100.387 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -35.3478C48.7596 -33.9551 47.4755 -32.8261 45.8914 -32.8261C44.3073 -32.8261 43.0232 -33.9551 43.0232 -35.3478C43.0232 -36.7405 44.3073 -37.8696 45.8914 -37.8696C47.4755 -37.8696 48.7596 -36.7405 48.7596 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M100.387 -35.3478C100.387 -33.9551 99.1033 -32.8261 97.5192 -32.8261C95.9351 -32.8261 94.651 -33.9551 94.651 -35.3478C94.651 -36.7405 95.9351 -37.8696 97.5192 -37.8696C99.1033 -37.8696 100.387 -36.7405 100.387 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -5.08696C48.7596 -3.69424 47.4755 -2.56522 45.8914 -2.56522C44.3073 -2.56522 43.0232 -3.69424 43.0232 -5.08696C43.0232 -6.47968 44.3073 -7.60869 45.8914 -7.60869C47.4755 -7.60869 48.7596 -6.47968 48.7596 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M100.387 -5.08696C100.387 -3.69424 99.1033 -2.56522 97.5192 -2.56522C95.9351 -2.56522 94.651 -3.69424 94.651 -5.08696C94.651 -6.47968 95.9351 -7.60869 97.5192 -7.60869C99.1033 -7.60869 100.387 -6.47968 100.387 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -42.913C48.7596 -41.5203 47.4755 -40.3913 45.8914 -40.3913C44.3073 -40.3913 43.0232 -41.5203 43.0232 -42.913C43.0232 -44.3058 44.3073 -45.4348 45.8914 -45.4348C47.4755 -45.4348 48.7596 -44.3058 48.7596 -42.913Z"
        fill="#060606"
      />
      <path
        d="M100.387 -42.913C100.387 -41.5203 99.1033 -40.3913 97.5192 -40.3913C95.9351 -40.3913 94.651 -41.5203 94.651 -42.913C94.651 -44.3058 95.9351 -45.4348 97.5192 -45.4348C99.1033 -45.4348 100.387 -44.3058 100.387 -42.913Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -12.6522C48.7596 -11.2595 47.4755 -10.1304 45.8914 -10.1304C44.3073 -10.1304 43.0232 -11.2595 43.0232 -12.6522C43.0232 -14.0449 44.3073 -15.1739 45.8914 -15.1739C47.4755 -15.1739 48.7596 -14.0449 48.7596 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M100.387 -12.6522C100.387 -11.2595 99.1033 -10.1304 97.5192 -10.1304C95.9351 -10.1304 94.651 -11.2595 94.651 -12.6522C94.651 -14.0449 95.9351 -15.1739 97.5192 -15.1739C99.1033 -15.1739 100.387 -14.0449 100.387 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M48.7596 -27.7826C48.7596 -26.3899 47.4755 -25.2609 45.8914 -25.2609C44.3073 -25.2609 43.0232 -26.3899 43.0232 -27.7826C43.0232 -29.1753 44.3073 -30.3043 45.8914 -30.3043C47.4755 -30.3043 48.7596 -29.1753 48.7596 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M100.387 -27.7826C100.387 -26.3899 99.1033 -25.2609 97.5192 -25.2609C95.9351 -25.2609 94.651 -26.3899 94.651 -27.7826C94.651 -29.1753 95.9351 -30.3043 97.5192 -30.3043C99.1033 -30.3043 100.387 -29.1753 100.387 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M48.7596 2.47826C48.7596 3.87098 47.4755 5 45.8914 5C44.3073 5 43.0232 3.87098 43.0232 2.47826C43.0232 1.08554 44.3073 -0.0434761 45.8914 -0.0434761C47.4755 -0.0434761 48.7596 1.08554 48.7596 2.47826Z"
        fill="#060606"
      />
      <path
        d="M100.387 2.47826C100.387 3.87098 99.1033 5 97.5192 5C95.9351 5 94.651 3.87098 94.651 2.47826C94.651 1.08554 95.9351 -0.0434761 97.5192 -0.0434761C99.1033 -0.0434761 100.387 1.08554 100.387 2.47826Z"
        fill="#060606"
      />
      <path
        d="M5.73642 69.5217C5.73642 70.9145 4.45228 72.0435 2.86821 72.0435C1.28414 72.0435 0 70.9145 0 69.5217C0 68.129 1.28414 67 2.86821 67C4.45228 67 5.73642 68.129 5.73642 69.5217Z"
        fill="#060606"
      />
      <path
        d="M57.3642 69.5217C57.3642 70.9145 56.0801 72.0435 54.496 72.0435C52.912 72.0435 51.6278 70.9145 51.6278 69.5217C51.6278 68.129 52.912 67 54.496 67C56.0801 67 57.3642 68.129 57.3642 69.5217Z"
        fill="#060606"
      />
      <path
        d="M5.73642 99.7826C5.73642 101.175 4.45228 102.304 2.86821 102.304C1.28414 102.304 0 101.175 0 99.7826C0 98.3899 1.28414 97.2609 2.86821 97.2609C4.45228 97.2609 5.73642 98.3899 5.73642 99.7826Z"
        fill="#060606"
      />
      <path
        d="M57.3642 99.7826C57.3642 101.175 56.0801 102.304 54.496 102.304C52.912 102.304 51.6278 101.175 51.6278 99.7826C51.6278 98.3899 52.912 97.2609 54.496 97.2609C56.0801 97.2609 57.3642 98.3899 57.3642 99.7826Z"
        fill="#060606"
      />
      <path
        d="M5.73642 84.6522C5.73642 86.0449 4.45228 87.1739 2.86821 87.1739C1.28414 87.1739 0 86.0449 0 84.6522C0 83.2595 1.28414 82.1304 2.86821 82.1304C4.45228 82.1304 5.73642 83.2595 5.73642 84.6522Z"
        fill="#060606"
      />
      <path
        d="M57.3642 84.6522C57.3642 86.0449 56.0801 87.1739 54.496 87.1739C52.912 87.1739 51.6278 86.0449 51.6278 84.6522C51.6278 83.2595 52.912 82.1304 54.496 82.1304C56.0801 82.1304 57.3642 83.2595 57.3642 84.6522Z"
        fill="#060606"
      />
      <path
        d="M5.73642 114.913C5.73642 116.306 4.45228 117.435 2.86821 117.435C1.28414 117.435 0 116.306 0 114.913C0 113.52 1.28414 112.391 2.86821 112.391C4.45228 112.391 5.73642 113.52 5.73642 114.913Z"
        fill="#060606"
      />
      <path
        d="M57.3642 114.913C57.3642 116.306 56.0801 117.435 54.496 117.435C52.912 117.435 51.6278 116.306 51.6278 114.913C51.6278 113.52 52.912 112.391 54.496 112.391C56.0801 112.391 57.3642 113.52 57.3642 114.913Z"
        fill="#060606"
      />
      <path
        d="M5.73642 77.087C5.73642 78.4797 4.45228 79.6087 2.86821 79.6087C1.28414 79.6087 0 78.4797 0 77.087C0 75.6942 1.28414 74.5652 2.86821 74.5652C4.45228 74.5652 5.73642 75.6942 5.73642 77.087Z"
        fill="#060606"
      />
      <path
        d="M57.3642 77.087C57.3642 78.4797 56.0801 79.6087 54.496 79.6087C52.912 79.6087 51.6278 78.4797 51.6278 77.087C51.6278 75.6942 52.912 74.5652 54.496 74.5652C56.0801 74.5652 57.3642 75.6942 57.3642 77.087Z"
        fill="#060606"
      />
      <path
        d="M5.73642 107.348C5.73642 108.741 4.45228 109.87 2.86821 109.87C1.28414 109.87 0 108.741 0 107.348C0 105.955 1.28414 104.826 2.86821 104.826C4.45228 104.826 5.73642 105.955 5.73642 107.348Z"
        fill="#060606"
      />
      <path
        d="M57.3642 107.348C57.3642 108.741 56.0801 109.87 54.496 109.87C52.912 109.87 51.6278 108.741 51.6278 107.348C51.6278 105.955 52.912 104.826 54.496 104.826C56.0801 104.826 57.3642 105.955 57.3642 107.348Z"
        fill="#060606"
      />
      <path
        d="M5.73642 92.2174C5.73642 93.6101 4.45228 94.7391 2.86821 94.7391C1.28414 94.7391 0 93.6101 0 92.2174C0 90.8247 1.28414 89.6956 2.86821 89.6956C4.45228 89.6956 5.73642 90.8247 5.73642 92.2174Z"
        fill="#060606"
      />
      <path
        d="M57.3642 92.2174C57.3642 93.6101 56.0801 94.7391 54.496 94.7391C52.912 94.7391 51.6278 93.6101 51.6278 92.2174C51.6278 90.8247 52.912 89.6956 54.496 89.6956C56.0801 89.6956 57.3642 90.8247 57.3642 92.2174Z"
        fill="#060606"
      />
      <path
        d="M5.73642 122.478C5.73642 123.871 4.45228 125 2.86821 125C1.28414 125 0 123.871 0 122.478C0 121.086 1.28414 119.957 2.86821 119.957C4.45228 119.957 5.73642 121.086 5.73642 122.478Z"
        fill="#060606"
      />
      <path
        d="M57.3642 122.478C57.3642 123.871 56.0801 125 54.496 125C52.912 125 51.6278 123.871 51.6278 122.478C51.6278 121.086 52.912 119.957 54.496 119.957C56.0801 119.957 57.3642 121.086 57.3642 122.478Z"
        fill="#060606"
      />
      <path
        d="M22.9457 69.5217C22.9457 70.9145 21.6616 72.0435 20.0775 72.0435C18.4934 72.0435 17.2093 70.9145 17.2093 69.5217C17.2093 68.129 18.4934 67 20.0775 67C21.6616 67 22.9457 68.129 22.9457 69.5217Z"
        fill="#060606"
      />
      <path
        d="M74.5735 69.5217C74.5735 70.9145 73.2894 72.0435 71.7053 72.0435C70.1212 72.0435 68.8371 70.9145 68.8371 69.5217C68.8371 68.129 70.1212 67 71.7053 67C73.2894 67 74.5735 68.129 74.5735 69.5217Z"
        fill="#060606"
      />
      <path
        d="M22.9457 99.7826C22.9457 101.175 21.6616 102.304 20.0775 102.304C18.4934 102.304 17.2093 101.175 17.2093 99.7826C17.2093 98.3899 18.4934 97.2609 20.0775 97.2609C21.6616 97.2609 22.9457 98.3899 22.9457 99.7826Z"
        fill="#060606"
      />
      <path
        d="M74.5735 99.7826C74.5735 101.175 73.2894 102.304 71.7053 102.304C70.1212 102.304 68.8371 101.175 68.8371 99.7826C68.8371 98.3899 70.1212 97.2609 71.7053 97.2609C73.2894 97.2609 74.5735 98.3899 74.5735 99.7826Z"
        fill="#060606"
      />
      <path
        d="M22.9457 84.6522C22.9457 86.0449 21.6616 87.1739 20.0775 87.1739C18.4934 87.1739 17.2093 86.0449 17.2093 84.6522C17.2093 83.2595 18.4934 82.1304 20.0775 82.1304C21.6616 82.1304 22.9457 83.2595 22.9457 84.6522Z"
        fill="#060606"
      />
      <path
        d="M74.5735 84.6522C74.5735 86.0449 73.2894 87.1739 71.7053 87.1739C70.1212 87.1739 68.8371 86.0449 68.8371 84.6522C68.8371 83.2595 70.1212 82.1304 71.7053 82.1304C73.2894 82.1304 74.5735 83.2595 74.5735 84.6522Z"
        fill="#060606"
      />
      <path
        d="M22.9457 114.913C22.9457 116.306 21.6616 117.435 20.0775 117.435C18.4934 117.435 17.2093 116.306 17.2093 114.913C17.2093 113.52 18.4934 112.391 20.0775 112.391C21.6616 112.391 22.9457 113.52 22.9457 114.913Z"
        fill="#060606"
      />
      <path
        d="M74.5735 114.913C74.5735 116.306 73.2894 117.435 71.7053 117.435C70.1212 117.435 68.8371 116.306 68.8371 114.913C68.8371 113.52 70.1212 112.391 71.7053 112.391C73.2894 112.391 74.5735 113.52 74.5735 114.913Z"
        fill="#060606"
      />
      <path
        d="M22.9457 77.087C22.9457 78.4797 21.6616 79.6087 20.0775 79.6087C18.4934 79.6087 17.2093 78.4797 17.2093 77.087C17.2093 75.6942 18.4934 74.5652 20.0775 74.5652C21.6616 74.5652 22.9457 75.6942 22.9457 77.087Z"
        fill="#060606"
      />
      <path
        d="M74.5735 77.087C74.5735 78.4797 73.2894 79.6087 71.7053 79.6087C70.1212 79.6087 68.8371 78.4797 68.8371 77.087C68.8371 75.6942 70.1212 74.5652 71.7053 74.5652C73.2894 74.5652 74.5735 75.6942 74.5735 77.087Z"
        fill="#060606"
      />
      <path
        d="M22.9457 107.348C22.9457 108.741 21.6616 109.87 20.0775 109.87C18.4934 109.87 17.2093 108.741 17.2093 107.348C17.2093 105.955 18.4934 104.826 20.0775 104.826C21.6616 104.826 22.9457 105.955 22.9457 107.348Z"
        fill="#060606"
      />
      <path
        d="M74.5735 107.348C74.5735 108.741 73.2894 109.87 71.7053 109.87C70.1212 109.87 68.8371 108.741 68.8371 107.348C68.8371 105.955 70.1212 104.826 71.7053 104.826C73.2894 104.826 74.5735 105.955 74.5735 107.348Z"
        fill="#060606"
      />
      <path
        d="M22.9457 92.2174C22.9457 93.6101 21.6616 94.7391 20.0775 94.7391C18.4934 94.7391 17.2093 93.6101 17.2093 92.2174C17.2093 90.8247 18.4934 89.6956 20.0775 89.6956C21.6616 89.6956 22.9457 90.8247 22.9457 92.2174Z"
        fill="#060606"
      />
      <path
        d="M74.5735 92.2174C74.5735 93.6101 73.2894 94.7391 71.7053 94.7391C70.1212 94.7391 68.8371 93.6101 68.8371 92.2174C68.8371 90.8247 70.1212 89.6956 71.7053 89.6956C73.2894 89.6956 74.5735 90.8247 74.5735 92.2174Z"
        fill="#060606"
      />
      <path
        d="M22.9457 122.478C22.9457 123.871 21.6616 125 20.0775 125C18.4934 125 17.2093 123.871 17.2093 122.478C17.2093 121.086 18.4934 119.957 20.0775 119.957C21.6616 119.957 22.9457 121.086 22.9457 122.478Z"
        fill="#060606"
      />
      <path
        d="M74.5735 122.478C74.5735 123.871 73.2894 125 71.7053 125C70.1212 125 68.8371 123.871 68.8371 122.478C68.8371 121.086 70.1212 119.957 71.7053 119.957C73.2894 119.957 74.5735 121.086 74.5735 122.478Z"
        fill="#060606"
      />
      <path
        d="M40.155 69.5217C40.155 70.9145 38.8708 72.0435 37.2868 72.0435C35.7027 72.0435 34.4185 70.9145 34.4185 69.5217C34.4185 68.129 35.7027 67 37.2868 67C38.8708 67 40.155 68.129 40.155 69.5217Z"
        fill="#060606"
      />
      <path
        d="M91.7828 69.5217C91.7828 70.9145 90.4986 72.0435 88.9146 72.0435C87.3305 72.0435 86.0464 70.9145 86.0464 69.5217C86.0464 68.129 87.3305 67 88.9146 67C90.4986 67 91.7828 68.129 91.7828 69.5217Z"
        fill="#060606"
      />
      <path
        d="M40.155 99.7826C40.155 101.175 38.8708 102.304 37.2868 102.304C35.7027 102.304 34.4185 101.175 34.4185 99.7826C34.4185 98.3899 35.7027 97.2609 37.2868 97.2609C38.8708 97.2609 40.155 98.3899 40.155 99.7826Z"
        fill="#060606"
      />
      <path
        d="M91.7828 99.7826C91.7828 101.175 90.4986 102.304 88.9146 102.304C87.3305 102.304 86.0464 101.175 86.0464 99.7826C86.0464 98.3899 87.3305 97.2609 88.9146 97.2609C90.4986 97.2609 91.7828 98.3899 91.7828 99.7826Z"
        fill="#060606"
      />
      <path
        d="M40.155 84.6522C40.155 86.0449 38.8708 87.1739 37.2868 87.1739C35.7027 87.1739 34.4185 86.0449 34.4185 84.6522C34.4185 83.2595 35.7027 82.1304 37.2868 82.1304C38.8708 82.1304 40.155 83.2595 40.155 84.6522Z"
        fill="#060606"
      />
      <path
        d="M91.7828 84.6522C91.7828 86.0449 90.4986 87.1739 88.9146 87.1739C87.3305 87.1739 86.0464 86.0449 86.0464 84.6522C86.0464 83.2595 87.3305 82.1304 88.9146 82.1304C90.4986 82.1304 91.7828 83.2595 91.7828 84.6522Z"
        fill="#060606"
      />
      <path
        d="M40.155 114.913C40.155 116.306 38.8708 117.435 37.2868 117.435C35.7027 117.435 34.4185 116.306 34.4185 114.913C34.4185 113.52 35.7027 112.391 37.2868 112.391C38.8708 112.391 40.155 113.52 40.155 114.913Z"
        fill="#060606"
      />
      <path
        d="M91.7828 114.913C91.7828 116.306 90.4986 117.435 88.9146 117.435C87.3305 117.435 86.0464 116.306 86.0464 114.913C86.0464 113.52 87.3305 112.391 88.9146 112.391C90.4986 112.391 91.7828 113.52 91.7828 114.913Z"
        fill="#060606"
      />
      <path
        d="M40.155 77.087C40.155 78.4797 38.8708 79.6087 37.2868 79.6087C35.7027 79.6087 34.4185 78.4797 34.4185 77.087C34.4185 75.6942 35.7027 74.5652 37.2868 74.5652C38.8708 74.5652 40.155 75.6942 40.155 77.087Z"
        fill="#060606"
      />
      <path
        d="M91.7828 77.087C91.7828 78.4797 90.4986 79.6087 88.9146 79.6087C87.3305 79.6087 86.0464 78.4797 86.0464 77.087C86.0464 75.6942 87.3305 74.5652 88.9146 74.5652C90.4986 74.5652 91.7828 75.6942 91.7828 77.087Z"
        fill="#060606"
      />
      <path
        d="M40.155 107.348C40.155 108.741 38.8708 109.87 37.2868 109.87C35.7027 109.87 34.4185 108.741 34.4185 107.348C34.4185 105.955 35.7027 104.826 37.2868 104.826C38.8708 104.826 40.155 105.955 40.155 107.348Z"
        fill="#060606"
      />
      <path
        d="M91.7828 107.348C91.7828 108.741 90.4986 109.87 88.9146 109.87C87.3305 109.87 86.0464 108.741 86.0464 107.348C86.0464 105.955 87.3305 104.826 88.9146 104.826C90.4986 104.826 91.7828 105.955 91.7828 107.348Z"
        fill="#060606"
      />
      <path
        d="M40.155 92.2174C40.155 93.6101 38.8708 94.7391 37.2868 94.7391C35.7027 94.7391 34.4185 93.6101 34.4185 92.2174C34.4185 90.8247 35.7027 89.6956 37.2868 89.6956C38.8708 89.6956 40.155 90.8247 40.155 92.2174Z"
        fill="#060606"
      />
      <path
        d="M91.7828 92.2174C91.7828 93.6101 90.4986 94.7391 88.9146 94.7391C87.3305 94.7391 86.0464 93.6101 86.0464 92.2174C86.0464 90.8247 87.3305 89.6956 88.9146 89.6956C90.4986 89.6956 91.7828 90.8247 91.7828 92.2174Z"
        fill="#060606"
      />
      <path
        d="M40.155 122.478C40.155 123.871 38.8708 125 37.2868 125C35.7027 125 34.4185 123.871 34.4185 122.478C34.4185 121.086 35.7027 119.957 37.2868 119.957C38.8708 119.957 40.155 121.086 40.155 122.478Z"
        fill="#060606"
      />
      <path
        d="M91.7828 122.478C91.7828 123.871 90.4986 125 88.9146 125C87.3305 125 86.0464 123.871 86.0464 122.478C86.0464 121.086 87.3305 119.957 88.9146 119.957C90.4986 119.957 91.7828 121.086 91.7828 122.478Z"
        fill="#060606"
      />
      <path
        d="M14.3411 69.5217C14.3411 70.9145 13.0569 72.0435 11.4728 72.0435C9.88878 72.0435 8.60464 70.9145 8.60464 69.5217C8.60464 68.129 9.88878 67 11.4728 67C13.0569 67 14.3411 68.129 14.3411 69.5217Z"
        fill="#060606"
      />
      <path
        d="M65.9689 69.5217C65.9689 70.9145 64.6847 72.0435 63.1007 72.0435C61.5166 72.0435 60.2325 70.9145 60.2325 69.5217C60.2325 68.129 61.5166 67 63.1007 67C64.6847 67 65.9689 68.129 65.9689 69.5217Z"
        fill="#060606"
      />
      <path
        d="M14.3411 99.7826C14.3411 101.175 13.0569 102.304 11.4728 102.304C9.88878 102.304 8.60464 101.175 8.60464 99.7826C8.60464 98.3899 9.88878 97.2609 11.4728 97.2609C13.0569 97.2609 14.3411 98.3899 14.3411 99.7826Z"
        fill="#060606"
      />
      <path
        d="M65.9689 99.7826C65.9689 101.175 64.6847 102.304 63.1007 102.304C61.5166 102.304 60.2325 101.175 60.2325 99.7826C60.2325 98.3899 61.5166 97.2609 63.1007 97.2609C64.6847 97.2609 65.9689 98.3899 65.9689 99.7826Z"
        fill="#060606"
      />
      <path
        d="M14.3411 84.6522C14.3411 86.0449 13.0569 87.1739 11.4728 87.1739C9.88878 87.1739 8.60464 86.0449 8.60464 84.6522C8.60464 83.2595 9.88878 82.1304 11.4728 82.1304C13.0569 82.1304 14.3411 83.2595 14.3411 84.6522Z"
        fill="#060606"
      />
      <path
        d="M65.9689 84.6522C65.9689 86.0449 64.6847 87.1739 63.1007 87.1739C61.5166 87.1739 60.2325 86.0449 60.2325 84.6522C60.2325 83.2595 61.5166 82.1304 63.1007 82.1304C64.6847 82.1304 65.9689 83.2595 65.9689 84.6522Z"
        fill="#060606"
      />
      <path
        d="M14.3411 114.913C14.3411 116.306 13.0569 117.435 11.4728 117.435C9.88878 117.435 8.60464 116.306 8.60464 114.913C8.60464 113.52 9.88878 112.391 11.4728 112.391C13.0569 112.391 14.3411 113.52 14.3411 114.913Z"
        fill="#060606"
      />
      <path
        d="M65.9689 114.913C65.9689 116.306 64.6847 117.435 63.1007 117.435C61.5166 117.435 60.2325 116.306 60.2325 114.913C60.2325 113.52 61.5166 112.391 63.1007 112.391C64.6847 112.391 65.9689 113.52 65.9689 114.913Z"
        fill="#060606"
      />
      <path
        d="M14.3411 77.087C14.3411 78.4797 13.0569 79.6087 11.4728 79.6087C9.88878 79.6087 8.60464 78.4797 8.60464 77.087C8.60464 75.6942 9.88878 74.5652 11.4728 74.5652C13.0569 74.5652 14.3411 75.6942 14.3411 77.087Z"
        fill="#060606"
      />
      <path
        d="M65.9689 77.087C65.9689 78.4797 64.6847 79.6087 63.1007 79.6087C61.5166 79.6087 60.2325 78.4797 60.2325 77.087C60.2325 75.6942 61.5166 74.5652 63.1007 74.5652C64.6847 74.5652 65.9689 75.6942 65.9689 77.087Z"
        fill="#060606"
      />
      <path
        d="M14.3411 107.348C14.3411 108.741 13.0569 109.87 11.4728 109.87C9.88878 109.87 8.60464 108.741 8.60464 107.348C8.60464 105.955 9.88878 104.826 11.4728 104.826C13.0569 104.826 14.3411 105.955 14.3411 107.348Z"
        fill="#060606"
      />
      <path
        d="M65.9689 107.348C65.9689 108.741 64.6847 109.87 63.1007 109.87C61.5166 109.87 60.2325 108.741 60.2325 107.348C60.2325 105.955 61.5166 104.826 63.1007 104.826C64.6847 104.826 65.9689 105.955 65.9689 107.348Z"
        fill="#060606"
      />
      <path
        d="M14.3411 92.2174C14.3411 93.6101 13.0569 94.7391 11.4728 94.7391C9.88878 94.7391 8.60464 93.6101 8.60464 92.2174C8.60464 90.8247 9.88878 89.6956 11.4728 89.6956C13.0569 89.6956 14.3411 90.8247 14.3411 92.2174Z"
        fill="#060606"
      />
      <path
        d="M65.9689 92.2174C65.9689 93.6101 64.6847 94.7391 63.1007 94.7391C61.5166 94.7391 60.2325 93.6101 60.2325 92.2174C60.2325 90.8247 61.5166 89.6956 63.1007 89.6956C64.6847 89.6956 65.9689 90.8247 65.9689 92.2174Z"
        fill="#060606"
      />
      <path
        d="M14.3411 122.478C14.3411 123.871 13.0569 125 11.4728 125C9.88878 125 8.60464 123.871 8.60464 122.478C8.60464 121.086 9.88878 119.957 11.4728 119.957C13.0569 119.957 14.3411 121.086 14.3411 122.478Z"
        fill="#060606"
      />
      <path
        d="M65.9689 122.478C65.9689 123.871 64.6847 125 63.1007 125C61.5166 125 60.2325 123.871 60.2325 122.478C60.2325 121.086 61.5166 119.957 63.1007 119.957C64.6847 119.957 65.9689 121.086 65.9689 122.478Z"
        fill="#060606"
      />
      <path
        d="M31.5503 69.5217C31.5503 70.9145 30.2662 72.0435 28.6821 72.0435C27.0981 72.0435 25.8139 70.9145 25.8139 69.5217C25.8139 68.129 27.0981 67 28.6821 67C30.2662 67 31.5503 68.129 31.5503 69.5217Z"
        fill="#060606"
      />
      <path
        d="M83.1782 69.5217C83.1782 70.9145 81.894 72.0435 80.3099 72.0435C78.7259 72.0435 77.4417 70.9145 77.4417 69.5217C77.4417 68.129 78.7259 67 80.3099 67C81.894 67 83.1782 68.129 83.1782 69.5217Z"
        fill="#060606"
      />
      <path
        d="M31.5503 99.7826C31.5503 101.175 30.2662 102.304 28.6821 102.304C27.0981 102.304 25.8139 101.175 25.8139 99.7826C25.8139 98.3899 27.0981 97.2609 28.6821 97.2609C30.2662 97.2609 31.5503 98.3899 31.5503 99.7826Z"
        fill="#060606"
      />
      <path
        d="M83.1782 99.7826C83.1782 101.175 81.894 102.304 80.3099 102.304C78.7259 102.304 77.4417 101.175 77.4417 99.7826C77.4417 98.3899 78.7259 97.2609 80.3099 97.2609C81.894 97.2609 83.1782 98.3899 83.1782 99.7826Z"
        fill="#060606"
      />
      <path
        d="M31.5503 84.6522C31.5503 86.0449 30.2662 87.1739 28.6821 87.1739C27.0981 87.1739 25.8139 86.0449 25.8139 84.6522C25.8139 83.2595 27.0981 82.1304 28.6821 82.1304C30.2662 82.1304 31.5503 83.2595 31.5503 84.6522Z"
        fill="#060606"
      />
      <path
        d="M83.1782 84.6522C83.1782 86.0449 81.894 87.1739 80.3099 87.1739C78.7259 87.1739 77.4417 86.0449 77.4417 84.6522C77.4417 83.2595 78.7259 82.1304 80.3099 82.1304C81.894 82.1304 83.1782 83.2595 83.1782 84.6522Z"
        fill="#060606"
      />
      <path
        d="M31.5503 114.913C31.5503 116.306 30.2662 117.435 28.6821 117.435C27.0981 117.435 25.8139 116.306 25.8139 114.913C25.8139 113.52 27.0981 112.391 28.6821 112.391C30.2662 112.391 31.5503 113.52 31.5503 114.913Z"
        fill="#060606"
      />
      <path
        d="M83.1782 114.913C83.1782 116.306 81.894 117.435 80.3099 117.435C78.7259 117.435 77.4417 116.306 77.4417 114.913C77.4417 113.52 78.7259 112.391 80.3099 112.391C81.894 112.391 83.1782 113.52 83.1782 114.913Z"
        fill="#060606"
      />
      <path
        d="M31.5503 77.087C31.5503 78.4797 30.2662 79.6087 28.6821 79.6087C27.0981 79.6087 25.8139 78.4797 25.8139 77.087C25.8139 75.6942 27.0981 74.5652 28.6821 74.5652C30.2662 74.5652 31.5503 75.6942 31.5503 77.087Z"
        fill="#060606"
      />
      <path
        d="M83.1782 77.087C83.1782 78.4797 81.894 79.6087 80.3099 79.6087C78.7259 79.6087 77.4417 78.4797 77.4417 77.087C77.4417 75.6942 78.7259 74.5652 80.3099 74.5652C81.894 74.5652 83.1782 75.6942 83.1782 77.087Z"
        fill="#060606"
      />
      <path
        d="M31.5503 107.348C31.5503 108.741 30.2662 109.87 28.6821 109.87C27.0981 109.87 25.8139 108.741 25.8139 107.348C25.8139 105.955 27.0981 104.826 28.6821 104.826C30.2662 104.826 31.5503 105.955 31.5503 107.348Z"
        fill="#060606"
      />
      <path
        d="M83.1782 107.348C83.1782 108.741 81.894 109.87 80.3099 109.87C78.7259 109.87 77.4417 108.741 77.4417 107.348C77.4417 105.955 78.7259 104.826 80.3099 104.826C81.894 104.826 83.1782 105.955 83.1782 107.348Z"
        fill="#060606"
      />
      <path
        d="M31.5503 92.2174C31.5503 93.6101 30.2662 94.7391 28.6821 94.7391C27.0981 94.7391 25.8139 93.6101 25.8139 92.2174C25.8139 90.8247 27.0981 89.6956 28.6821 89.6956C30.2662 89.6956 31.5503 90.8247 31.5503 92.2174Z"
        fill="#060606"
      />
      <path
        d="M83.1782 92.2174C83.1782 93.6101 81.894 94.7391 80.3099 94.7391C78.7259 94.7391 77.4417 93.6101 77.4417 92.2174C77.4417 90.8247 78.7259 89.6956 80.3099 89.6956C81.894 89.6956 83.1782 90.8247 83.1782 92.2174Z"
        fill="#060606"
      />
      <path
        d="M31.5503 122.478C31.5503 123.871 30.2662 125 28.6821 125C27.0981 125 25.8139 123.871 25.8139 122.478C25.8139 121.086 27.0981 119.957 28.6821 119.957C30.2662 119.957 31.5503 121.086 31.5503 122.478Z"
        fill="#060606"
      />
      <path
        d="M83.1782 122.478C83.1782 123.871 81.894 125 80.3099 125C78.7259 125 77.4417 123.871 77.4417 122.478C77.4417 121.086 78.7259 119.957 80.3099 119.957C81.894 119.957 83.1782 121.086 83.1782 122.478Z"
        fill="#060606"
      />
      <path
        d="M48.7596 69.5217C48.7596 70.9145 47.4755 72.0435 45.8914 72.0435C44.3073 72.0435 43.0232 70.9145 43.0232 69.5217C43.0232 68.129 44.3073 67 45.8914 67C47.4755 67 48.7596 68.129 48.7596 69.5217Z"
        fill="#060606"
      />
      <path
        d="M100.387 69.5217C100.387 70.9145 99.1033 72.0435 97.5192 72.0435C95.9351 72.0435 94.651 70.9145 94.651 69.5217C94.651 68.129 95.9351 67 97.5192 67C99.1033 67 100.387 68.129 100.387 69.5217Z"
        fill="#060606"
      />
      <path
        d="M48.7596 99.7826C48.7596 101.175 47.4755 102.304 45.8914 102.304C44.3073 102.304 43.0232 101.175 43.0232 99.7826C43.0232 98.3899 44.3073 97.2609 45.8914 97.2609C47.4755 97.2609 48.7596 98.3899 48.7596 99.7826Z"
        fill="#060606"
      />
      <path
        d="M100.387 99.7826C100.387 101.175 99.1033 102.304 97.5192 102.304C95.9351 102.304 94.651 101.175 94.651 99.7826C94.651 98.3899 95.9351 97.2609 97.5192 97.2609C99.1033 97.2609 100.387 98.3899 100.387 99.7826Z"
        fill="#060606"
      />
      <path
        d="M48.7596 84.6522C48.7596 86.0449 47.4755 87.1739 45.8914 87.1739C44.3073 87.1739 43.0232 86.0449 43.0232 84.6522C43.0232 83.2595 44.3073 82.1304 45.8914 82.1304C47.4755 82.1304 48.7596 83.2595 48.7596 84.6522Z"
        fill="#060606"
      />
      <path
        d="M100.387 84.6522C100.387 86.0449 99.1033 87.1739 97.5192 87.1739C95.9351 87.1739 94.651 86.0449 94.651 84.6522C94.651 83.2595 95.9351 82.1304 97.5192 82.1304C99.1033 82.1304 100.387 83.2595 100.387 84.6522Z"
        fill="#060606"
      />
      <path
        d="M48.7596 114.913C48.7596 116.306 47.4755 117.435 45.8914 117.435C44.3073 117.435 43.0232 116.306 43.0232 114.913C43.0232 113.52 44.3073 112.391 45.8914 112.391C47.4755 112.391 48.7596 113.52 48.7596 114.913Z"
        fill="#060606"
      />
      <path
        d="M100.387 114.913C100.387 116.306 99.1033 117.435 97.5192 117.435C95.9351 117.435 94.651 116.306 94.651 114.913C94.651 113.52 95.9351 112.391 97.5192 112.391C99.1033 112.391 100.387 113.52 100.387 114.913Z"
        fill="#060606"
      />
      <path
        d="M48.7596 77.087C48.7596 78.4797 47.4755 79.6087 45.8914 79.6087C44.3073 79.6087 43.0232 78.4797 43.0232 77.087C43.0232 75.6942 44.3073 74.5652 45.8914 74.5652C47.4755 74.5652 48.7596 75.6942 48.7596 77.087Z"
        fill="#060606"
      />
      <path
        d="M100.387 77.087C100.387 78.4797 99.1033 79.6087 97.5192 79.6087C95.9351 79.6087 94.651 78.4797 94.651 77.087C94.651 75.6942 95.9351 74.5652 97.5192 74.5652C99.1033 74.5652 100.387 75.6942 100.387 77.087Z"
        fill="#060606"
      />
      <path
        d="M48.7596 107.348C48.7596 108.741 47.4755 109.87 45.8914 109.87C44.3073 109.87 43.0232 108.741 43.0232 107.348C43.0232 105.955 44.3073 104.826 45.8914 104.826C47.4755 104.826 48.7596 105.955 48.7596 107.348Z"
        fill="#060606"
      />
      <path
        d="M100.387 107.348C100.387 108.741 99.1033 109.87 97.5192 109.87C95.9351 109.87 94.651 108.741 94.651 107.348C94.651 105.955 95.9351 104.826 97.5192 104.826C99.1033 104.826 100.387 105.955 100.387 107.348Z"
        fill="#060606"
      />
      <path
        d="M48.7596 92.2174C48.7596 93.6101 47.4755 94.7391 45.8914 94.7391C44.3073 94.7391 43.0232 93.6101 43.0232 92.2174C43.0232 90.8247 44.3073 89.6956 45.8914 89.6956C47.4755 89.6956 48.7596 90.8247 48.7596 92.2174Z"
        fill="#060606"
      />
      <path
        d="M100.387 92.2174C100.387 93.6101 99.1033 94.7391 97.5192 94.7391C95.9351 94.7391 94.651 93.6101 94.651 92.2174C94.651 90.8247 95.9351 89.6956 97.5192 89.6956C99.1033 89.6956 100.387 90.8247 100.387 92.2174Z"
        fill="#060606"
      />
      <path
        d="M48.7596 122.478C48.7596 123.871 47.4755 125 45.8914 125C44.3073 125 43.0232 123.871 43.0232 122.478C43.0232 121.086 44.3073 119.957 45.8914 119.957C47.4755 119.957 48.7596 121.086 48.7596 122.478Z"
        fill="#060606"
      />
      <path
        d="M100.387 122.478C100.387 123.871 99.1033 125 97.5192 125C95.9351 125 94.651 123.871 94.651 122.478C94.651 121.086 95.9351 119.957 97.5192 119.957C99.1033 119.957 100.387 121.086 100.387 122.478Z"
        fill="#060606"
      />
      <path
        d="M108.405 -50.4783C108.405 -49.0855 107.121 -47.9565 105.537 -47.9565C103.953 -47.9565 102.669 -49.0855 102.669 -50.4783C102.669 -51.871 103.953 -53 105.537 -53C107.121 -53 108.405 -51.871 108.405 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M160.033 -50.4783C160.033 -49.0855 158.749 -47.9565 157.165 -47.9565C155.581 -47.9565 154.297 -49.0855 154.297 -50.4783C154.297 -51.871 155.581 -53 157.165 -53C158.749 -53 160.033 -51.871 160.033 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M108.405 -20.2174C108.405 -18.8247 107.121 -17.6957 105.537 -17.6957C103.953 -17.6957 102.669 -18.8247 102.669 -20.2174C102.669 -21.6101 103.953 -22.7391 105.537 -22.7391C107.121 -22.7391 108.405 -21.6101 108.405 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M160.033 -20.2174C160.033 -18.8247 158.749 -17.6957 157.165 -17.6957C155.581 -17.6957 154.297 -18.8247 154.297 -20.2174C154.297 -21.6101 155.581 -22.7391 157.165 -22.7391C158.749 -22.7391 160.033 -21.6101 160.033 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M108.405 -35.3478C108.405 -33.9551 107.121 -32.8261 105.537 -32.8261C103.953 -32.8261 102.669 -33.9551 102.669 -35.3478C102.669 -36.7405 103.953 -37.8696 105.537 -37.8696C107.121 -37.8696 108.405 -36.7405 108.405 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M160.033 -35.3478C160.033 -33.9551 158.749 -32.8261 157.165 -32.8261C155.581 -32.8261 154.297 -33.9551 154.297 -35.3478C154.297 -36.7405 155.581 -37.8696 157.165 -37.8696C158.749 -37.8696 160.033 -36.7405 160.033 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M108.405 -5.08696C108.405 -3.69424 107.121 -2.56522 105.537 -2.56522C103.953 -2.56522 102.669 -3.69424 102.669 -5.08696C102.669 -6.47968 103.953 -7.60869 105.537 -7.60869C107.121 -7.60869 108.405 -6.47968 108.405 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M160.033 -5.08696C160.033 -3.69424 158.749 -2.56522 157.165 -2.56522C155.581 -2.56522 154.297 -3.69424 154.297 -5.08696C154.297 -6.47968 155.581 -7.60869 157.165 -7.60869C158.749 -7.60869 160.033 -6.47968 160.033 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M108.405 -42.913C108.405 -41.5203 107.121 -40.3913 105.537 -40.3913C103.953 -40.3913 102.669 -41.5203 102.669 -42.913C102.669 -44.3058 103.953 -45.4348 105.537 -45.4348C107.121 -45.4348 108.405 -44.3058 108.405 -42.913Z"
        fill="#060606"
      />
      <path
        d="M160.033 -42.913C160.033 -41.5203 158.749 -40.3913 157.165 -40.3913C155.581 -40.3913 154.297 -41.5203 154.297 -42.913C154.297 -44.3058 155.581 -45.4348 157.165 -45.4348C158.749 -45.4348 160.033 -44.3058 160.033 -42.913Z"
        fill="#060606"
      />
      <path
        d="M108.405 -12.6522C108.405 -11.2595 107.121 -10.1304 105.537 -10.1304C103.953 -10.1304 102.669 -11.2595 102.669 -12.6522C102.669 -14.0449 103.953 -15.1739 105.537 -15.1739C107.121 -15.1739 108.405 -14.0449 108.405 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M160.033 -12.6522C160.033 -11.2595 158.749 -10.1304 157.165 -10.1304C155.581 -10.1304 154.297 -11.2595 154.297 -12.6522C154.297 -14.0449 155.581 -15.1739 157.165 -15.1739C158.749 -15.1739 160.033 -14.0449 160.033 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M108.405 -27.7826C108.405 -26.3899 107.121 -25.2609 105.537 -25.2609C103.953 -25.2609 102.669 -26.3899 102.669 -27.7826C102.669 -29.1753 103.953 -30.3043 105.537 -30.3043C107.121 -30.3043 108.405 -29.1753 108.405 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M160.033 -27.7826C160.033 -26.3899 158.749 -25.2609 157.165 -25.2609C155.581 -25.2609 154.297 -26.3899 154.297 -27.7826C154.297 -29.1753 155.581 -30.3043 157.165 -30.3043C158.749 -30.3043 160.033 -29.1753 160.033 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M108.405 2.47826C108.405 3.87098 107.121 5 105.537 5C103.953 5 102.669 3.87098 102.669 2.47826C102.669 1.08554 103.953 -0.0434761 105.537 -0.0434761C107.121 -0.0434761 108.405 1.08554 108.405 2.47826Z"
        fill="#060606"
      />
      <path
        d="M160.033 2.47826C160.033 3.87098 158.749 5 157.165 5C155.581 5 154.297 3.87098 154.297 2.47826C154.297 1.08554 155.581 -0.0434761 157.165 -0.0434761C158.749 -0.0434761 160.033 1.08554 160.033 2.47826Z"
        fill="#060606"
      />
      <path
        d="M125.615 -50.4783C125.615 -49.0855 124.331 -47.9565 122.746 -47.9565C121.162 -47.9565 119.878 -49.0855 119.878 -50.4783C119.878 -51.871 121.162 -53 122.746 -53C124.331 -53 125.615 -51.871 125.615 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M177.242 -50.4783C177.242 -49.0855 175.958 -47.9565 174.374 -47.9565C172.79 -47.9565 171.506 -49.0855 171.506 -50.4783C171.506 -51.871 172.79 -53 174.374 -53C175.958 -53 177.242 -51.871 177.242 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M125.615 -20.2174C125.615 -18.8247 124.331 -17.6957 122.746 -17.6957C121.162 -17.6957 119.878 -18.8247 119.878 -20.2174C119.878 -21.6101 121.162 -22.7391 122.746 -22.7391C124.331 -22.7391 125.615 -21.6101 125.615 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M177.242 -20.2174C177.242 -18.8247 175.958 -17.6957 174.374 -17.6957C172.79 -17.6957 171.506 -18.8247 171.506 -20.2174C171.506 -21.6101 172.79 -22.7391 174.374 -22.7391C175.958 -22.7391 177.242 -21.6101 177.242 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M125.615 -35.3478C125.615 -33.9551 124.331 -32.8261 122.746 -32.8261C121.162 -32.8261 119.878 -33.9551 119.878 -35.3478C119.878 -36.7405 121.162 -37.8696 122.746 -37.8696C124.331 -37.8696 125.615 -36.7405 125.615 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M177.242 -35.3478C177.242 -33.9551 175.958 -32.8261 174.374 -32.8261C172.79 -32.8261 171.506 -33.9551 171.506 -35.3478C171.506 -36.7405 172.79 -37.8696 174.374 -37.8696C175.958 -37.8696 177.242 -36.7405 177.242 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M125.615 -5.08696C125.615 -3.69424 124.331 -2.56522 122.746 -2.56522C121.162 -2.56522 119.878 -3.69424 119.878 -5.08696C119.878 -6.47968 121.162 -7.60869 122.746 -7.60869C124.331 -7.60869 125.615 -6.47968 125.615 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M177.242 -5.08696C177.242 -3.69424 175.958 -2.56522 174.374 -2.56522C172.79 -2.56522 171.506 -3.69424 171.506 -5.08696C171.506 -6.47968 172.79 -7.60869 174.374 -7.60869C175.958 -7.60869 177.242 -6.47968 177.242 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M125.615 -42.913C125.615 -41.5203 124.331 -40.3913 122.746 -40.3913C121.162 -40.3913 119.878 -41.5203 119.878 -42.913C119.878 -44.3058 121.162 -45.4348 122.746 -45.4348C124.331 -45.4348 125.615 -44.3058 125.615 -42.913Z"
        fill="#060606"
      />
      <path
        d="M177.242 -42.913C177.242 -41.5203 175.958 -40.3913 174.374 -40.3913C172.79 -40.3913 171.506 -41.5203 171.506 -42.913C171.506 -44.3058 172.79 -45.4348 174.374 -45.4348C175.958 -45.4348 177.242 -44.3058 177.242 -42.913Z"
        fill="#060606"
      />
      <path
        d="M125.615 -12.6522C125.615 -11.2595 124.331 -10.1304 122.746 -10.1304C121.162 -10.1304 119.878 -11.2595 119.878 -12.6522C119.878 -14.0449 121.162 -15.1739 122.746 -15.1739C124.331 -15.1739 125.615 -14.0449 125.615 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M177.242 -12.6522C177.242 -11.2595 175.958 -10.1304 174.374 -10.1304C172.79 -10.1304 171.506 -11.2595 171.506 -12.6522C171.506 -14.0449 172.79 -15.1739 174.374 -15.1739C175.958 -15.1739 177.242 -14.0449 177.242 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M125.615 -27.7826C125.615 -26.3899 124.331 -25.2609 122.746 -25.2609C121.162 -25.2609 119.878 -26.3899 119.878 -27.7826C119.878 -29.1753 121.162 -30.3043 122.746 -30.3043C124.331 -30.3043 125.615 -29.1753 125.615 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M177.242 -27.7826C177.242 -26.3899 175.958 -25.2609 174.374 -25.2609C172.79 -25.2609 171.506 -26.3899 171.506 -27.7826C171.506 -29.1753 172.79 -30.3043 174.374 -30.3043C175.958 -30.3043 177.242 -29.1753 177.242 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M125.615 2.47826C125.615 3.87098 124.331 5 122.746 5C121.162 5 119.878 3.87098 119.878 2.47826C119.878 1.08554 121.162 -0.0434761 122.746 -0.0434761C124.331 -0.0434761 125.615 1.08554 125.615 2.47826Z"
        fill="#060606"
      />
      <path
        d="M177.242 2.47826C177.242 3.87098 175.958 5 174.374 5C172.79 5 171.506 3.87098 171.506 2.47826C171.506 1.08554 172.79 -0.0434761 174.374 -0.0434761C175.958 -0.0434761 177.242 1.08554 177.242 2.47826Z"
        fill="#060606"
      />
      <path
        d="M142.824 -50.4783C142.824 -49.0855 141.54 -47.9565 139.956 -47.9565C138.372 -47.9565 137.088 -49.0855 137.088 -50.4783C137.088 -51.871 138.372 -53 139.956 -53C141.54 -53 142.824 -51.871 142.824 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M194.452 -50.4783C194.452 -49.0855 193.168 -47.9565 191.584 -47.9565C189.999 -47.9565 188.715 -49.0855 188.715 -50.4783C188.715 -51.871 189.999 -53 191.584 -53C193.168 -53 194.452 -51.871 194.452 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M142.824 -20.2174C142.824 -18.8247 141.54 -17.6957 139.956 -17.6957C138.372 -17.6957 137.088 -18.8247 137.088 -20.2174C137.088 -21.6101 138.372 -22.7391 139.956 -22.7391C141.54 -22.7391 142.824 -21.6101 142.824 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M194.452 -20.2174C194.452 -18.8247 193.168 -17.6957 191.584 -17.6957C189.999 -17.6957 188.715 -18.8247 188.715 -20.2174C188.715 -21.6101 189.999 -22.7391 191.584 -22.7391C193.168 -22.7391 194.452 -21.6101 194.452 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M142.824 -35.3478C142.824 -33.9551 141.54 -32.8261 139.956 -32.8261C138.372 -32.8261 137.088 -33.9551 137.088 -35.3478C137.088 -36.7405 138.372 -37.8696 139.956 -37.8696C141.54 -37.8696 142.824 -36.7405 142.824 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M194.452 -35.3478C194.452 -33.9551 193.168 -32.8261 191.584 -32.8261C189.999 -32.8261 188.715 -33.9551 188.715 -35.3478C188.715 -36.7405 189.999 -37.8696 191.584 -37.8696C193.168 -37.8696 194.452 -36.7405 194.452 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M142.824 -5.08696C142.824 -3.69424 141.54 -2.56522 139.956 -2.56522C138.372 -2.56522 137.088 -3.69424 137.088 -5.08696C137.088 -6.47968 138.372 -7.60869 139.956 -7.60869C141.54 -7.60869 142.824 -6.47968 142.824 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M194.452 -5.08696C194.452 -3.69424 193.168 -2.56522 191.584 -2.56522C189.999 -2.56522 188.715 -3.69424 188.715 -5.08696C188.715 -6.47968 189.999 -7.60869 191.584 -7.60869C193.168 -7.60869 194.452 -6.47968 194.452 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M142.824 -42.913C142.824 -41.5203 141.54 -40.3913 139.956 -40.3913C138.372 -40.3913 137.088 -41.5203 137.088 -42.913C137.088 -44.3058 138.372 -45.4348 139.956 -45.4348C141.54 -45.4348 142.824 -44.3058 142.824 -42.913Z"
        fill="#060606"
      />
      <path
        d="M194.452 -42.913C194.452 -41.5203 193.168 -40.3913 191.584 -40.3913C189.999 -40.3913 188.715 -41.5203 188.715 -42.913C188.715 -44.3058 189.999 -45.4348 191.584 -45.4348C193.168 -45.4348 194.452 -44.3058 194.452 -42.913Z"
        fill="#060606"
      />
      <path
        d="M142.824 -12.6522C142.824 -11.2595 141.54 -10.1304 139.956 -10.1304C138.372 -10.1304 137.088 -11.2595 137.088 -12.6522C137.088 -14.0449 138.372 -15.1739 139.956 -15.1739C141.54 -15.1739 142.824 -14.0449 142.824 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M194.452 -12.6522C194.452 -11.2595 193.168 -10.1304 191.584 -10.1304C189.999 -10.1304 188.715 -11.2595 188.715 -12.6522C188.715 -14.0449 189.999 -15.1739 191.584 -15.1739C193.168 -15.1739 194.452 -14.0449 194.452 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M142.824 -27.7826C142.824 -26.3899 141.54 -25.2609 139.956 -25.2609C138.372 -25.2609 137.088 -26.3899 137.088 -27.7826C137.088 -29.1753 138.372 -30.3043 139.956 -30.3043C141.54 -30.3043 142.824 -29.1753 142.824 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M194.452 -27.7826C194.452 -26.3899 193.168 -25.2609 191.584 -25.2609C189.999 -25.2609 188.715 -26.3899 188.715 -27.7826C188.715 -29.1753 189.999 -30.3043 191.584 -30.3043C193.168 -30.3043 194.452 -29.1753 194.452 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M142.824 2.47826C142.824 3.87098 141.54 5 139.956 5C138.372 5 137.088 3.87098 137.088 2.47826C137.088 1.08554 138.372 -0.0434761 139.956 -0.0434761C141.54 -0.0434761 142.824 1.08554 142.824 2.47826Z"
        fill="#060606"
      />
      <path
        d="M194.452 2.47826C194.452 3.87098 193.168 5 191.584 5C189.999 5 188.715 3.87098 188.715 2.47826C188.715 1.08554 189.999 -0.0434761 191.584 -0.0434761C193.168 -0.0434761 194.452 1.08554 194.452 2.47826Z"
        fill="#060606"
      />
      <path
        d="M117.01 -50.4783C117.01 -49.0855 115.726 -47.9565 114.142 -47.9565C112.558 -47.9565 111.274 -49.0855 111.274 -50.4783C111.274 -51.871 112.558 -53 114.142 -53C115.726 -53 117.01 -51.871 117.01 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M168.638 -50.4783C168.638 -49.0855 167.354 -47.9565 165.77 -47.9565C164.186 -47.9565 162.901 -49.0855 162.901 -50.4783C162.901 -51.871 164.186 -53 165.77 -53C167.354 -53 168.638 -51.871 168.638 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M117.01 -20.2174C117.01 -18.8247 115.726 -17.6957 114.142 -17.6957C112.558 -17.6957 111.274 -18.8247 111.274 -20.2174C111.274 -21.6101 112.558 -22.7391 114.142 -22.7391C115.726 -22.7391 117.01 -21.6101 117.01 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M168.638 -20.2174C168.638 -18.8247 167.354 -17.6957 165.77 -17.6957C164.186 -17.6957 162.901 -18.8247 162.901 -20.2174C162.901 -21.6101 164.186 -22.7391 165.77 -22.7391C167.354 -22.7391 168.638 -21.6101 168.638 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M117.01 -35.3478C117.01 -33.9551 115.726 -32.8261 114.142 -32.8261C112.558 -32.8261 111.274 -33.9551 111.274 -35.3478C111.274 -36.7405 112.558 -37.8696 114.142 -37.8696C115.726 -37.8696 117.01 -36.7405 117.01 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M168.638 -35.3478C168.638 -33.9551 167.354 -32.8261 165.77 -32.8261C164.186 -32.8261 162.901 -33.9551 162.901 -35.3478C162.901 -36.7405 164.186 -37.8696 165.77 -37.8696C167.354 -37.8696 168.638 -36.7405 168.638 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M117.01 -5.08696C117.01 -3.69424 115.726 -2.56522 114.142 -2.56522C112.558 -2.56522 111.274 -3.69424 111.274 -5.08696C111.274 -6.47968 112.558 -7.60869 114.142 -7.60869C115.726 -7.60869 117.01 -6.47968 117.01 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M168.638 -5.08696C168.638 -3.69424 167.354 -2.56522 165.77 -2.56522C164.186 -2.56522 162.901 -3.69424 162.901 -5.08696C162.901 -6.47968 164.186 -7.60869 165.77 -7.60869C167.354 -7.60869 168.638 -6.47968 168.638 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M117.01 -42.913C117.01 -41.5203 115.726 -40.3913 114.142 -40.3913C112.558 -40.3913 111.274 -41.5203 111.274 -42.913C111.274 -44.3058 112.558 -45.4348 114.142 -45.4348C115.726 -45.4348 117.01 -44.3058 117.01 -42.913Z"
        fill="#060606"
      />
      <path
        d="M168.638 -42.913C168.638 -41.5203 167.354 -40.3913 165.77 -40.3913C164.186 -40.3913 162.901 -41.5203 162.901 -42.913C162.901 -44.3058 164.186 -45.4348 165.77 -45.4348C167.354 -45.4348 168.638 -44.3058 168.638 -42.913Z"
        fill="#060606"
      />
      <path
        d="M117.01 -12.6522C117.01 -11.2595 115.726 -10.1304 114.142 -10.1304C112.558 -10.1304 111.274 -11.2595 111.274 -12.6522C111.274 -14.0449 112.558 -15.1739 114.142 -15.1739C115.726 -15.1739 117.01 -14.0449 117.01 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M168.638 -12.6522C168.638 -11.2595 167.354 -10.1304 165.77 -10.1304C164.186 -10.1304 162.901 -11.2595 162.901 -12.6522C162.901 -14.0449 164.186 -15.1739 165.77 -15.1739C167.354 -15.1739 168.638 -14.0449 168.638 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M117.01 -27.7826C117.01 -26.3899 115.726 -25.2609 114.142 -25.2609C112.558 -25.2609 111.274 -26.3899 111.274 -27.7826C111.274 -29.1753 112.558 -30.3043 114.142 -30.3043C115.726 -30.3043 117.01 -29.1753 117.01 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M168.638 -27.7826C168.638 -26.3899 167.354 -25.2609 165.77 -25.2609C164.186 -25.2609 162.901 -26.3899 162.901 -27.7826C162.901 -29.1753 164.186 -30.3043 165.77 -30.3043C167.354 -30.3043 168.638 -29.1753 168.638 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M117.01 2.47826C117.01 3.87098 115.726 5 114.142 5C112.558 5 111.274 3.87098 111.274 2.47826C111.274 1.08554 112.558 -0.0434761 114.142 -0.0434761C115.726 -0.0434761 117.01 1.08554 117.01 2.47826Z"
        fill="#060606"
      />
      <path
        d="M168.638 2.47826C168.638 3.87098 167.354 5 165.77 5C164.186 5 162.901 3.87098 162.901 2.47826C162.901 1.08554 164.186 -0.0434761 165.77 -0.0434761C167.354 -0.0434761 168.638 1.08554 168.638 2.47826Z"
        fill="#060606"
      />
      <path
        d="M134.219 -50.4783C134.219 -49.0855 132.935 -47.9565 131.351 -47.9565C129.767 -47.9565 128.483 -49.0855 128.483 -50.4783C128.483 -51.871 129.767 -53 131.351 -53C132.935 -53 134.219 -51.871 134.219 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M185.847 -50.4783C185.847 -49.0855 184.563 -47.9565 182.979 -47.9565C181.395 -47.9565 180.111 -49.0855 180.111 -50.4783C180.111 -51.871 181.395 -53 182.979 -53C184.563 -53 185.847 -51.871 185.847 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M134.219 -20.2174C134.219 -18.8247 132.935 -17.6957 131.351 -17.6957C129.767 -17.6957 128.483 -18.8247 128.483 -20.2174C128.483 -21.6101 129.767 -22.7391 131.351 -22.7391C132.935 -22.7391 134.219 -21.6101 134.219 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M185.847 -20.2174C185.847 -18.8247 184.563 -17.6957 182.979 -17.6957C181.395 -17.6957 180.111 -18.8247 180.111 -20.2174C180.111 -21.6101 181.395 -22.7391 182.979 -22.7391C184.563 -22.7391 185.847 -21.6101 185.847 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M134.219 -35.3478C134.219 -33.9551 132.935 -32.8261 131.351 -32.8261C129.767 -32.8261 128.483 -33.9551 128.483 -35.3478C128.483 -36.7405 129.767 -37.8696 131.351 -37.8696C132.935 -37.8696 134.219 -36.7405 134.219 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M185.847 -35.3478C185.847 -33.9551 184.563 -32.8261 182.979 -32.8261C181.395 -32.8261 180.111 -33.9551 180.111 -35.3478C180.111 -36.7405 181.395 -37.8696 182.979 -37.8696C184.563 -37.8696 185.847 -36.7405 185.847 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M134.219 -5.08696C134.219 -3.69424 132.935 -2.56522 131.351 -2.56522C129.767 -2.56522 128.483 -3.69424 128.483 -5.08696C128.483 -6.47968 129.767 -7.60869 131.351 -7.60869C132.935 -7.60869 134.219 -6.47968 134.219 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M185.847 -5.08696C185.847 -3.69424 184.563 -2.56522 182.979 -2.56522C181.395 -2.56522 180.111 -3.69424 180.111 -5.08696C180.111 -6.47968 181.395 -7.60869 182.979 -7.60869C184.563 -7.60869 185.847 -6.47968 185.847 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M134.219 -42.913C134.219 -41.5203 132.935 -40.3913 131.351 -40.3913C129.767 -40.3913 128.483 -41.5203 128.483 -42.913C128.483 -44.3058 129.767 -45.4348 131.351 -45.4348C132.935 -45.4348 134.219 -44.3058 134.219 -42.913Z"
        fill="#060606"
      />
      <path
        d="M185.847 -42.913C185.847 -41.5203 184.563 -40.3913 182.979 -40.3913C181.395 -40.3913 180.111 -41.5203 180.111 -42.913C180.111 -44.3058 181.395 -45.4348 182.979 -45.4348C184.563 -45.4348 185.847 -44.3058 185.847 -42.913Z"
        fill="#060606"
      />
      <path
        d="M134.219 -12.6522C134.219 -11.2595 132.935 -10.1304 131.351 -10.1304C129.767 -10.1304 128.483 -11.2595 128.483 -12.6522C128.483 -14.0449 129.767 -15.1739 131.351 -15.1739C132.935 -15.1739 134.219 -14.0449 134.219 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M185.847 -12.6522C185.847 -11.2595 184.563 -10.1304 182.979 -10.1304C181.395 -10.1304 180.111 -11.2595 180.111 -12.6522C180.111 -14.0449 181.395 -15.1739 182.979 -15.1739C184.563 -15.1739 185.847 -14.0449 185.847 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M134.219 -27.7826C134.219 -26.3899 132.935 -25.2609 131.351 -25.2609C129.767 -25.2609 128.483 -26.3899 128.483 -27.7826C128.483 -29.1753 129.767 -30.3043 131.351 -30.3043C132.935 -30.3043 134.219 -29.1753 134.219 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M185.847 -27.7826C185.847 -26.3899 184.563 -25.2609 182.979 -25.2609C181.395 -25.2609 180.111 -26.3899 180.111 -27.7826C180.111 -29.1753 181.395 -30.3043 182.979 -30.3043C184.563 -30.3043 185.847 -29.1753 185.847 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M134.219 2.47826C134.219 3.87098 132.935 5 131.351 5C129.767 5 128.483 3.87098 128.483 2.47826C128.483 1.08554 129.767 -0.0434761 131.351 -0.0434761C132.935 -0.0434761 134.219 1.08554 134.219 2.47826Z"
        fill="#060606"
      />
      <path
        d="M185.847 2.47826C185.847 3.87098 184.563 5 182.979 5C181.395 5 180.111 3.87098 180.111 2.47826C180.111 1.08554 181.395 -0.0434761 182.979 -0.0434761C184.563 -0.0434761 185.847 1.08554 185.847 2.47826Z"
        fill="#060606"
      />
      <path
        d="M151.429 -50.4783C151.429 -49.0855 150.144 -47.9565 148.56 -47.9565C146.976 -47.9565 145.692 -49.0855 145.692 -50.4783C145.692 -51.871 146.976 -53 148.56 -53C150.144 -53 151.429 -51.871 151.429 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M203.056 -50.4783C203.056 -49.0855 201.772 -47.9565 200.188 -47.9565C198.604 -47.9565 197.32 -49.0855 197.32 -50.4783C197.32 -51.871 198.604 -53 200.188 -53C201.772 -53 203.056 -51.871 203.056 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M151.429 -20.2174C151.429 -18.8247 150.144 -17.6957 148.56 -17.6957C146.976 -17.6957 145.692 -18.8247 145.692 -20.2174C145.692 -21.6101 146.976 -22.7391 148.56 -22.7391C150.144 -22.7391 151.429 -21.6101 151.429 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M203.056 -20.2174C203.056 -18.8247 201.772 -17.6957 200.188 -17.6957C198.604 -17.6957 197.32 -18.8247 197.32 -20.2174C197.32 -21.6101 198.604 -22.7391 200.188 -22.7391C201.772 -22.7391 203.056 -21.6101 203.056 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M151.429 -35.3478C151.429 -33.9551 150.144 -32.8261 148.56 -32.8261C146.976 -32.8261 145.692 -33.9551 145.692 -35.3478C145.692 -36.7405 146.976 -37.8696 148.56 -37.8696C150.144 -37.8696 151.429 -36.7405 151.429 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M203.056 -35.3478C203.056 -33.9551 201.772 -32.8261 200.188 -32.8261C198.604 -32.8261 197.32 -33.9551 197.32 -35.3478C197.32 -36.7405 198.604 -37.8696 200.188 -37.8696C201.772 -37.8696 203.056 -36.7405 203.056 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M151.429 -5.08696C151.429 -3.69424 150.144 -2.56522 148.56 -2.56522C146.976 -2.56522 145.692 -3.69424 145.692 -5.08696C145.692 -6.47968 146.976 -7.60869 148.56 -7.60869C150.144 -7.60869 151.429 -6.47968 151.429 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M203.056 -5.08696C203.056 -3.69424 201.772 -2.56522 200.188 -2.56522C198.604 -2.56522 197.32 -3.69424 197.32 -5.08696C197.32 -6.47968 198.604 -7.60869 200.188 -7.60869C201.772 -7.60869 203.056 -6.47968 203.056 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M151.429 -42.913C151.429 -41.5203 150.144 -40.3913 148.56 -40.3913C146.976 -40.3913 145.692 -41.5203 145.692 -42.913C145.692 -44.3058 146.976 -45.4348 148.56 -45.4348C150.144 -45.4348 151.429 -44.3058 151.429 -42.913Z"
        fill="#060606"
      />
      <path
        d="M203.056 -42.913C203.056 -41.5203 201.772 -40.3913 200.188 -40.3913C198.604 -40.3913 197.32 -41.5203 197.32 -42.913C197.32 -44.3058 198.604 -45.4348 200.188 -45.4348C201.772 -45.4348 203.056 -44.3058 203.056 -42.913Z"
        fill="#060606"
      />
      <path
        d="M151.429 -12.6522C151.429 -11.2595 150.144 -10.1304 148.56 -10.1304C146.976 -10.1304 145.692 -11.2595 145.692 -12.6522C145.692 -14.0449 146.976 -15.1739 148.56 -15.1739C150.144 -15.1739 151.429 -14.0449 151.429 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M203.056 -12.6522C203.056 -11.2595 201.772 -10.1304 200.188 -10.1304C198.604 -10.1304 197.32 -11.2595 197.32 -12.6522C197.32 -14.0449 198.604 -15.1739 200.188 -15.1739C201.772 -15.1739 203.056 -14.0449 203.056 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M151.429 -27.7826C151.429 -26.3899 150.144 -25.2609 148.56 -25.2609C146.976 -25.2609 145.692 -26.3899 145.692 -27.7826C145.692 -29.1753 146.976 -30.3043 148.56 -30.3043C150.144 -30.3043 151.429 -29.1753 151.429 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M203.056 -27.7826C203.056 -26.3899 201.772 -25.2609 200.188 -25.2609C198.604 -25.2609 197.32 -26.3899 197.32 -27.7826C197.32 -29.1753 198.604 -30.3043 200.188 -30.3043C201.772 -30.3043 203.056 -29.1753 203.056 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M151.429 2.47826C151.429 3.87098 150.144 5 148.56 5C146.976 5 145.692 3.87098 145.692 2.47826C145.692 1.08554 146.976 -0.0434761 148.56 -0.0434761C150.144 -0.0434761 151.429 1.08554 151.429 2.47826Z"
        fill="#060606"
      />
      <path
        d="M203.056 2.47826C203.056 3.87098 201.772 5 200.188 5C198.604 5 197.32 3.87098 197.32 2.47826C197.32 1.08554 198.604 -0.0434761 200.188 -0.0434761C201.772 -0.0434761 203.056 1.08554 203.056 2.47826Z"
        fill="#060606"
      />
      <path
        d="M108.405 -50.4783C108.405 -49.0855 107.121 -47.9565 105.537 -47.9565C103.953 -47.9565 102.669 -49.0855 102.669 -50.4783C102.669 -51.871 103.953 -53 105.537 -53C107.121 -53 108.405 -51.871 108.405 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M160.033 -50.4783C160.033 -49.0855 158.749 -47.9565 157.165 -47.9565C155.581 -47.9565 154.297 -49.0855 154.297 -50.4783C154.297 -51.871 155.581 -53 157.165 -53C158.749 -53 160.033 -51.871 160.033 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M108.405 -20.2174C108.405 -18.8247 107.121 -17.6957 105.537 -17.6957C103.953 -17.6957 102.669 -18.8247 102.669 -20.2174C102.669 -21.6101 103.953 -22.7391 105.537 -22.7391C107.121 -22.7391 108.405 -21.6101 108.405 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M160.033 -20.2174C160.033 -18.8247 158.749 -17.6957 157.165 -17.6957C155.581 -17.6957 154.297 -18.8247 154.297 -20.2174C154.297 -21.6101 155.581 -22.7391 157.165 -22.7391C158.749 -22.7391 160.033 -21.6101 160.033 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M108.405 -35.3478C108.405 -33.9551 107.121 -32.8261 105.537 -32.8261C103.953 -32.8261 102.669 -33.9551 102.669 -35.3478C102.669 -36.7405 103.953 -37.8696 105.537 -37.8696C107.121 -37.8696 108.405 -36.7405 108.405 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M160.033 -35.3478C160.033 -33.9551 158.749 -32.8261 157.165 -32.8261C155.581 -32.8261 154.297 -33.9551 154.297 -35.3478C154.297 -36.7405 155.581 -37.8696 157.165 -37.8696C158.749 -37.8696 160.033 -36.7405 160.033 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M108.405 -5.08696C108.405 -3.69424 107.121 -2.56522 105.537 -2.56522C103.953 -2.56522 102.669 -3.69424 102.669 -5.08696C102.669 -6.47968 103.953 -7.60869 105.537 -7.60869C107.121 -7.60869 108.405 -6.47968 108.405 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M160.033 -5.08696C160.033 -3.69424 158.749 -2.56522 157.165 -2.56522C155.581 -2.56522 154.297 -3.69424 154.297 -5.08696C154.297 -6.47968 155.581 -7.60869 157.165 -7.60869C158.749 -7.60869 160.033 -6.47968 160.033 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M108.405 -42.913C108.405 -41.5203 107.121 -40.3913 105.537 -40.3913C103.953 -40.3913 102.669 -41.5203 102.669 -42.913C102.669 -44.3058 103.953 -45.4348 105.537 -45.4348C107.121 -45.4348 108.405 -44.3058 108.405 -42.913Z"
        fill="#060606"
      />
      <path
        d="M160.033 -42.913C160.033 -41.5203 158.749 -40.3913 157.165 -40.3913C155.581 -40.3913 154.297 -41.5203 154.297 -42.913C154.297 -44.3058 155.581 -45.4348 157.165 -45.4348C158.749 -45.4348 160.033 -44.3058 160.033 -42.913Z"
        fill="#060606"
      />
      <path
        d="M108.405 -12.6522C108.405 -11.2595 107.121 -10.1304 105.537 -10.1304C103.953 -10.1304 102.669 -11.2595 102.669 -12.6522C102.669 -14.0449 103.953 -15.1739 105.537 -15.1739C107.121 -15.1739 108.405 -14.0449 108.405 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M160.033 -12.6522C160.033 -11.2595 158.749 -10.1304 157.165 -10.1304C155.581 -10.1304 154.297 -11.2595 154.297 -12.6522C154.297 -14.0449 155.581 -15.1739 157.165 -15.1739C158.749 -15.1739 160.033 -14.0449 160.033 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M108.405 -27.7826C108.405 -26.3899 107.121 -25.2609 105.537 -25.2609C103.953 -25.2609 102.669 -26.3899 102.669 -27.7826C102.669 -29.1753 103.953 -30.3043 105.537 -30.3043C107.121 -30.3043 108.405 -29.1753 108.405 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M160.033 -27.7826C160.033 -26.3899 158.749 -25.2609 157.165 -25.2609C155.581 -25.2609 154.297 -26.3899 154.297 -27.7826C154.297 -29.1753 155.581 -30.3043 157.165 -30.3043C158.749 -30.3043 160.033 -29.1753 160.033 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M108.405 2.47826C108.405 3.87098 107.121 5 105.537 5C103.953 5 102.669 3.87098 102.669 2.47826C102.669 1.08554 103.953 -0.0434761 105.537 -0.0434761C107.121 -0.0434761 108.405 1.08554 108.405 2.47826Z"
        fill="#060606"
      />
      <path
        d="M160.033 2.47826C160.033 3.87098 158.749 5 157.165 5C155.581 5 154.297 3.87098 154.297 2.47826C154.297 1.08554 155.581 -0.0434761 157.165 -0.0434761C158.749 -0.0434761 160.033 1.08554 160.033 2.47826Z"
        fill="#060606"
      />
      <path
        d="M125.615 -50.4783C125.615 -49.0855 124.331 -47.9565 122.746 -47.9565C121.162 -47.9565 119.878 -49.0855 119.878 -50.4783C119.878 -51.871 121.162 -53 122.746 -53C124.331 -53 125.615 -51.871 125.615 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M177.242 -50.4783C177.242 -49.0855 175.958 -47.9565 174.374 -47.9565C172.79 -47.9565 171.506 -49.0855 171.506 -50.4783C171.506 -51.871 172.79 -53 174.374 -53C175.958 -53 177.242 -51.871 177.242 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M125.615 -20.2174C125.615 -18.8247 124.331 -17.6957 122.746 -17.6957C121.162 -17.6957 119.878 -18.8247 119.878 -20.2174C119.878 -21.6101 121.162 -22.7391 122.746 -22.7391C124.331 -22.7391 125.615 -21.6101 125.615 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M177.242 -20.2174C177.242 -18.8247 175.958 -17.6957 174.374 -17.6957C172.79 -17.6957 171.506 -18.8247 171.506 -20.2174C171.506 -21.6101 172.79 -22.7391 174.374 -22.7391C175.958 -22.7391 177.242 -21.6101 177.242 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M125.615 -35.3478C125.615 -33.9551 124.331 -32.8261 122.746 -32.8261C121.162 -32.8261 119.878 -33.9551 119.878 -35.3478C119.878 -36.7405 121.162 -37.8696 122.746 -37.8696C124.331 -37.8696 125.615 -36.7405 125.615 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M177.242 -35.3478C177.242 -33.9551 175.958 -32.8261 174.374 -32.8261C172.79 -32.8261 171.506 -33.9551 171.506 -35.3478C171.506 -36.7405 172.79 -37.8696 174.374 -37.8696C175.958 -37.8696 177.242 -36.7405 177.242 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M125.615 -5.08696C125.615 -3.69424 124.331 -2.56522 122.746 -2.56522C121.162 -2.56522 119.878 -3.69424 119.878 -5.08696C119.878 -6.47968 121.162 -7.60869 122.746 -7.60869C124.331 -7.60869 125.615 -6.47968 125.615 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M177.242 -5.08696C177.242 -3.69424 175.958 -2.56522 174.374 -2.56522C172.79 -2.56522 171.506 -3.69424 171.506 -5.08696C171.506 -6.47968 172.79 -7.60869 174.374 -7.60869C175.958 -7.60869 177.242 -6.47968 177.242 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M125.615 -42.913C125.615 -41.5203 124.331 -40.3913 122.746 -40.3913C121.162 -40.3913 119.878 -41.5203 119.878 -42.913C119.878 -44.3058 121.162 -45.4348 122.746 -45.4348C124.331 -45.4348 125.615 -44.3058 125.615 -42.913Z"
        fill="#060606"
      />
      <path
        d="M177.242 -42.913C177.242 -41.5203 175.958 -40.3913 174.374 -40.3913C172.79 -40.3913 171.506 -41.5203 171.506 -42.913C171.506 -44.3058 172.79 -45.4348 174.374 -45.4348C175.958 -45.4348 177.242 -44.3058 177.242 -42.913Z"
        fill="#060606"
      />
      <path
        d="M125.615 -12.6522C125.615 -11.2595 124.331 -10.1304 122.746 -10.1304C121.162 -10.1304 119.878 -11.2595 119.878 -12.6522C119.878 -14.0449 121.162 -15.1739 122.746 -15.1739C124.331 -15.1739 125.615 -14.0449 125.615 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M177.242 -12.6522C177.242 -11.2595 175.958 -10.1304 174.374 -10.1304C172.79 -10.1304 171.506 -11.2595 171.506 -12.6522C171.506 -14.0449 172.79 -15.1739 174.374 -15.1739C175.958 -15.1739 177.242 -14.0449 177.242 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M125.615 -27.7826C125.615 -26.3899 124.331 -25.2609 122.746 -25.2609C121.162 -25.2609 119.878 -26.3899 119.878 -27.7826C119.878 -29.1753 121.162 -30.3043 122.746 -30.3043C124.331 -30.3043 125.615 -29.1753 125.615 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M177.242 -27.7826C177.242 -26.3899 175.958 -25.2609 174.374 -25.2609C172.79 -25.2609 171.506 -26.3899 171.506 -27.7826C171.506 -29.1753 172.79 -30.3043 174.374 -30.3043C175.958 -30.3043 177.242 -29.1753 177.242 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M125.615 2.47826C125.615 3.87098 124.331 5 122.746 5C121.162 5 119.878 3.87098 119.878 2.47826C119.878 1.08554 121.162 -0.0434761 122.746 -0.0434761C124.331 -0.0434761 125.615 1.08554 125.615 2.47826Z"
        fill="#060606"
      />
      <path
        d="M177.242 2.47826C177.242 3.87098 175.958 5 174.374 5C172.79 5 171.506 3.87098 171.506 2.47826C171.506 1.08554 172.79 -0.0434761 174.374 -0.0434761C175.958 -0.0434761 177.242 1.08554 177.242 2.47826Z"
        fill="#060606"
      />
      <path
        d="M142.824 -50.4783C142.824 -49.0855 141.54 -47.9565 139.956 -47.9565C138.372 -47.9565 137.088 -49.0855 137.088 -50.4783C137.088 -51.871 138.372 -53 139.956 -53C141.54 -53 142.824 -51.871 142.824 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M194.452 -50.4783C194.452 -49.0855 193.168 -47.9565 191.584 -47.9565C189.999 -47.9565 188.715 -49.0855 188.715 -50.4783C188.715 -51.871 189.999 -53 191.584 -53C193.168 -53 194.452 -51.871 194.452 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M142.824 -20.2174C142.824 -18.8247 141.54 -17.6957 139.956 -17.6957C138.372 -17.6957 137.088 -18.8247 137.088 -20.2174C137.088 -21.6101 138.372 -22.7391 139.956 -22.7391C141.54 -22.7391 142.824 -21.6101 142.824 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M194.452 -20.2174C194.452 -18.8247 193.168 -17.6957 191.584 -17.6957C189.999 -17.6957 188.715 -18.8247 188.715 -20.2174C188.715 -21.6101 189.999 -22.7391 191.584 -22.7391C193.168 -22.7391 194.452 -21.6101 194.452 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M142.824 -35.3478C142.824 -33.9551 141.54 -32.8261 139.956 -32.8261C138.372 -32.8261 137.088 -33.9551 137.088 -35.3478C137.088 -36.7405 138.372 -37.8696 139.956 -37.8696C141.54 -37.8696 142.824 -36.7405 142.824 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M194.452 -35.3478C194.452 -33.9551 193.168 -32.8261 191.584 -32.8261C189.999 -32.8261 188.715 -33.9551 188.715 -35.3478C188.715 -36.7405 189.999 -37.8696 191.584 -37.8696C193.168 -37.8696 194.452 -36.7405 194.452 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M142.824 -5.08696C142.824 -3.69424 141.54 -2.56522 139.956 -2.56522C138.372 -2.56522 137.088 -3.69424 137.088 -5.08696C137.088 -6.47968 138.372 -7.60869 139.956 -7.60869C141.54 -7.60869 142.824 -6.47968 142.824 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M194.452 -5.08696C194.452 -3.69424 193.168 -2.56522 191.584 -2.56522C189.999 -2.56522 188.715 -3.69424 188.715 -5.08696C188.715 -6.47968 189.999 -7.60869 191.584 -7.60869C193.168 -7.60869 194.452 -6.47968 194.452 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M142.824 -42.913C142.824 -41.5203 141.54 -40.3913 139.956 -40.3913C138.372 -40.3913 137.088 -41.5203 137.088 -42.913C137.088 -44.3058 138.372 -45.4348 139.956 -45.4348C141.54 -45.4348 142.824 -44.3058 142.824 -42.913Z"
        fill="#060606"
      />
      <path
        d="M194.452 -42.913C194.452 -41.5203 193.168 -40.3913 191.584 -40.3913C189.999 -40.3913 188.715 -41.5203 188.715 -42.913C188.715 -44.3058 189.999 -45.4348 191.584 -45.4348C193.168 -45.4348 194.452 -44.3058 194.452 -42.913Z"
        fill="#060606"
      />
      <path
        d="M142.824 -12.6522C142.824 -11.2595 141.54 -10.1304 139.956 -10.1304C138.372 -10.1304 137.088 -11.2595 137.088 -12.6522C137.088 -14.0449 138.372 -15.1739 139.956 -15.1739C141.54 -15.1739 142.824 -14.0449 142.824 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M194.452 -12.6522C194.452 -11.2595 193.168 -10.1304 191.584 -10.1304C189.999 -10.1304 188.715 -11.2595 188.715 -12.6522C188.715 -14.0449 189.999 -15.1739 191.584 -15.1739C193.168 -15.1739 194.452 -14.0449 194.452 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M142.824 -27.7826C142.824 -26.3899 141.54 -25.2609 139.956 -25.2609C138.372 -25.2609 137.088 -26.3899 137.088 -27.7826C137.088 -29.1753 138.372 -30.3043 139.956 -30.3043C141.54 -30.3043 142.824 -29.1753 142.824 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M194.452 -27.7826C194.452 -26.3899 193.168 -25.2609 191.584 -25.2609C189.999 -25.2609 188.715 -26.3899 188.715 -27.7826C188.715 -29.1753 189.999 -30.3043 191.584 -30.3043C193.168 -30.3043 194.452 -29.1753 194.452 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M142.824 2.47826C142.824 3.87098 141.54 5 139.956 5C138.372 5 137.088 3.87098 137.088 2.47826C137.088 1.08554 138.372 -0.0434761 139.956 -0.0434761C141.54 -0.0434761 142.824 1.08554 142.824 2.47826Z"
        fill="#060606"
      />
      <path
        d="M194.452 2.47826C194.452 3.87098 193.168 5 191.584 5C189.999 5 188.715 3.87098 188.715 2.47826C188.715 1.08554 189.999 -0.0434761 191.584 -0.0434761C193.168 -0.0434761 194.452 1.08554 194.452 2.47826Z"
        fill="#060606"
      />
      <path
        d="M117.01 -50.4783C117.01 -49.0855 115.726 -47.9565 114.142 -47.9565C112.558 -47.9565 111.274 -49.0855 111.274 -50.4783C111.274 -51.871 112.558 -53 114.142 -53C115.726 -53 117.01 -51.871 117.01 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M168.638 -50.4783C168.638 -49.0855 167.354 -47.9565 165.77 -47.9565C164.186 -47.9565 162.901 -49.0855 162.901 -50.4783C162.901 -51.871 164.186 -53 165.77 -53C167.354 -53 168.638 -51.871 168.638 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M117.01 -20.2174C117.01 -18.8247 115.726 -17.6957 114.142 -17.6957C112.558 -17.6957 111.274 -18.8247 111.274 -20.2174C111.274 -21.6101 112.558 -22.7391 114.142 -22.7391C115.726 -22.7391 117.01 -21.6101 117.01 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M168.638 -20.2174C168.638 -18.8247 167.354 -17.6957 165.77 -17.6957C164.186 -17.6957 162.901 -18.8247 162.901 -20.2174C162.901 -21.6101 164.186 -22.7391 165.77 -22.7391C167.354 -22.7391 168.638 -21.6101 168.638 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M117.01 -35.3478C117.01 -33.9551 115.726 -32.8261 114.142 -32.8261C112.558 -32.8261 111.274 -33.9551 111.274 -35.3478C111.274 -36.7405 112.558 -37.8696 114.142 -37.8696C115.726 -37.8696 117.01 -36.7405 117.01 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M168.638 -35.3478C168.638 -33.9551 167.354 -32.8261 165.77 -32.8261C164.186 -32.8261 162.901 -33.9551 162.901 -35.3478C162.901 -36.7405 164.186 -37.8696 165.77 -37.8696C167.354 -37.8696 168.638 -36.7405 168.638 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M117.01 -5.08696C117.01 -3.69424 115.726 -2.56522 114.142 -2.56522C112.558 -2.56522 111.274 -3.69424 111.274 -5.08696C111.274 -6.47968 112.558 -7.60869 114.142 -7.60869C115.726 -7.60869 117.01 -6.47968 117.01 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M168.638 -5.08696C168.638 -3.69424 167.354 -2.56522 165.77 -2.56522C164.186 -2.56522 162.901 -3.69424 162.901 -5.08696C162.901 -6.47968 164.186 -7.60869 165.77 -7.60869C167.354 -7.60869 168.638 -6.47968 168.638 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M117.01 -42.913C117.01 -41.5203 115.726 -40.3913 114.142 -40.3913C112.558 -40.3913 111.274 -41.5203 111.274 -42.913C111.274 -44.3058 112.558 -45.4348 114.142 -45.4348C115.726 -45.4348 117.01 -44.3058 117.01 -42.913Z"
        fill="#060606"
      />
      <path
        d="M168.638 -42.913C168.638 -41.5203 167.354 -40.3913 165.77 -40.3913C164.186 -40.3913 162.901 -41.5203 162.901 -42.913C162.901 -44.3058 164.186 -45.4348 165.77 -45.4348C167.354 -45.4348 168.638 -44.3058 168.638 -42.913Z"
        fill="#060606"
      />
      <path
        d="M117.01 -12.6522C117.01 -11.2595 115.726 -10.1304 114.142 -10.1304C112.558 -10.1304 111.274 -11.2595 111.274 -12.6522C111.274 -14.0449 112.558 -15.1739 114.142 -15.1739C115.726 -15.1739 117.01 -14.0449 117.01 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M168.638 -12.6522C168.638 -11.2595 167.354 -10.1304 165.77 -10.1304C164.186 -10.1304 162.901 -11.2595 162.901 -12.6522C162.901 -14.0449 164.186 -15.1739 165.77 -15.1739C167.354 -15.1739 168.638 -14.0449 168.638 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M117.01 -27.7826C117.01 -26.3899 115.726 -25.2609 114.142 -25.2609C112.558 -25.2609 111.274 -26.3899 111.274 -27.7826C111.274 -29.1753 112.558 -30.3043 114.142 -30.3043C115.726 -30.3043 117.01 -29.1753 117.01 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M168.638 -27.7826C168.638 -26.3899 167.354 -25.2609 165.77 -25.2609C164.186 -25.2609 162.901 -26.3899 162.901 -27.7826C162.901 -29.1753 164.186 -30.3043 165.77 -30.3043C167.354 -30.3043 168.638 -29.1753 168.638 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M117.01 2.47826C117.01 3.87098 115.726 5 114.142 5C112.558 5 111.274 3.87098 111.274 2.47826C111.274 1.08554 112.558 -0.0434761 114.142 -0.0434761C115.726 -0.0434761 117.01 1.08554 117.01 2.47826Z"
        fill="#060606"
      />
      <path
        d="M168.638 2.47826C168.638 3.87098 167.354 5 165.77 5C164.186 5 162.901 3.87098 162.901 2.47826C162.901 1.08554 164.186 -0.0434761 165.77 -0.0434761C167.354 -0.0434761 168.638 1.08554 168.638 2.47826Z"
        fill="#060606"
      />
      <path
        d="M134.219 -50.4783C134.219 -49.0855 132.935 -47.9565 131.351 -47.9565C129.767 -47.9565 128.483 -49.0855 128.483 -50.4783C128.483 -51.871 129.767 -53 131.351 -53C132.935 -53 134.219 -51.871 134.219 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M185.847 -50.4783C185.847 -49.0855 184.563 -47.9565 182.979 -47.9565C181.395 -47.9565 180.111 -49.0855 180.111 -50.4783C180.111 -51.871 181.395 -53 182.979 -53C184.563 -53 185.847 -51.871 185.847 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M134.219 -20.2174C134.219 -18.8247 132.935 -17.6957 131.351 -17.6957C129.767 -17.6957 128.483 -18.8247 128.483 -20.2174C128.483 -21.6101 129.767 -22.7391 131.351 -22.7391C132.935 -22.7391 134.219 -21.6101 134.219 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M185.847 -20.2174C185.847 -18.8247 184.563 -17.6957 182.979 -17.6957C181.395 -17.6957 180.111 -18.8247 180.111 -20.2174C180.111 -21.6101 181.395 -22.7391 182.979 -22.7391C184.563 -22.7391 185.847 -21.6101 185.847 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M134.219 -35.3478C134.219 -33.9551 132.935 -32.8261 131.351 -32.8261C129.767 -32.8261 128.483 -33.9551 128.483 -35.3478C128.483 -36.7405 129.767 -37.8696 131.351 -37.8696C132.935 -37.8696 134.219 -36.7405 134.219 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M185.847 -35.3478C185.847 -33.9551 184.563 -32.8261 182.979 -32.8261C181.395 -32.8261 180.111 -33.9551 180.111 -35.3478C180.111 -36.7405 181.395 -37.8696 182.979 -37.8696C184.563 -37.8696 185.847 -36.7405 185.847 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M134.219 -5.08696C134.219 -3.69424 132.935 -2.56522 131.351 -2.56522C129.767 -2.56522 128.483 -3.69424 128.483 -5.08696C128.483 -6.47968 129.767 -7.60869 131.351 -7.60869C132.935 -7.60869 134.219 -6.47968 134.219 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M185.847 -5.08696C185.847 -3.69424 184.563 -2.56522 182.979 -2.56522C181.395 -2.56522 180.111 -3.69424 180.111 -5.08696C180.111 -6.47968 181.395 -7.60869 182.979 -7.60869C184.563 -7.60869 185.847 -6.47968 185.847 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M134.219 -42.913C134.219 -41.5203 132.935 -40.3913 131.351 -40.3913C129.767 -40.3913 128.483 -41.5203 128.483 -42.913C128.483 -44.3058 129.767 -45.4348 131.351 -45.4348C132.935 -45.4348 134.219 -44.3058 134.219 -42.913Z"
        fill="#060606"
      />
      <path
        d="M185.847 -42.913C185.847 -41.5203 184.563 -40.3913 182.979 -40.3913C181.395 -40.3913 180.111 -41.5203 180.111 -42.913C180.111 -44.3058 181.395 -45.4348 182.979 -45.4348C184.563 -45.4348 185.847 -44.3058 185.847 -42.913Z"
        fill="#060606"
      />
      <path
        d="M134.219 -12.6522C134.219 -11.2595 132.935 -10.1304 131.351 -10.1304C129.767 -10.1304 128.483 -11.2595 128.483 -12.6522C128.483 -14.0449 129.767 -15.1739 131.351 -15.1739C132.935 -15.1739 134.219 -14.0449 134.219 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M185.847 -12.6522C185.847 -11.2595 184.563 -10.1304 182.979 -10.1304C181.395 -10.1304 180.111 -11.2595 180.111 -12.6522C180.111 -14.0449 181.395 -15.1739 182.979 -15.1739C184.563 -15.1739 185.847 -14.0449 185.847 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M134.219 -27.7826C134.219 -26.3899 132.935 -25.2609 131.351 -25.2609C129.767 -25.2609 128.483 -26.3899 128.483 -27.7826C128.483 -29.1753 129.767 -30.3043 131.351 -30.3043C132.935 -30.3043 134.219 -29.1753 134.219 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M185.847 -27.7826C185.847 -26.3899 184.563 -25.2609 182.979 -25.2609C181.395 -25.2609 180.111 -26.3899 180.111 -27.7826C180.111 -29.1753 181.395 -30.3043 182.979 -30.3043C184.563 -30.3043 185.847 -29.1753 185.847 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M134.219 2.47826C134.219 3.87098 132.935 5 131.351 5C129.767 5 128.483 3.87098 128.483 2.47826C128.483 1.08554 129.767 -0.0434761 131.351 -0.0434761C132.935 -0.0434761 134.219 1.08554 134.219 2.47826Z"
        fill="#060606"
      />
      <path
        d="M185.847 2.47826C185.847 3.87098 184.563 5 182.979 5C181.395 5 180.111 3.87098 180.111 2.47826C180.111 1.08554 181.395 -0.0434761 182.979 -0.0434761C184.563 -0.0434761 185.847 1.08554 185.847 2.47826Z"
        fill="#060606"
      />
      <path
        d="M151.429 -50.4783C151.429 -49.0855 150.144 -47.9565 148.56 -47.9565C146.976 -47.9565 145.692 -49.0855 145.692 -50.4783C145.692 -51.871 146.976 -53 148.56 -53C150.144 -53 151.429 -51.871 151.429 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M203.056 -50.4783C203.056 -49.0855 201.772 -47.9565 200.188 -47.9565C198.604 -47.9565 197.32 -49.0855 197.32 -50.4783C197.32 -51.871 198.604 -53 200.188 -53C201.772 -53 203.056 -51.871 203.056 -50.4783Z"
        fill="#060606"
      />
      <path
        d="M151.429 -20.2174C151.429 -18.8247 150.144 -17.6957 148.56 -17.6957C146.976 -17.6957 145.692 -18.8247 145.692 -20.2174C145.692 -21.6101 146.976 -22.7391 148.56 -22.7391C150.144 -22.7391 151.429 -21.6101 151.429 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M203.056 -20.2174C203.056 -18.8247 201.772 -17.6957 200.188 -17.6957C198.604 -17.6957 197.32 -18.8247 197.32 -20.2174C197.32 -21.6101 198.604 -22.7391 200.188 -22.7391C201.772 -22.7391 203.056 -21.6101 203.056 -20.2174Z"
        fill="#060606"
      />
      <path
        d="M151.429 -35.3478C151.429 -33.9551 150.144 -32.8261 148.56 -32.8261C146.976 -32.8261 145.692 -33.9551 145.692 -35.3478C145.692 -36.7405 146.976 -37.8696 148.56 -37.8696C150.144 -37.8696 151.429 -36.7405 151.429 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M203.056 -35.3478C203.056 -33.9551 201.772 -32.8261 200.188 -32.8261C198.604 -32.8261 197.32 -33.9551 197.32 -35.3478C197.32 -36.7405 198.604 -37.8696 200.188 -37.8696C201.772 -37.8696 203.056 -36.7405 203.056 -35.3478Z"
        fill="#060606"
      />
      <path
        d="M151.429 -5.08696C151.429 -3.69424 150.144 -2.56522 148.56 -2.56522C146.976 -2.56522 145.692 -3.69424 145.692 -5.08696C145.692 -6.47968 146.976 -7.60869 148.56 -7.60869C150.144 -7.60869 151.429 -6.47968 151.429 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M203.056 -5.08696C203.056 -3.69424 201.772 -2.56522 200.188 -2.56522C198.604 -2.56522 197.32 -3.69424 197.32 -5.08696C197.32 -6.47968 198.604 -7.60869 200.188 -7.60869C201.772 -7.60869 203.056 -6.47968 203.056 -5.08696Z"
        fill="#060606"
      />
      <path
        d="M151.429 -42.913C151.429 -41.5203 150.144 -40.3913 148.56 -40.3913C146.976 -40.3913 145.692 -41.5203 145.692 -42.913C145.692 -44.3058 146.976 -45.4348 148.56 -45.4348C150.144 -45.4348 151.429 -44.3058 151.429 -42.913Z"
        fill="#060606"
      />
      <path
        d="M203.056 -42.913C203.056 -41.5203 201.772 -40.3913 200.188 -40.3913C198.604 -40.3913 197.32 -41.5203 197.32 -42.913C197.32 -44.3058 198.604 -45.4348 200.188 -45.4348C201.772 -45.4348 203.056 -44.3058 203.056 -42.913Z"
        fill="#060606"
      />
      <path
        d="M151.429 -12.6522C151.429 -11.2595 150.144 -10.1304 148.56 -10.1304C146.976 -10.1304 145.692 -11.2595 145.692 -12.6522C145.692 -14.0449 146.976 -15.1739 148.56 -15.1739C150.144 -15.1739 151.429 -14.0449 151.429 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M203.056 -12.6522C203.056 -11.2595 201.772 -10.1304 200.188 -10.1304C198.604 -10.1304 197.32 -11.2595 197.32 -12.6522C197.32 -14.0449 198.604 -15.1739 200.188 -15.1739C201.772 -15.1739 203.056 -14.0449 203.056 -12.6522Z"
        fill="#060606"
      />
      <path
        d="M151.429 -27.7826C151.429 -26.3899 150.144 -25.2609 148.56 -25.2609C146.976 -25.2609 145.692 -26.3899 145.692 -27.7826C145.692 -29.1753 146.976 -30.3043 148.56 -30.3043C150.144 -30.3043 151.429 -29.1753 151.429 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M203.056 -27.7826C203.056 -26.3899 201.772 -25.2609 200.188 -25.2609C198.604 -25.2609 197.32 -26.3899 197.32 -27.7826C197.32 -29.1753 198.604 -30.3043 200.188 -30.3043C201.772 -30.3043 203.056 -29.1753 203.056 -27.7826Z"
        fill="#060606"
      />
      <path
        d="M151.429 2.47826C151.429 3.87098 150.144 5 148.56 5C146.976 5 145.692 3.87098 145.692 2.47826C145.692 1.08554 146.976 -0.0434761 148.56 -0.0434761C150.144 -0.0434761 151.429 1.08554 151.429 2.47826Z"
        fill="#060606"
      />
      <path
        d="M203.056 2.47826C203.056 3.87098 201.772 5 200.188 5C198.604 5 197.32 3.87098 197.32 2.47826C197.32 1.08554 198.604 -0.0434761 200.188 -0.0434761C201.772 -0.0434761 203.056 1.08554 203.056 2.47826Z"
        fill="#060606"
      />
      <path
        d="M108.405 69.5217C108.405 70.9145 107.121 72.0435 105.537 72.0435C103.953 72.0435 102.669 70.9145 102.669 69.5217C102.669 68.129 103.953 67 105.537 67C107.121 67 108.405 68.129 108.405 69.5217Z"
        fill="#060606"
      />
      <path
        d="M160.033 69.5217C160.033 70.9145 158.749 72.0435 157.165 72.0435C155.581 72.0435 154.297 70.9145 154.297 69.5217C154.297 68.129 155.581 67 157.165 67C158.749 67 160.033 68.129 160.033 69.5217Z"
        fill="#060606"
      />
      <path
        d="M108.405 99.7826C108.405 101.175 107.121 102.304 105.537 102.304C103.953 102.304 102.669 101.175 102.669 99.7826C102.669 98.3899 103.953 97.2609 105.537 97.2609C107.121 97.2609 108.405 98.3899 108.405 99.7826Z"
        fill="#060606"
      />
      <path
        d="M160.033 99.7826C160.033 101.175 158.749 102.304 157.165 102.304C155.581 102.304 154.297 101.175 154.297 99.7826C154.297 98.3899 155.581 97.2609 157.165 97.2609C158.749 97.2609 160.033 98.3899 160.033 99.7826Z"
        fill="#060606"
      />
      <path
        d="M108.405 84.6522C108.405 86.0449 107.121 87.1739 105.537 87.1739C103.953 87.1739 102.669 86.0449 102.669 84.6522C102.669 83.2595 103.953 82.1304 105.537 82.1304C107.121 82.1304 108.405 83.2595 108.405 84.6522Z"
        fill="#060606"
      />
      <path
        d="M160.033 84.6522C160.033 86.0449 158.749 87.1739 157.165 87.1739C155.581 87.1739 154.297 86.0449 154.297 84.6522C154.297 83.2595 155.581 82.1304 157.165 82.1304C158.749 82.1304 160.033 83.2595 160.033 84.6522Z"
        fill="#060606"
      />
      <path
        d="M108.405 114.913C108.405 116.306 107.121 117.435 105.537 117.435C103.953 117.435 102.669 116.306 102.669 114.913C102.669 113.52 103.953 112.391 105.537 112.391C107.121 112.391 108.405 113.52 108.405 114.913Z"
        fill="#060606"
      />
      <path
        d="M160.033 114.913C160.033 116.306 158.749 117.435 157.165 117.435C155.581 117.435 154.297 116.306 154.297 114.913C154.297 113.52 155.581 112.391 157.165 112.391C158.749 112.391 160.033 113.52 160.033 114.913Z"
        fill="#060606"
      />
      <path
        d="M108.405 77.087C108.405 78.4797 107.121 79.6087 105.537 79.6087C103.953 79.6087 102.669 78.4797 102.669 77.087C102.669 75.6942 103.953 74.5652 105.537 74.5652C107.121 74.5652 108.405 75.6942 108.405 77.087Z"
        fill="#060606"
      />
      <path
        d="M160.033 77.087C160.033 78.4797 158.749 79.6087 157.165 79.6087C155.581 79.6087 154.297 78.4797 154.297 77.087C154.297 75.6942 155.581 74.5652 157.165 74.5652C158.749 74.5652 160.033 75.6942 160.033 77.087Z"
        fill="#060606"
      />
      <path
        d="M108.405 107.348C108.405 108.741 107.121 109.87 105.537 109.87C103.953 109.87 102.669 108.741 102.669 107.348C102.669 105.955 103.953 104.826 105.537 104.826C107.121 104.826 108.405 105.955 108.405 107.348Z"
        fill="#060606"
      />
      <path
        d="M160.033 107.348C160.033 108.741 158.749 109.87 157.165 109.87C155.581 109.87 154.297 108.741 154.297 107.348C154.297 105.955 155.581 104.826 157.165 104.826C158.749 104.826 160.033 105.955 160.033 107.348Z"
        fill="#060606"
      />
      <path
        d="M108.405 92.2174C108.405 93.6101 107.121 94.7391 105.537 94.7391C103.953 94.7391 102.669 93.6101 102.669 92.2174C102.669 90.8247 103.953 89.6956 105.537 89.6956C107.121 89.6956 108.405 90.8247 108.405 92.2174Z"
        fill="#060606"
      />
      <path
        d="M160.033 92.2174C160.033 93.6101 158.749 94.7391 157.165 94.7391C155.581 94.7391 154.297 93.6101 154.297 92.2174C154.297 90.8247 155.581 89.6956 157.165 89.6956C158.749 89.6956 160.033 90.8247 160.033 92.2174Z"
        fill="#060606"
      />
      <path
        d="M108.405 122.478C108.405 123.871 107.121 125 105.537 125C103.953 125 102.669 123.871 102.669 122.478C102.669 121.086 103.953 119.957 105.537 119.957C107.121 119.957 108.405 121.086 108.405 122.478Z"
        fill="#060606"
      />
      <path
        d="M160.033 122.478C160.033 123.871 158.749 125 157.165 125C155.581 125 154.297 123.871 154.297 122.478C154.297 121.086 155.581 119.957 157.165 119.957C158.749 119.957 160.033 121.086 160.033 122.478Z"
        fill="#060606"
      />
      <path
        d="M125.615 69.5217C125.615 70.9145 124.331 72.0435 122.746 72.0435C121.162 72.0435 119.878 70.9145 119.878 69.5217C119.878 68.129 121.162 67 122.746 67C124.331 67 125.615 68.129 125.615 69.5217Z"
        fill="#060606"
      />
      <path
        d="M177.242 69.5217C177.242 70.9145 175.958 72.0435 174.374 72.0435C172.79 72.0435 171.506 70.9145 171.506 69.5217C171.506 68.129 172.79 67 174.374 67C175.958 67 177.242 68.129 177.242 69.5217Z"
        fill="#060606"
      />
      <path
        d="M125.615 99.7826C125.615 101.175 124.331 102.304 122.746 102.304C121.162 102.304 119.878 101.175 119.878 99.7826C119.878 98.3899 121.162 97.2609 122.746 97.2609C124.331 97.2609 125.615 98.3899 125.615 99.7826Z"
        fill="#060606"
      />
      <path
        d="M177.242 99.7826C177.242 101.175 175.958 102.304 174.374 102.304C172.79 102.304 171.506 101.175 171.506 99.7826C171.506 98.3899 172.79 97.2609 174.374 97.2609C175.958 97.2609 177.242 98.3899 177.242 99.7826Z"
        fill="#060606"
      />
      <path
        d="M125.615 84.6522C125.615 86.0449 124.331 87.1739 122.746 87.1739C121.162 87.1739 119.878 86.0449 119.878 84.6522C119.878 83.2595 121.162 82.1304 122.746 82.1304C124.331 82.1304 125.615 83.2595 125.615 84.6522Z"
        fill="#060606"
      />
      <path
        d="M177.242 84.6522C177.242 86.0449 175.958 87.1739 174.374 87.1739C172.79 87.1739 171.506 86.0449 171.506 84.6522C171.506 83.2595 172.79 82.1304 174.374 82.1304C175.958 82.1304 177.242 83.2595 177.242 84.6522Z"
        fill="#060606"
      />
      <path
        d="M125.615 114.913C125.615 116.306 124.331 117.435 122.746 117.435C121.162 117.435 119.878 116.306 119.878 114.913C119.878 113.52 121.162 112.391 122.746 112.391C124.331 112.391 125.615 113.52 125.615 114.913Z"
        fill="#060606"
      />
      <path
        d="M177.242 114.913C177.242 116.306 175.958 117.435 174.374 117.435C172.79 117.435 171.506 116.306 171.506 114.913C171.506 113.52 172.79 112.391 174.374 112.391C175.958 112.391 177.242 113.52 177.242 114.913Z"
        fill="#060606"
      />
      <path
        d="M125.615 77.087C125.615 78.4797 124.331 79.6087 122.746 79.6087C121.162 79.6087 119.878 78.4797 119.878 77.087C119.878 75.6942 121.162 74.5652 122.746 74.5652C124.331 74.5652 125.615 75.6942 125.615 77.087Z"
        fill="#060606"
      />
      <path
        d="M177.242 77.087C177.242 78.4797 175.958 79.6087 174.374 79.6087C172.79 79.6087 171.506 78.4797 171.506 77.087C171.506 75.6942 172.79 74.5652 174.374 74.5652C175.958 74.5652 177.242 75.6942 177.242 77.087Z"
        fill="#060606"
      />
      <path
        d="M125.615 107.348C125.615 108.741 124.331 109.87 122.746 109.87C121.162 109.87 119.878 108.741 119.878 107.348C119.878 105.955 121.162 104.826 122.746 104.826C124.331 104.826 125.615 105.955 125.615 107.348Z"
        fill="#060606"
      />
      <path
        d="M177.242 107.348C177.242 108.741 175.958 109.87 174.374 109.87C172.79 109.87 171.506 108.741 171.506 107.348C171.506 105.955 172.79 104.826 174.374 104.826C175.958 104.826 177.242 105.955 177.242 107.348Z"
        fill="#060606"
      />
      <path
        d="M125.615 92.2174C125.615 93.6101 124.331 94.7391 122.746 94.7391C121.162 94.7391 119.878 93.6101 119.878 92.2174C119.878 90.8247 121.162 89.6956 122.746 89.6956C124.331 89.6956 125.615 90.8247 125.615 92.2174Z"
        fill="#060606"
      />
      <path
        d="M177.242 92.2174C177.242 93.6101 175.958 94.7391 174.374 94.7391C172.79 94.7391 171.506 93.6101 171.506 92.2174C171.506 90.8247 172.79 89.6956 174.374 89.6956C175.958 89.6956 177.242 90.8247 177.242 92.2174Z"
        fill="#060606"
      />
      <path
        d="M125.615 122.478C125.615 123.871 124.331 125 122.746 125C121.162 125 119.878 123.871 119.878 122.478C119.878 121.086 121.162 119.957 122.746 119.957C124.331 119.957 125.615 121.086 125.615 122.478Z"
        fill="#060606"
      />
      <path
        d="M177.242 122.478C177.242 123.871 175.958 125 174.374 125C172.79 125 171.506 123.871 171.506 122.478C171.506 121.086 172.79 119.957 174.374 119.957C175.958 119.957 177.242 121.086 177.242 122.478Z"
        fill="#060606"
      />
      <path
        d="M142.824 69.5217C142.824 70.9145 141.54 72.0435 139.956 72.0435C138.372 72.0435 137.088 70.9145 137.088 69.5217C137.088 68.129 138.372 67 139.956 67C141.54 67 142.824 68.129 142.824 69.5217Z"
        fill="#060606"
      />
      <path
        d="M194.452 69.5217C194.452 70.9145 193.168 72.0435 191.584 72.0435C189.999 72.0435 188.715 70.9145 188.715 69.5217C188.715 68.129 189.999 67 191.584 67C193.168 67 194.452 68.129 194.452 69.5217Z"
        fill="#060606"
      />
      <path
        d="M142.824 99.7826C142.824 101.175 141.54 102.304 139.956 102.304C138.372 102.304 137.088 101.175 137.088 99.7826C137.088 98.3899 138.372 97.2609 139.956 97.2609C141.54 97.2609 142.824 98.3899 142.824 99.7826Z"
        fill="#060606"
      />
      <path
        d="M194.452 99.7826C194.452 101.175 193.168 102.304 191.584 102.304C189.999 102.304 188.715 101.175 188.715 99.7826C188.715 98.3899 189.999 97.2609 191.584 97.2609C193.168 97.2609 194.452 98.3899 194.452 99.7826Z"
        fill="#060606"
      />
      <path
        d="M142.824 84.6522C142.824 86.0449 141.54 87.1739 139.956 87.1739C138.372 87.1739 137.088 86.0449 137.088 84.6522C137.088 83.2595 138.372 82.1304 139.956 82.1304C141.54 82.1304 142.824 83.2595 142.824 84.6522Z"
        fill="#060606"
      />
      <path
        d="M194.452 84.6522C194.452 86.0449 193.168 87.1739 191.584 87.1739C189.999 87.1739 188.715 86.0449 188.715 84.6522C188.715 83.2595 189.999 82.1304 191.584 82.1304C193.168 82.1304 194.452 83.2595 194.452 84.6522Z"
        fill="#060606"
      />
      <path
        d="M142.824 114.913C142.824 116.306 141.54 117.435 139.956 117.435C138.372 117.435 137.088 116.306 137.088 114.913C137.088 113.52 138.372 112.391 139.956 112.391C141.54 112.391 142.824 113.52 142.824 114.913Z"
        fill="#060606"
      />
      <path
        d="M194.452 114.913C194.452 116.306 193.168 117.435 191.584 117.435C189.999 117.435 188.715 116.306 188.715 114.913C188.715 113.52 189.999 112.391 191.584 112.391C193.168 112.391 194.452 113.52 194.452 114.913Z"
        fill="#060606"
      />
      <path
        d="M142.824 77.087C142.824 78.4797 141.54 79.6087 139.956 79.6087C138.372 79.6087 137.088 78.4797 137.088 77.087C137.088 75.6942 138.372 74.5652 139.956 74.5652C141.54 74.5652 142.824 75.6942 142.824 77.087Z"
        fill="#060606"
      />
      <path
        d="M194.452 77.087C194.452 78.4797 193.168 79.6087 191.584 79.6087C189.999 79.6087 188.715 78.4797 188.715 77.087C188.715 75.6942 189.999 74.5652 191.584 74.5652C193.168 74.5652 194.452 75.6942 194.452 77.087Z"
        fill="#060606"
      />
      <path
        d="M142.824 107.348C142.824 108.741 141.54 109.87 139.956 109.87C138.372 109.87 137.088 108.741 137.088 107.348C137.088 105.955 138.372 104.826 139.956 104.826C141.54 104.826 142.824 105.955 142.824 107.348Z"
        fill="#060606"
      />
      <path
        d="M194.452 107.348C194.452 108.741 193.168 109.87 191.584 109.87C189.999 109.87 188.715 108.741 188.715 107.348C188.715 105.955 189.999 104.826 191.584 104.826C193.168 104.826 194.452 105.955 194.452 107.348Z"
        fill="#060606"
      />
      <path
        d="M142.824 92.2174C142.824 93.6101 141.54 94.7391 139.956 94.7391C138.372 94.7391 137.088 93.6101 137.088 92.2174C137.088 90.8247 138.372 89.6956 139.956 89.6956C141.54 89.6956 142.824 90.8247 142.824 92.2174Z"
        fill="#060606"
      />
      <path
        d="M194.452 92.2174C194.452 93.6101 193.168 94.7391 191.584 94.7391C189.999 94.7391 188.715 93.6101 188.715 92.2174C188.715 90.8247 189.999 89.6956 191.584 89.6956C193.168 89.6956 194.452 90.8247 194.452 92.2174Z"
        fill="#060606"
      />
      <path
        d="M142.824 122.478C142.824 123.871 141.54 125 139.956 125C138.372 125 137.088 123.871 137.088 122.478C137.088 121.086 138.372 119.957 139.956 119.957C141.54 119.957 142.824 121.086 142.824 122.478Z"
        fill="#060606"
      />
      <path
        d="M194.452 122.478C194.452 123.871 193.168 125 191.584 125C189.999 125 188.715 123.871 188.715 122.478C188.715 121.086 189.999 119.957 191.584 119.957C193.168 119.957 194.452 121.086 194.452 122.478Z"
        fill="#060606"
      />
      <path
        d="M117.01 69.5217C117.01 70.9145 115.726 72.0435 114.142 72.0435C112.558 72.0435 111.274 70.9145 111.274 69.5217C111.274 68.129 112.558 67 114.142 67C115.726 67 117.01 68.129 117.01 69.5217Z"
        fill="#060606"
      />
      <path
        d="M168.638 69.5217C168.638 70.9145 167.354 72.0435 165.77 72.0435C164.186 72.0435 162.901 70.9145 162.901 69.5217C162.901 68.129 164.186 67 165.77 67C167.354 67 168.638 68.129 168.638 69.5217Z"
        fill="#060606"
      />
      <path
        d="M117.01 99.7826C117.01 101.175 115.726 102.304 114.142 102.304C112.558 102.304 111.274 101.175 111.274 99.7826C111.274 98.3899 112.558 97.2609 114.142 97.2609C115.726 97.2609 117.01 98.3899 117.01 99.7826Z"
        fill="#060606"
      />
      <path
        d="M168.638 99.7826C168.638 101.175 167.354 102.304 165.77 102.304C164.186 102.304 162.901 101.175 162.901 99.7826C162.901 98.3899 164.186 97.2609 165.77 97.2609C167.354 97.2609 168.638 98.3899 168.638 99.7826Z"
        fill="#060606"
      />
      <path
        d="M117.01 84.6522C117.01 86.0449 115.726 87.1739 114.142 87.1739C112.558 87.1739 111.274 86.0449 111.274 84.6522C111.274 83.2595 112.558 82.1304 114.142 82.1304C115.726 82.1304 117.01 83.2595 117.01 84.6522Z"
        fill="#060606"
      />
      <path
        d="M168.638 84.6522C168.638 86.0449 167.354 87.1739 165.77 87.1739C164.186 87.1739 162.901 86.0449 162.901 84.6522C162.901 83.2595 164.186 82.1304 165.77 82.1304C167.354 82.1304 168.638 83.2595 168.638 84.6522Z"
        fill="#060606"
      />
      <path
        d="M117.01 114.913C117.01 116.306 115.726 117.435 114.142 117.435C112.558 117.435 111.274 116.306 111.274 114.913C111.274 113.52 112.558 112.391 114.142 112.391C115.726 112.391 117.01 113.52 117.01 114.913Z"
        fill="#060606"
      />
      <path
        d="M168.638 114.913C168.638 116.306 167.354 117.435 165.77 117.435C164.186 117.435 162.901 116.306 162.901 114.913C162.901 113.52 164.186 112.391 165.77 112.391C167.354 112.391 168.638 113.52 168.638 114.913Z"
        fill="#060606"
      />
      <path
        d="M117.01 77.087C117.01 78.4797 115.726 79.6087 114.142 79.6087C112.558 79.6087 111.274 78.4797 111.274 77.087C111.274 75.6942 112.558 74.5652 114.142 74.5652C115.726 74.5652 117.01 75.6942 117.01 77.087Z"
        fill="#060606"
      />
      <path
        d="M168.638 77.087C168.638 78.4797 167.354 79.6087 165.77 79.6087C164.186 79.6087 162.901 78.4797 162.901 77.087C162.901 75.6942 164.186 74.5652 165.77 74.5652C167.354 74.5652 168.638 75.6942 168.638 77.087Z"
        fill="#060606"
      />
      <path
        d="M117.01 107.348C117.01 108.741 115.726 109.87 114.142 109.87C112.558 109.87 111.274 108.741 111.274 107.348C111.274 105.955 112.558 104.826 114.142 104.826C115.726 104.826 117.01 105.955 117.01 107.348Z"
        fill="#060606"
      />
      <path
        d="M168.638 107.348C168.638 108.741 167.354 109.87 165.77 109.87C164.186 109.87 162.901 108.741 162.901 107.348C162.901 105.955 164.186 104.826 165.77 104.826C167.354 104.826 168.638 105.955 168.638 107.348Z"
        fill="#060606"
      />
      <path
        d="M117.01 92.2174C117.01 93.6101 115.726 94.7391 114.142 94.7391C112.558 94.7391 111.274 93.6101 111.274 92.2174C111.274 90.8247 112.558 89.6956 114.142 89.6956C115.726 89.6956 117.01 90.8247 117.01 92.2174Z"
        fill="#060606"
      />
      <path
        d="M168.638 92.2174C168.638 93.6101 167.354 94.7391 165.77 94.7391C164.186 94.7391 162.901 93.6101 162.901 92.2174C162.901 90.8247 164.186 89.6956 165.77 89.6956C167.354 89.6956 168.638 90.8247 168.638 92.2174Z"
        fill="#060606"
      />
      <path
        d="M117.01 122.478C117.01 123.871 115.726 125 114.142 125C112.558 125 111.274 123.871 111.274 122.478C111.274 121.086 112.558 119.957 114.142 119.957C115.726 119.957 117.01 121.086 117.01 122.478Z"
        fill="#060606"
      />
      <path
        d="M168.638 122.478C168.638 123.871 167.354 125 165.77 125C164.186 125 162.901 123.871 162.901 122.478C162.901 121.086 164.186 119.957 165.77 119.957C167.354 119.957 168.638 121.086 168.638 122.478Z"
        fill="#060606"
      />
      <path
        d="M134.219 69.5217C134.219 70.9145 132.935 72.0435 131.351 72.0435C129.767 72.0435 128.483 70.9145 128.483 69.5217C128.483 68.129 129.767 67 131.351 67C132.935 67 134.219 68.129 134.219 69.5217Z"
        fill="#060606"
      />
      <path
        d="M185.847 69.5217C185.847 70.9145 184.563 72.0435 182.979 72.0435C181.395 72.0435 180.111 70.9145 180.111 69.5217C180.111 68.129 181.395 67 182.979 67C184.563 67 185.847 68.129 185.847 69.5217Z"
        fill="#060606"
      />
      <path
        d="M134.219 99.7826C134.219 101.175 132.935 102.304 131.351 102.304C129.767 102.304 128.483 101.175 128.483 99.7826C128.483 98.3899 129.767 97.2609 131.351 97.2609C132.935 97.2609 134.219 98.3899 134.219 99.7826Z"
        fill="#060606"
      />
      <path
        d="M185.847 99.7826C185.847 101.175 184.563 102.304 182.979 102.304C181.395 102.304 180.111 101.175 180.111 99.7826C180.111 98.3899 181.395 97.2609 182.979 97.2609C184.563 97.2609 185.847 98.3899 185.847 99.7826Z"
        fill="#060606"
      />
      <path
        d="M134.219 84.6522C134.219 86.0449 132.935 87.1739 131.351 87.1739C129.767 87.1739 128.483 86.0449 128.483 84.6522C128.483 83.2595 129.767 82.1304 131.351 82.1304C132.935 82.1304 134.219 83.2595 134.219 84.6522Z"
        fill="#060606"
      />
      <path
        d="M185.847 84.6522C185.847 86.0449 184.563 87.1739 182.979 87.1739C181.395 87.1739 180.111 86.0449 180.111 84.6522C180.111 83.2595 181.395 82.1304 182.979 82.1304C184.563 82.1304 185.847 83.2595 185.847 84.6522Z"
        fill="#060606"
      />
      <path
        d="M134.219 114.913C134.219 116.306 132.935 117.435 131.351 117.435C129.767 117.435 128.483 116.306 128.483 114.913C128.483 113.52 129.767 112.391 131.351 112.391C132.935 112.391 134.219 113.52 134.219 114.913Z"
        fill="#060606"
      />
      <path
        d="M185.847 114.913C185.847 116.306 184.563 117.435 182.979 117.435C181.395 117.435 180.111 116.306 180.111 114.913C180.111 113.52 181.395 112.391 182.979 112.391C184.563 112.391 185.847 113.52 185.847 114.913Z"
        fill="#060606"
      />
      <path
        d="M134.219 77.087C134.219 78.4797 132.935 79.6087 131.351 79.6087C129.767 79.6087 128.483 78.4797 128.483 77.087C128.483 75.6942 129.767 74.5652 131.351 74.5652C132.935 74.5652 134.219 75.6942 134.219 77.087Z"
        fill="#060606"
      />
      <path
        d="M185.847 77.087C185.847 78.4797 184.563 79.6087 182.979 79.6087C181.395 79.6087 180.111 78.4797 180.111 77.087C180.111 75.6942 181.395 74.5652 182.979 74.5652C184.563 74.5652 185.847 75.6942 185.847 77.087Z"
        fill="#060606"
      />
      <path
        d="M134.219 107.348C134.219 108.741 132.935 109.87 131.351 109.87C129.767 109.87 128.483 108.741 128.483 107.348C128.483 105.955 129.767 104.826 131.351 104.826C132.935 104.826 134.219 105.955 134.219 107.348Z"
        fill="#060606"
      />
      <path
        d="M185.847 107.348C185.847 108.741 184.563 109.87 182.979 109.87C181.395 109.87 180.111 108.741 180.111 107.348C180.111 105.955 181.395 104.826 182.979 104.826C184.563 104.826 185.847 105.955 185.847 107.348Z"
        fill="#060606"
      />
      <path
        d="M134.219 92.2174C134.219 93.6101 132.935 94.7391 131.351 94.7391C129.767 94.7391 128.483 93.6101 128.483 92.2174C128.483 90.8247 129.767 89.6956 131.351 89.6956C132.935 89.6956 134.219 90.8247 134.219 92.2174Z"
        fill="#060606"
      />
      <path
        d="M185.847 92.2174C185.847 93.6101 184.563 94.7391 182.979 94.7391C181.395 94.7391 180.111 93.6101 180.111 92.2174C180.111 90.8247 181.395 89.6956 182.979 89.6956C184.563 89.6956 185.847 90.8247 185.847 92.2174Z"
        fill="#060606"
      />
      <path
        d="M134.219 122.478C134.219 123.871 132.935 125 131.351 125C129.767 125 128.483 123.871 128.483 122.478C128.483 121.086 129.767 119.957 131.351 119.957C132.935 119.957 134.219 121.086 134.219 122.478Z"
        fill="#060606"
      />
      <path
        d="M185.847 122.478C185.847 123.871 184.563 125 182.979 125C181.395 125 180.111 123.871 180.111 122.478C180.111 121.086 181.395 119.957 182.979 119.957C184.563 119.957 185.847 121.086 185.847 122.478Z"
        fill="#060606"
      />
      <path
        d="M151.429 69.5217C151.429 70.9145 150.144 72.0435 148.56 72.0435C146.976 72.0435 145.692 70.9145 145.692 69.5217C145.692 68.129 146.976 67 148.56 67C150.144 67 151.429 68.129 151.429 69.5217Z"
        fill="#060606"
      />
      <path
        d="M203.056 69.5217C203.056 70.9145 201.772 72.0435 200.188 72.0435C198.604 72.0435 197.32 70.9145 197.32 69.5217C197.32 68.129 198.604 67 200.188 67C201.772 67 203.056 68.129 203.056 69.5217Z"
        fill="#060606"
      />
      <path
        d="M151.429 99.7826C151.429 101.175 150.144 102.304 148.56 102.304C146.976 102.304 145.692 101.175 145.692 99.7826C145.692 98.3899 146.976 97.2609 148.56 97.2609C150.144 97.2609 151.429 98.3899 151.429 99.7826Z"
        fill="#060606"
      />
      <path
        d="M203.056 99.7826C203.056 101.175 201.772 102.304 200.188 102.304C198.604 102.304 197.32 101.175 197.32 99.7826C197.32 98.3899 198.604 97.2609 200.188 97.2609C201.772 97.2609 203.056 98.3899 203.056 99.7826Z"
        fill="#060606"
      />
      <path
        d="M151.429 84.6522C151.429 86.0449 150.144 87.1739 148.56 87.1739C146.976 87.1739 145.692 86.0449 145.692 84.6522C145.692 83.2595 146.976 82.1304 148.56 82.1304C150.144 82.1304 151.429 83.2595 151.429 84.6522Z"
        fill="#060606"
      />
      <path
        d="M203.056 84.6522C203.056 86.0449 201.772 87.1739 200.188 87.1739C198.604 87.1739 197.32 86.0449 197.32 84.6522C197.32 83.2595 198.604 82.1304 200.188 82.1304C201.772 82.1304 203.056 83.2595 203.056 84.6522Z"
        fill="#060606"
      />
      <path
        d="M151.429 114.913C151.429 116.306 150.144 117.435 148.56 117.435C146.976 117.435 145.692 116.306 145.692 114.913C145.692 113.52 146.976 112.391 148.56 112.391C150.144 112.391 151.429 113.52 151.429 114.913Z"
        fill="#060606"
      />
      <path
        d="M203.056 114.913C203.056 116.306 201.772 117.435 200.188 117.435C198.604 117.435 197.32 116.306 197.32 114.913C197.32 113.52 198.604 112.391 200.188 112.391C201.772 112.391 203.056 113.52 203.056 114.913Z"
        fill="#060606"
      />
      <path
        d="M151.429 77.087C151.429 78.4797 150.144 79.6087 148.56 79.6087C146.976 79.6087 145.692 78.4797 145.692 77.087C145.692 75.6942 146.976 74.5652 148.56 74.5652C150.144 74.5652 151.429 75.6942 151.429 77.087Z"
        fill="#060606"
      />
      <path
        d="M203.056 77.087C203.056 78.4797 201.772 79.6087 200.188 79.6087C198.604 79.6087 197.32 78.4797 197.32 77.087C197.32 75.6942 198.604 74.5652 200.188 74.5652C201.772 74.5652 203.056 75.6942 203.056 77.087Z"
        fill="#060606"
      />
      <path
        d="M151.429 107.348C151.429 108.741 150.144 109.87 148.56 109.87C146.976 109.87 145.692 108.741 145.692 107.348C145.692 105.955 146.976 104.826 148.56 104.826C150.144 104.826 151.429 105.955 151.429 107.348Z"
        fill="#060606"
      />
      <path
        d="M203.056 107.348C203.056 108.741 201.772 109.87 200.188 109.87C198.604 109.87 197.32 108.741 197.32 107.348C197.32 105.955 198.604 104.826 200.188 104.826C201.772 104.826 203.056 105.955 203.056 107.348Z"
        fill="#060606"
      />
      <path
        d="M151.429 92.2174C151.429 93.6101 150.144 94.7391 148.56 94.7391C146.976 94.7391 145.692 93.6101 145.692 92.2174C145.692 90.8247 146.976 89.6956 148.56 89.6956C150.144 89.6956 151.429 90.8247 151.429 92.2174Z"
        fill="#060606"
      />
      <path
        d="M203.056 92.2174C203.056 93.6101 201.772 94.7391 200.188 94.7391C198.604 94.7391 197.32 93.6101 197.32 92.2174C197.32 90.8247 198.604 89.6956 200.188 89.6956C201.772 89.6956 203.056 90.8247 203.056 92.2174Z"
        fill="#060606"
      />
      <path
        d="M151.429 122.478C151.429 123.871 150.144 125 148.56 125C146.976 125 145.692 123.871 145.692 122.478C145.692 121.086 146.976 119.957 148.56 119.957C150.144 119.957 151.429 121.086 151.429 122.478Z"
        fill="#060606"
      />
      <path
        d="M203.056 122.478C203.056 123.871 201.772 125 200.188 125C198.604 125 197.32 123.871 197.32 122.478C197.32 121.086 198.604 119.957 200.188 119.957C201.772 119.957 203.056 121.086 203.056 122.478Z"
        fill="#060606"
      />
      <path
        d="M5.73642 9.52174C5.73642 10.9145 4.45228 12.0435 2.86821 12.0435C1.28414 12.0435 0 10.9145 0 9.52174C0 8.12902 1.28414 7 2.86821 7C4.45228 7 5.73642 8.12902 5.73642 9.52174Z"
        fill="#060606"
      />
      <path
        d="M57.3642 9.52174C57.3642 10.9145 56.0801 12.0435 54.496 12.0435C52.912 12.0435 51.6278 10.9145 51.6278 9.52174C51.6278 8.12902 52.912 7 54.496 7C56.0801 7 57.3642 8.12902 57.3642 9.52174Z"
        fill="#060606"
      />
      <path
        d="M5.73642 39.7826C5.73642 41.1753 4.45228 42.3044 2.86821 42.3044C1.28414 42.3044 0 41.1753 0 39.7826C0 38.3899 1.28414 37.2609 2.86821 37.2609C4.45228 37.2609 5.73642 38.3899 5.73642 39.7826Z"
        fill="#060606"
      />
      <path
        d="M57.3642 39.7826C57.3642 41.1753 56.0801 42.3044 54.496 42.3044C52.912 42.3044 51.6278 41.1753 51.6278 39.7826C51.6278 38.3899 52.912 37.2609 54.496 37.2609C56.0801 37.2609 57.3642 38.3899 57.3642 39.7826Z"
        fill="#060606"
      />
      <path
        d="M5.73642 24.6522C5.73642 26.0449 4.45228 27.1739 2.86821 27.1739C1.28414 27.1739 0 26.0449 0 24.6522C0 23.2595 1.28414 22.1304 2.86821 22.1304C4.45228 22.1304 5.73642 23.2595 5.73642 24.6522Z"
        fill="#060606"
      />
      <path
        d="M57.3642 24.6522C57.3642 26.0449 56.0801 27.1739 54.496 27.1739C52.912 27.1739 51.6278 26.0449 51.6278 24.6522C51.6278 23.2595 52.912 22.1304 54.496 22.1304C56.0801 22.1304 57.3642 23.2595 57.3642 24.6522Z"
        fill="#060606"
      />
      <path
        d="M5.73642 54.913C5.73642 56.3058 4.45228 57.4348 2.86821 57.4348C1.28414 57.4348 0 56.3058 0 54.913C0 53.5203 1.28414 52.3913 2.86821 52.3913C4.45228 52.3913 5.73642 53.5203 5.73642 54.913Z"
        fill="#060606"
      />
      <path
        d="M57.3642 54.913C57.3642 56.3058 56.0801 57.4348 54.496 57.4348C52.912 57.4348 51.6278 56.3058 51.6278 54.913C51.6278 53.5203 52.912 52.3913 54.496 52.3913C56.0801 52.3913 57.3642 53.5203 57.3642 54.913Z"
        fill="#060606"
      />
      <path
        d="M5.73642 17.087C5.73642 18.4797 4.45228 19.6087 2.86821 19.6087C1.28414 19.6087 0 18.4797 0 17.087C0 15.6942 1.28414 14.5652 2.86821 14.5652C4.45228 14.5652 5.73642 15.6942 5.73642 17.087Z"
        fill="#060606"
      />
      <path
        d="M57.3642 17.087C57.3642 18.4797 56.0801 19.6087 54.496 19.6087C52.912 19.6087 51.6278 18.4797 51.6278 17.087C51.6278 15.6942 52.912 14.5652 54.496 14.5652C56.0801 14.5652 57.3642 15.6942 57.3642 17.087Z"
        fill="#060606"
      />
      <path
        d="M5.73642 47.3478C5.73642 48.7405 4.45228 49.8696 2.86821 49.8696C1.28414 49.8696 0 48.7405 0 47.3478C0 45.9551 1.28414 44.8261 2.86821 44.8261C4.45228 44.8261 5.73642 45.9551 5.73642 47.3478Z"
        fill="#060606"
      />
      <path
        d="M57.3642 47.3478C57.3642 48.7405 56.0801 49.8696 54.496 49.8696C52.912 49.8696 51.6278 48.7405 51.6278 47.3478C51.6278 45.9551 52.912 44.8261 54.496 44.8261C56.0801 44.8261 57.3642 45.9551 57.3642 47.3478Z"
        fill="#060606"
      />
      <path
        d="M5.73642 32.2174C5.73642 33.6101 4.45228 34.7391 2.86821 34.7391C1.28414 34.7391 0 33.6101 0 32.2174C0 30.8247 1.28414 29.6957 2.86821 29.6957C4.45228 29.6957 5.73642 30.8247 5.73642 32.2174Z"
        fill="#060606"
      />
      <path
        d="M57.3642 32.2174C57.3642 33.6101 56.0801 34.7391 54.496 34.7391C52.912 34.7391 51.6278 33.6101 51.6278 32.2174C51.6278 30.8247 52.912 29.6957 54.496 29.6957C56.0801 29.6957 57.3642 30.8247 57.3642 32.2174Z"
        fill="#060606"
      />
      <path
        d="M5.73642 62.4783C5.73642 63.871 4.45228 65 2.86821 65C1.28414 65 0 63.871 0 62.4783C0 61.0855 1.28414 59.9565 2.86821 59.9565C4.45228 59.9565 5.73642 61.0855 5.73642 62.4783Z"
        fill="#060606"
      />
      <path
        d="M57.3642 62.4783C57.3642 63.871 56.0801 65 54.496 65C52.912 65 51.6278 63.871 51.6278 62.4783C51.6278 61.0855 52.912 59.9565 54.496 59.9565C56.0801 59.9565 57.3642 61.0855 57.3642 62.4783Z"
        fill="#060606"
      />
      <path
        d="M22.9457 9.52174C22.9457 10.9145 21.6616 12.0435 20.0775 12.0435C18.4934 12.0435 17.2093 10.9145 17.2093 9.52174C17.2093 8.12902 18.4934 7 20.0775 7C21.6616 7 22.9457 8.12902 22.9457 9.52174Z"
        fill="#060606"
      />
      <path
        d="M74.5735 9.52174C74.5735 10.9145 73.2894 12.0435 71.7053 12.0435C70.1212 12.0435 68.8371 10.9145 68.8371 9.52174C68.8371 8.12902 70.1212 7 71.7053 7C73.2894 7 74.5735 8.12902 74.5735 9.52174Z"
        fill="#060606"
      />
      <path
        d="M22.9457 39.7826C22.9457 41.1753 21.6616 42.3044 20.0775 42.3044C18.4934 42.3044 17.2093 41.1753 17.2093 39.7826C17.2093 38.3899 18.4934 37.2609 20.0775 37.2609C21.6616 37.2609 22.9457 38.3899 22.9457 39.7826Z"
        fill="#060606"
      />
      <path
        d="M74.5735 39.7826C74.5735 41.1753 73.2894 42.3044 71.7053 42.3044C70.1212 42.3044 68.8371 41.1753 68.8371 39.7826C68.8371 38.3899 70.1212 37.2609 71.7053 37.2609C73.2894 37.2609 74.5735 38.3899 74.5735 39.7826Z"
        fill="#060606"
      />
      <path
        d="M22.9457 24.6522C22.9457 26.0449 21.6616 27.1739 20.0775 27.1739C18.4934 27.1739 17.2093 26.0449 17.2093 24.6522C17.2093 23.2595 18.4934 22.1304 20.0775 22.1304C21.6616 22.1304 22.9457 23.2595 22.9457 24.6522Z"
        fill="#060606"
      />
      <path
        d="M74.5735 24.6522C74.5735 26.0449 73.2894 27.1739 71.7053 27.1739C70.1212 27.1739 68.8371 26.0449 68.8371 24.6522C68.8371 23.2595 70.1212 22.1304 71.7053 22.1304C73.2894 22.1304 74.5735 23.2595 74.5735 24.6522Z"
        fill="#060606"
      />
      <path
        d="M22.9457 54.913C22.9457 56.3058 21.6616 57.4348 20.0775 57.4348C18.4934 57.4348 17.2093 56.3058 17.2093 54.913C17.2093 53.5203 18.4934 52.3913 20.0775 52.3913C21.6616 52.3913 22.9457 53.5203 22.9457 54.913Z"
        fill="#060606"
      />
      <path
        d="M74.5735 54.913C74.5735 56.3058 73.2894 57.4348 71.7053 57.4348C70.1212 57.4348 68.8371 56.3058 68.8371 54.913C68.8371 53.5203 70.1212 52.3913 71.7053 52.3913C73.2894 52.3913 74.5735 53.5203 74.5735 54.913Z"
        fill="#060606"
      />
      <path
        d="M22.9457 17.087C22.9457 18.4797 21.6616 19.6087 20.0775 19.6087C18.4934 19.6087 17.2093 18.4797 17.2093 17.087C17.2093 15.6942 18.4934 14.5652 20.0775 14.5652C21.6616 14.5652 22.9457 15.6942 22.9457 17.087Z"
        fill="#060606"
      />
      <path
        d="M74.5735 17.087C74.5735 18.4797 73.2894 19.6087 71.7053 19.6087C70.1212 19.6087 68.8371 18.4797 68.8371 17.087C68.8371 15.6942 70.1212 14.5652 71.7053 14.5652C73.2894 14.5652 74.5735 15.6942 74.5735 17.087Z"
        fill="#060606"
      />
      <path
        d="M22.9457 47.3478C22.9457 48.7405 21.6616 49.8696 20.0775 49.8696C18.4934 49.8696 17.2093 48.7405 17.2093 47.3478C17.2093 45.9551 18.4934 44.8261 20.0775 44.8261C21.6616 44.8261 22.9457 45.9551 22.9457 47.3478Z"
        fill="#060606"
      />
      <path
        d="M74.5735 47.3478C74.5735 48.7405 73.2894 49.8696 71.7053 49.8696C70.1212 49.8696 68.8371 48.7405 68.8371 47.3478C68.8371 45.9551 70.1212 44.8261 71.7053 44.8261C73.2894 44.8261 74.5735 45.9551 74.5735 47.3478Z"
        fill="#060606"
      />
      <path
        d="M22.9457 32.2174C22.9457 33.6101 21.6616 34.7391 20.0775 34.7391C18.4934 34.7391 17.2093 33.6101 17.2093 32.2174C17.2093 30.8247 18.4934 29.6957 20.0775 29.6957C21.6616 29.6957 22.9457 30.8247 22.9457 32.2174Z"
        fill="#060606"
      />
      <path
        d="M74.5735 32.2174C74.5735 33.6101 73.2894 34.7391 71.7053 34.7391C70.1212 34.7391 68.8371 33.6101 68.8371 32.2174C68.8371 30.8247 70.1212 29.6957 71.7053 29.6957C73.2894 29.6957 74.5735 30.8247 74.5735 32.2174Z"
        fill="#060606"
      />
      <path
        d="M22.9457 62.4783C22.9457 63.871 21.6616 65 20.0775 65C18.4934 65 17.2093 63.871 17.2093 62.4783C17.2093 61.0855 18.4934 59.9565 20.0775 59.9565C21.6616 59.9565 22.9457 61.0855 22.9457 62.4783Z"
        fill="#060606"
      />
      <path
        d="M74.5735 62.4783C74.5735 63.871 73.2894 65 71.7053 65C70.1212 65 68.8371 63.871 68.8371 62.4783C68.8371 61.0855 70.1212 59.9565 71.7053 59.9565C73.2894 59.9565 74.5735 61.0855 74.5735 62.4783Z"
        fill="#060606"
      />
      <path
        d="M40.155 9.52174C40.155 10.9145 38.8708 12.0435 37.2868 12.0435C35.7027 12.0435 34.4185 10.9145 34.4185 9.52174C34.4185 8.12902 35.7027 7 37.2868 7C38.8708 7 40.155 8.12902 40.155 9.52174Z"
        fill="#060606"
      />
      <path
        d="M91.7828 9.52174C91.7828 10.9145 90.4986 12.0435 88.9146 12.0435C87.3305 12.0435 86.0464 10.9145 86.0464 9.52174C86.0464 8.12902 87.3305 7 88.9146 7C90.4986 7 91.7828 8.12902 91.7828 9.52174Z"
        fill="#060606"
      />
      <path
        d="M40.155 39.7826C40.155 41.1753 38.8708 42.3044 37.2868 42.3044C35.7027 42.3044 34.4185 41.1753 34.4185 39.7826C34.4185 38.3899 35.7027 37.2609 37.2868 37.2609C38.8708 37.2609 40.155 38.3899 40.155 39.7826Z"
        fill="#060606"
      />
      <path
        d="M91.7828 39.7826C91.7828 41.1753 90.4986 42.3044 88.9146 42.3044C87.3305 42.3044 86.0464 41.1753 86.0464 39.7826C86.0464 38.3899 87.3305 37.2609 88.9146 37.2609C90.4986 37.2609 91.7828 38.3899 91.7828 39.7826Z"
        fill="#060606"
      />
      <path
        d="M40.155 24.6522C40.155 26.0449 38.8708 27.1739 37.2868 27.1739C35.7027 27.1739 34.4185 26.0449 34.4185 24.6522C34.4185 23.2595 35.7027 22.1304 37.2868 22.1304C38.8708 22.1304 40.155 23.2595 40.155 24.6522Z"
        fill="#060606"
      />
      <path
        d="M91.7828 24.6522C91.7828 26.0449 90.4986 27.1739 88.9146 27.1739C87.3305 27.1739 86.0464 26.0449 86.0464 24.6522C86.0464 23.2595 87.3305 22.1304 88.9146 22.1304C90.4986 22.1304 91.7828 23.2595 91.7828 24.6522Z"
        fill="#060606"
      />
      <path
        d="M40.155 54.913C40.155 56.3058 38.8708 57.4348 37.2868 57.4348C35.7027 57.4348 34.4185 56.3058 34.4185 54.913C34.4185 53.5203 35.7027 52.3913 37.2868 52.3913C38.8708 52.3913 40.155 53.5203 40.155 54.913Z"
        fill="#060606"
      />
      <path
        d="M91.7828 54.913C91.7828 56.3058 90.4986 57.4348 88.9146 57.4348C87.3305 57.4348 86.0464 56.3058 86.0464 54.913C86.0464 53.5203 87.3305 52.3913 88.9146 52.3913C90.4986 52.3913 91.7828 53.5203 91.7828 54.913Z"
        fill="#060606"
      />
      <path
        d="M40.155 17.087C40.155 18.4797 38.8708 19.6087 37.2868 19.6087C35.7027 19.6087 34.4185 18.4797 34.4185 17.087C34.4185 15.6942 35.7027 14.5652 37.2868 14.5652C38.8708 14.5652 40.155 15.6942 40.155 17.087Z"
        fill="#060606"
      />
      <path
        d="M91.7828 17.087C91.7828 18.4797 90.4986 19.6087 88.9146 19.6087C87.3305 19.6087 86.0464 18.4797 86.0464 17.087C86.0464 15.6942 87.3305 14.5652 88.9146 14.5652C90.4986 14.5652 91.7828 15.6942 91.7828 17.087Z"
        fill="#060606"
      />
      <path
        d="M40.155 47.3478C40.155 48.7405 38.8708 49.8696 37.2868 49.8696C35.7027 49.8696 34.4185 48.7405 34.4185 47.3478C34.4185 45.9551 35.7027 44.8261 37.2868 44.8261C38.8708 44.8261 40.155 45.9551 40.155 47.3478Z"
        fill="#060606"
      />
      <path
        d="M91.7828 47.3478C91.7828 48.7405 90.4986 49.8696 88.9146 49.8696C87.3305 49.8696 86.0464 48.7405 86.0464 47.3478C86.0464 45.9551 87.3305 44.8261 88.9146 44.8261C90.4986 44.8261 91.7828 45.9551 91.7828 47.3478Z"
        fill="#060606"
      />
      <path
        d="M40.155 32.2174C40.155 33.6101 38.8708 34.7391 37.2868 34.7391C35.7027 34.7391 34.4185 33.6101 34.4185 32.2174C34.4185 30.8247 35.7027 29.6957 37.2868 29.6957C38.8708 29.6957 40.155 30.8247 40.155 32.2174Z"
        fill="#060606"
      />
      <path
        d="M91.7828 32.2174C91.7828 33.6101 90.4986 34.7391 88.9146 34.7391C87.3305 34.7391 86.0464 33.6101 86.0464 32.2174C86.0464 30.8247 87.3305 29.6957 88.9146 29.6957C90.4986 29.6957 91.7828 30.8247 91.7828 32.2174Z"
        fill="#060606"
      />
      <path
        d="M40.155 62.4783C40.155 63.871 38.8708 65 37.2868 65C35.7027 65 34.4185 63.871 34.4185 62.4783C34.4185 61.0855 35.7027 59.9565 37.2868 59.9565C38.8708 59.9565 40.155 61.0855 40.155 62.4783Z"
        fill="#060606"
      />
      <path
        d="M91.7828 62.4783C91.7828 63.871 90.4986 65 88.9146 65C87.3305 65 86.0464 63.871 86.0464 62.4783C86.0464 61.0855 87.3305 59.9565 88.9146 59.9565C90.4986 59.9565 91.7828 61.0855 91.7828 62.4783Z"
        fill="#060606"
      />
      <path
        d="M14.3411 9.52174C14.3411 10.9145 13.0569 12.0435 11.4728 12.0435C9.88878 12.0435 8.60464 10.9145 8.60464 9.52174C8.60464 8.12902 9.88878 7 11.4728 7C13.0569 7 14.3411 8.12902 14.3411 9.52174Z"
        fill="#060606"
      />
      <path
        d="M65.9689 9.52174C65.9689 10.9145 64.6847 12.0435 63.1007 12.0435C61.5166 12.0435 60.2325 10.9145 60.2325 9.52174C60.2325 8.12902 61.5166 7 63.1007 7C64.6847 7 65.9689 8.12902 65.9689 9.52174Z"
        fill="#060606"
      />
      <path
        d="M14.3411 39.7826C14.3411 41.1753 13.0569 42.3044 11.4728 42.3044C9.88878 42.3044 8.60464 41.1753 8.60464 39.7826C8.60464 38.3899 9.88878 37.2609 11.4728 37.2609C13.0569 37.2609 14.3411 38.3899 14.3411 39.7826Z"
        fill="#060606"
      />
      <path
        d="M65.9689 39.7826C65.9689 41.1753 64.6847 42.3044 63.1007 42.3044C61.5166 42.3044 60.2325 41.1753 60.2325 39.7826C60.2325 38.3899 61.5166 37.2609 63.1007 37.2609C64.6847 37.2609 65.9689 38.3899 65.9689 39.7826Z"
        fill="#060606"
      />
      <path
        d="M14.3411 24.6522C14.3411 26.0449 13.0569 27.1739 11.4728 27.1739C9.88878 27.1739 8.60464 26.0449 8.60464 24.6522C8.60464 23.2595 9.88878 22.1304 11.4728 22.1304C13.0569 22.1304 14.3411 23.2595 14.3411 24.6522Z"
        fill="#060606"
      />
      <path
        d="M65.9689 24.6522C65.9689 26.0449 64.6847 27.1739 63.1007 27.1739C61.5166 27.1739 60.2325 26.0449 60.2325 24.6522C60.2325 23.2595 61.5166 22.1304 63.1007 22.1304C64.6847 22.1304 65.9689 23.2595 65.9689 24.6522Z"
        fill="#060606"
      />
      <path
        d="M14.3411 54.913C14.3411 56.3058 13.0569 57.4348 11.4728 57.4348C9.88878 57.4348 8.60464 56.3058 8.60464 54.913C8.60464 53.5203 9.88878 52.3913 11.4728 52.3913C13.0569 52.3913 14.3411 53.5203 14.3411 54.913Z"
        fill="#060606"
      />
      <path
        d="M65.9689 54.913C65.9689 56.3058 64.6847 57.4348 63.1007 57.4348C61.5166 57.4348 60.2325 56.3058 60.2325 54.913C60.2325 53.5203 61.5166 52.3913 63.1007 52.3913C64.6847 52.3913 65.9689 53.5203 65.9689 54.913Z"
        fill="#060606"
      />
      <path
        d="M14.3411 17.087C14.3411 18.4797 13.0569 19.6087 11.4728 19.6087C9.88878 19.6087 8.60464 18.4797 8.60464 17.087C8.60464 15.6942 9.88878 14.5652 11.4728 14.5652C13.0569 14.5652 14.3411 15.6942 14.3411 17.087Z"
        fill="#060606"
      />
      <path
        d="M65.9689 17.087C65.9689 18.4797 64.6847 19.6087 63.1007 19.6087C61.5166 19.6087 60.2325 18.4797 60.2325 17.087C60.2325 15.6942 61.5166 14.5652 63.1007 14.5652C64.6847 14.5652 65.9689 15.6942 65.9689 17.087Z"
        fill="#060606"
      />
      <path
        d="M14.3411 47.3478C14.3411 48.7405 13.0569 49.8696 11.4728 49.8696C9.88878 49.8696 8.60464 48.7405 8.60464 47.3478C8.60464 45.9551 9.88878 44.8261 11.4728 44.8261C13.0569 44.8261 14.3411 45.9551 14.3411 47.3478Z"
        fill="#060606"
      />
      <path
        d="M65.9689 47.3478C65.9689 48.7405 64.6847 49.8696 63.1007 49.8696C61.5166 49.8696 60.2325 48.7405 60.2325 47.3478C60.2325 45.9551 61.5166 44.8261 63.1007 44.8261C64.6847 44.8261 65.9689 45.9551 65.9689 47.3478Z"
        fill="#060606"
      />
      <path
        d="M14.3411 32.2174C14.3411 33.6101 13.0569 34.7391 11.4728 34.7391C9.88878 34.7391 8.60464 33.6101 8.60464 32.2174C8.60464 30.8247 9.88878 29.6957 11.4728 29.6957C13.0569 29.6957 14.3411 30.8247 14.3411 32.2174Z"
        fill="#060606"
      />
      <path
        d="M65.9689 32.2174C65.9689 33.6101 64.6847 34.7391 63.1007 34.7391C61.5166 34.7391 60.2325 33.6101 60.2325 32.2174C60.2325 30.8247 61.5166 29.6957 63.1007 29.6957C64.6847 29.6957 65.9689 30.8247 65.9689 32.2174Z"
        fill="#060606"
      />
      <path
        d="M14.3411 62.4783C14.3411 63.871 13.0569 65 11.4728 65C9.88878 65 8.60464 63.871 8.60464 62.4783C8.60464 61.0855 9.88878 59.9565 11.4728 59.9565C13.0569 59.9565 14.3411 61.0855 14.3411 62.4783Z"
        fill="#060606"
      />
      <path
        d="M65.9689 62.4783C65.9689 63.871 64.6847 65 63.1007 65C61.5166 65 60.2325 63.871 60.2325 62.4783C60.2325 61.0855 61.5166 59.9565 63.1007 59.9565C64.6847 59.9565 65.9689 61.0855 65.9689 62.4783Z"
        fill="#060606"
      />
      <path
        d="M31.5503 9.52174C31.5503 10.9145 30.2662 12.0435 28.6821 12.0435C27.0981 12.0435 25.8139 10.9145 25.8139 9.52174C25.8139 8.12902 27.0981 7 28.6821 7C30.2662 7 31.5503 8.12902 31.5503 9.52174Z"
        fill="#060606"
      />
      <path
        d="M83.1782 9.52174C83.1782 10.9145 81.894 12.0435 80.3099 12.0435C78.7259 12.0435 77.4417 10.9145 77.4417 9.52174C77.4417 8.12902 78.7259 7 80.3099 7C81.894 7 83.1782 8.12902 83.1782 9.52174Z"
        fill="#060606"
      />
      <path
        d="M31.5503 39.7826C31.5503 41.1753 30.2662 42.3044 28.6821 42.3044C27.0981 42.3044 25.8139 41.1753 25.8139 39.7826C25.8139 38.3899 27.0981 37.2609 28.6821 37.2609C30.2662 37.2609 31.5503 38.3899 31.5503 39.7826Z"
        fill="#060606"
      />
      <path
        d="M83.1782 39.7826C83.1782 41.1753 81.894 42.3044 80.3099 42.3044C78.7259 42.3044 77.4417 41.1753 77.4417 39.7826C77.4417 38.3899 78.7259 37.2609 80.3099 37.2609C81.894 37.2609 83.1782 38.3899 83.1782 39.7826Z"
        fill="#060606"
      />
      <path
        d="M31.5503 24.6522C31.5503 26.0449 30.2662 27.1739 28.6821 27.1739C27.0981 27.1739 25.8139 26.0449 25.8139 24.6522C25.8139 23.2595 27.0981 22.1304 28.6821 22.1304C30.2662 22.1304 31.5503 23.2595 31.5503 24.6522Z"
        fill="#060606"
      />
      <path
        d="M83.1782 24.6522C83.1782 26.0449 81.894 27.1739 80.3099 27.1739C78.7259 27.1739 77.4417 26.0449 77.4417 24.6522C77.4417 23.2595 78.7259 22.1304 80.3099 22.1304C81.894 22.1304 83.1782 23.2595 83.1782 24.6522Z"
        fill="#060606"
      />
      <path
        d="M31.5503 54.913C31.5503 56.3058 30.2662 57.4348 28.6821 57.4348C27.0981 57.4348 25.8139 56.3058 25.8139 54.913C25.8139 53.5203 27.0981 52.3913 28.6821 52.3913C30.2662 52.3913 31.5503 53.5203 31.5503 54.913Z"
        fill="#060606"
      />
      <path
        d="M83.1782 54.913C83.1782 56.3058 81.894 57.4348 80.3099 57.4348C78.7259 57.4348 77.4417 56.3058 77.4417 54.913C77.4417 53.5203 78.7259 52.3913 80.3099 52.3913C81.894 52.3913 83.1782 53.5203 83.1782 54.913Z"
        fill="#060606"
      />
      <path
        d="M31.5503 17.087C31.5503 18.4797 30.2662 19.6087 28.6821 19.6087C27.0981 19.6087 25.8139 18.4797 25.8139 17.087C25.8139 15.6942 27.0981 14.5652 28.6821 14.5652C30.2662 14.5652 31.5503 15.6942 31.5503 17.087Z"
        fill="#060606"
      />
      <path
        d="M83.1782 17.087C83.1782 18.4797 81.894 19.6087 80.3099 19.6087C78.7259 19.6087 77.4417 18.4797 77.4417 17.087C77.4417 15.6942 78.7259 14.5652 80.3099 14.5652C81.894 14.5652 83.1782 15.6942 83.1782 17.087Z"
        fill="#060606"
      />
      <path
        d="M31.5503 47.3478C31.5503 48.7405 30.2662 49.8696 28.6821 49.8696C27.0981 49.8696 25.8139 48.7405 25.8139 47.3478C25.8139 45.9551 27.0981 44.8261 28.6821 44.8261C30.2662 44.8261 31.5503 45.9551 31.5503 47.3478Z"
        fill="#060606"
      />
      <path
        d="M83.1782 47.3478C83.1782 48.7405 81.894 49.8696 80.3099 49.8696C78.7259 49.8696 77.4417 48.7405 77.4417 47.3478C77.4417 45.9551 78.7259 44.8261 80.3099 44.8261C81.894 44.8261 83.1782 45.9551 83.1782 47.3478Z"
        fill="#060606"
      />
      <path
        d="M31.5503 32.2174C31.5503 33.6101 30.2662 34.7391 28.6821 34.7391C27.0981 34.7391 25.8139 33.6101 25.8139 32.2174C25.8139 30.8247 27.0981 29.6957 28.6821 29.6957C30.2662 29.6957 31.5503 30.8247 31.5503 32.2174Z"
        fill="#060606"
      />
      <path
        d="M83.1782 32.2174C83.1782 33.6101 81.894 34.7391 80.3099 34.7391C78.7259 34.7391 77.4417 33.6101 77.4417 32.2174C77.4417 30.8247 78.7259 29.6957 80.3099 29.6957C81.894 29.6957 83.1782 30.8247 83.1782 32.2174Z"
        fill="#060606"
      />
      <path
        d="M31.5503 62.4783C31.5503 63.871 30.2662 65 28.6821 65C27.0981 65 25.8139 63.871 25.8139 62.4783C25.8139 61.0855 27.0981 59.9565 28.6821 59.9565C30.2662 59.9565 31.5503 61.0855 31.5503 62.4783Z"
        fill="#060606"
      />
      <path
        d="M83.1782 62.4783C83.1782 63.871 81.894 65 80.3099 65C78.7259 65 77.4417 63.871 77.4417 62.4783C77.4417 61.0855 78.7259 59.9565 80.3099 59.9565C81.894 59.9565 83.1782 61.0855 83.1782 62.4783Z"
        fill="#060606"
      />
      <path
        d="M48.7596 9.52174C48.7596 10.9145 47.4755 12.0435 45.8914 12.0435C44.3073 12.0435 43.0232 10.9145 43.0232 9.52174C43.0232 8.12902 44.3073 7 45.8914 7C47.4755 7 48.7596 8.12902 48.7596 9.52174Z"
        fill="#060606"
      />
      <path
        d="M100.387 9.52174C100.387 10.9145 99.1033 12.0435 97.5192 12.0435C95.9351 12.0435 94.651 10.9145 94.651 9.52174C94.651 8.12902 95.9351 7 97.5192 7C99.1033 7 100.387 8.12902 100.387 9.52174Z"
        fill="#060606"
      />
      <path
        d="M48.7596 39.7826C48.7596 41.1753 47.4755 42.3044 45.8914 42.3044C44.3073 42.3044 43.0232 41.1753 43.0232 39.7826C43.0232 38.3899 44.3073 37.2609 45.8914 37.2609C47.4755 37.2609 48.7596 38.3899 48.7596 39.7826Z"
        fill="#060606"
      />
      <path
        d="M100.387 39.7826C100.387 41.1753 99.1033 42.3044 97.5192 42.3044C95.9351 42.3044 94.651 41.1753 94.651 39.7826C94.651 38.3899 95.9351 37.2609 97.5192 37.2609C99.1033 37.2609 100.387 38.3899 100.387 39.7826Z"
        fill="#060606"
      />
      <path
        d="M48.7596 24.6522C48.7596 26.0449 47.4755 27.1739 45.8914 27.1739C44.3073 27.1739 43.0232 26.0449 43.0232 24.6522C43.0232 23.2595 44.3073 22.1304 45.8914 22.1304C47.4755 22.1304 48.7596 23.2595 48.7596 24.6522Z"
        fill="#060606"
      />
      <path
        d="M100.387 24.6522C100.387 26.0449 99.1033 27.1739 97.5192 27.1739C95.9351 27.1739 94.651 26.0449 94.651 24.6522C94.651 23.2595 95.9351 22.1304 97.5192 22.1304C99.1033 22.1304 100.387 23.2595 100.387 24.6522Z"
        fill="#060606"
      />
      <path
        d="M48.7596 54.913C48.7596 56.3058 47.4755 57.4348 45.8914 57.4348C44.3073 57.4348 43.0232 56.3058 43.0232 54.913C43.0232 53.5203 44.3073 52.3913 45.8914 52.3913C47.4755 52.3913 48.7596 53.5203 48.7596 54.913Z"
        fill="#060606"
      />
      <path
        d="M100.387 54.913C100.387 56.3058 99.1033 57.4348 97.5192 57.4348C95.9351 57.4348 94.651 56.3058 94.651 54.913C94.651 53.5203 95.9351 52.3913 97.5192 52.3913C99.1033 52.3913 100.387 53.5203 100.387 54.913Z"
        fill="#060606"
      />
      <path
        d="M48.7596 17.087C48.7596 18.4797 47.4755 19.6087 45.8914 19.6087C44.3073 19.6087 43.0232 18.4797 43.0232 17.087C43.0232 15.6942 44.3073 14.5652 45.8914 14.5652C47.4755 14.5652 48.7596 15.6942 48.7596 17.087Z"
        fill="#060606"
      />
      <path
        d="M100.387 17.087C100.387 18.4797 99.1033 19.6087 97.5192 19.6087C95.9351 19.6087 94.651 18.4797 94.651 17.087C94.651 15.6942 95.9351 14.5652 97.5192 14.5652C99.1033 14.5652 100.387 15.6942 100.387 17.087Z"
        fill="#060606"
      />
      <path
        d="M48.7596 47.3478C48.7596 48.7405 47.4755 49.8696 45.8914 49.8696C44.3073 49.8696 43.0232 48.7405 43.0232 47.3478C43.0232 45.9551 44.3073 44.8261 45.8914 44.8261C47.4755 44.8261 48.7596 45.9551 48.7596 47.3478Z"
        fill="#060606"
      />
      <path
        d="M100.387 47.3478C100.387 48.7405 99.1033 49.8696 97.5192 49.8696C95.9351 49.8696 94.651 48.7405 94.651 47.3478C94.651 45.9551 95.9351 44.8261 97.5192 44.8261C99.1033 44.8261 100.387 45.9551 100.387 47.3478Z"
        fill="#060606"
      />
      <path
        d="M48.7596 32.2174C48.7596 33.6101 47.4755 34.7391 45.8914 34.7391C44.3073 34.7391 43.0232 33.6101 43.0232 32.2174C43.0232 30.8247 44.3073 29.6957 45.8914 29.6957C47.4755 29.6957 48.7596 30.8247 48.7596 32.2174Z"
        fill="#060606"
      />
      <path
        d="M100.387 32.2174C100.387 33.6101 99.1033 34.7391 97.5192 34.7391C95.9351 34.7391 94.651 33.6101 94.651 32.2174C94.651 30.8247 95.9351 29.6957 97.5192 29.6957C99.1033 29.6957 100.387 30.8247 100.387 32.2174Z"
        fill="#060606"
      />
      <path
        d="M48.7596 62.4783C48.7596 63.871 47.4755 65 45.8914 65C44.3073 65 43.0232 63.871 43.0232 62.4783C43.0232 61.0855 44.3073 59.9565 45.8914 59.9565C47.4755 59.9565 48.7596 61.0855 48.7596 62.4783Z"
        fill="#060606"
      />
      <path
        d="M100.387 62.4783C100.387 63.871 99.1033 65 97.5192 65C95.9351 65 94.651 63.871 94.651 62.4783C94.651 61.0855 95.9351 59.9565 97.5192 59.9565C99.1033 59.9565 100.387 61.0855 100.387 62.4783Z"
        fill="#060606"
      />
      <path
        d="M108.405 9.52174C108.405 10.9145 107.121 12.0435 105.537 12.0435C103.953 12.0435 102.669 10.9145 102.669 9.52174C102.669 8.12902 103.953 7 105.537 7C107.121 7 108.405 8.12902 108.405 9.52174Z"
        fill="#060606"
      />
      <path
        d="M160.033 9.52174C160.033 10.9145 158.749 12.0435 157.165 12.0435C155.581 12.0435 154.297 10.9145 154.297 9.52174C154.297 8.12902 155.581 7 157.165 7C158.749 7 160.033 8.12902 160.033 9.52174Z"
        fill="#060606"
      />
      <path
        d="M108.405 39.7826C108.405 41.1753 107.121 42.3044 105.537 42.3044C103.953 42.3044 102.669 41.1753 102.669 39.7826C102.669 38.3899 103.953 37.2609 105.537 37.2609C107.121 37.2609 108.405 38.3899 108.405 39.7826Z"
        fill="#060606"
      />
      <path
        d="M160.033 39.7826C160.033 41.1753 158.749 42.3044 157.165 42.3044C155.581 42.3044 154.297 41.1753 154.297 39.7826C154.297 38.3899 155.581 37.2609 157.165 37.2609C158.749 37.2609 160.033 38.3899 160.033 39.7826Z"
        fill="#060606"
      />
      <path
        d="M108.405 24.6522C108.405 26.0449 107.121 27.1739 105.537 27.1739C103.953 27.1739 102.669 26.0449 102.669 24.6522C102.669 23.2595 103.953 22.1304 105.537 22.1304C107.121 22.1304 108.405 23.2595 108.405 24.6522Z"
        fill="#060606"
      />
      <path
        d="M160.033 24.6522C160.033 26.0449 158.749 27.1739 157.165 27.1739C155.581 27.1739 154.297 26.0449 154.297 24.6522C154.297 23.2595 155.581 22.1304 157.165 22.1304C158.749 22.1304 160.033 23.2595 160.033 24.6522Z"
        fill="#060606"
      />
      <path
        d="M108.405 54.913C108.405 56.3058 107.121 57.4348 105.537 57.4348C103.953 57.4348 102.669 56.3058 102.669 54.913C102.669 53.5203 103.953 52.3913 105.537 52.3913C107.121 52.3913 108.405 53.5203 108.405 54.913Z"
        fill="#060606"
      />
      <path
        d="M160.033 54.913C160.033 56.3058 158.749 57.4348 157.165 57.4348C155.581 57.4348 154.297 56.3058 154.297 54.913C154.297 53.5203 155.581 52.3913 157.165 52.3913C158.749 52.3913 160.033 53.5203 160.033 54.913Z"
        fill="#060606"
      />
      <path
        d="M108.405 17.087C108.405 18.4797 107.121 19.6087 105.537 19.6087C103.953 19.6087 102.669 18.4797 102.669 17.087C102.669 15.6942 103.953 14.5652 105.537 14.5652C107.121 14.5652 108.405 15.6942 108.405 17.087Z"
        fill="#060606"
      />
      <path
        d="M160.033 17.087C160.033 18.4797 158.749 19.6087 157.165 19.6087C155.581 19.6087 154.297 18.4797 154.297 17.087C154.297 15.6942 155.581 14.5652 157.165 14.5652C158.749 14.5652 160.033 15.6942 160.033 17.087Z"
        fill="#060606"
      />
      <path
        d="M108.405 47.3478C108.405 48.7405 107.121 49.8696 105.537 49.8696C103.953 49.8696 102.669 48.7405 102.669 47.3478C102.669 45.9551 103.953 44.8261 105.537 44.8261C107.121 44.8261 108.405 45.9551 108.405 47.3478Z"
        fill="#060606"
      />
      <path
        d="M160.033 47.3478C160.033 48.7405 158.749 49.8696 157.165 49.8696C155.581 49.8696 154.297 48.7405 154.297 47.3478C154.297 45.9551 155.581 44.8261 157.165 44.8261C158.749 44.8261 160.033 45.9551 160.033 47.3478Z"
        fill="#060606"
      />
      <path
        d="M108.405 32.2174C108.405 33.6101 107.121 34.7391 105.537 34.7391C103.953 34.7391 102.669 33.6101 102.669 32.2174C102.669 30.8247 103.953 29.6957 105.537 29.6957C107.121 29.6957 108.405 30.8247 108.405 32.2174Z"
        fill="#060606"
      />
      <path
        d="M160.033 32.2174C160.033 33.6101 158.749 34.7391 157.165 34.7391C155.581 34.7391 154.297 33.6101 154.297 32.2174C154.297 30.8247 155.581 29.6957 157.165 29.6957C158.749 29.6957 160.033 30.8247 160.033 32.2174Z"
        fill="#060606"
      />
      <path
        d="M108.405 62.4783C108.405 63.871 107.121 65 105.537 65C103.953 65 102.669 63.871 102.669 62.4783C102.669 61.0855 103.953 59.9565 105.537 59.9565C107.121 59.9565 108.405 61.0855 108.405 62.4783Z"
        fill="#060606"
      />
      <path
        d="M160.033 62.4783C160.033 63.871 158.749 65 157.165 65C155.581 65 154.297 63.871 154.297 62.4783C154.297 61.0855 155.581 59.9565 157.165 59.9565C158.749 59.9565 160.033 61.0855 160.033 62.4783Z"
        fill="#060606"
      />
      <path
        d="M125.615 9.52174C125.615 10.9145 124.331 12.0435 122.746 12.0435C121.162 12.0435 119.878 10.9145 119.878 9.52174C119.878 8.12902 121.162 7 122.746 7C124.331 7 125.615 8.12902 125.615 9.52174Z"
        fill="#060606"
      />
      <path
        d="M177.242 9.52174C177.242 10.9145 175.958 12.0435 174.374 12.0435C172.79 12.0435 171.506 10.9145 171.506 9.52174C171.506 8.12902 172.79 7 174.374 7C175.958 7 177.242 8.12902 177.242 9.52174Z"
        fill="#060606"
      />
      <path
        d="M125.615 39.7826C125.615 41.1753 124.331 42.3044 122.746 42.3044C121.162 42.3044 119.878 41.1753 119.878 39.7826C119.878 38.3899 121.162 37.2609 122.746 37.2609C124.331 37.2609 125.615 38.3899 125.615 39.7826Z"
        fill="#060606"
      />
      <path
        d="M177.242 39.7826C177.242 41.1753 175.958 42.3044 174.374 42.3044C172.79 42.3044 171.506 41.1753 171.506 39.7826C171.506 38.3899 172.79 37.2609 174.374 37.2609C175.958 37.2609 177.242 38.3899 177.242 39.7826Z"
        fill="#060606"
      />
      <path
        d="M125.615 24.6522C125.615 26.0449 124.331 27.1739 122.746 27.1739C121.162 27.1739 119.878 26.0449 119.878 24.6522C119.878 23.2595 121.162 22.1304 122.746 22.1304C124.331 22.1304 125.615 23.2595 125.615 24.6522Z"
        fill="#060606"
      />
      <path
        d="M177.242 24.6522C177.242 26.0449 175.958 27.1739 174.374 27.1739C172.79 27.1739 171.506 26.0449 171.506 24.6522C171.506 23.2595 172.79 22.1304 174.374 22.1304C175.958 22.1304 177.242 23.2595 177.242 24.6522Z"
        fill="#060606"
      />
      <path
        d="M125.615 54.913C125.615 56.3058 124.331 57.4348 122.746 57.4348C121.162 57.4348 119.878 56.3058 119.878 54.913C119.878 53.5203 121.162 52.3913 122.746 52.3913C124.331 52.3913 125.615 53.5203 125.615 54.913Z"
        fill="#060606"
      />
      <path
        d="M177.242 54.913C177.242 56.3058 175.958 57.4348 174.374 57.4348C172.79 57.4348 171.506 56.3058 171.506 54.913C171.506 53.5203 172.79 52.3913 174.374 52.3913C175.958 52.3913 177.242 53.5203 177.242 54.913Z"
        fill="#060606"
      />
      <path
        d="M125.615 17.087C125.615 18.4797 124.331 19.6087 122.746 19.6087C121.162 19.6087 119.878 18.4797 119.878 17.087C119.878 15.6942 121.162 14.5652 122.746 14.5652C124.331 14.5652 125.615 15.6942 125.615 17.087Z"
        fill="#060606"
      />
      <path
        d="M177.242 17.087C177.242 18.4797 175.958 19.6087 174.374 19.6087C172.79 19.6087 171.506 18.4797 171.506 17.087C171.506 15.6942 172.79 14.5652 174.374 14.5652C175.958 14.5652 177.242 15.6942 177.242 17.087Z"
        fill="#060606"
      />
      <path
        d="M125.615 47.3478C125.615 48.7405 124.331 49.8696 122.746 49.8696C121.162 49.8696 119.878 48.7405 119.878 47.3478C119.878 45.9551 121.162 44.8261 122.746 44.8261C124.331 44.8261 125.615 45.9551 125.615 47.3478Z"
        fill="#060606"
      />
      <path
        d="M177.242 47.3478C177.242 48.7405 175.958 49.8696 174.374 49.8696C172.79 49.8696 171.506 48.7405 171.506 47.3478C171.506 45.9551 172.79 44.8261 174.374 44.8261C175.958 44.8261 177.242 45.9551 177.242 47.3478Z"
        fill="#060606"
      />
      <path
        d="M125.615 32.2174C125.615 33.6101 124.331 34.7391 122.746 34.7391C121.162 34.7391 119.878 33.6101 119.878 32.2174C119.878 30.8247 121.162 29.6957 122.746 29.6957C124.331 29.6957 125.615 30.8247 125.615 32.2174Z"
        fill="#060606"
      />
      <path
        d="M177.242 32.2174C177.242 33.6101 175.958 34.7391 174.374 34.7391C172.79 34.7391 171.506 33.6101 171.506 32.2174C171.506 30.8247 172.79 29.6957 174.374 29.6957C175.958 29.6957 177.242 30.8247 177.242 32.2174Z"
        fill="#060606"
      />
      <path
        d="M125.615 62.4783C125.615 63.871 124.331 65 122.746 65C121.162 65 119.878 63.871 119.878 62.4783C119.878 61.0855 121.162 59.9565 122.746 59.9565C124.331 59.9565 125.615 61.0855 125.615 62.4783Z"
        fill="#060606"
      />
      <path
        d="M177.242 62.4783C177.242 63.871 175.958 65 174.374 65C172.79 65 171.506 63.871 171.506 62.4783C171.506 61.0855 172.79 59.9565 174.374 59.9565C175.958 59.9565 177.242 61.0855 177.242 62.4783Z"
        fill="#060606"
      />
      <path
        d="M142.824 9.52174C142.824 10.9145 141.54 12.0435 139.956 12.0435C138.372 12.0435 137.088 10.9145 137.088 9.52174C137.088 8.12902 138.372 7 139.956 7C141.54 7 142.824 8.12902 142.824 9.52174Z"
        fill="#060606"
      />
      <path
        d="M194.452 9.52174C194.452 10.9145 193.168 12.0435 191.584 12.0435C189.999 12.0435 188.715 10.9145 188.715 9.52174C188.715 8.12902 189.999 7 191.584 7C193.168 7 194.452 8.12902 194.452 9.52174Z"
        fill="#060606"
      />
      <path
        d="M142.824 39.7826C142.824 41.1753 141.54 42.3044 139.956 42.3044C138.372 42.3044 137.088 41.1753 137.088 39.7826C137.088 38.3899 138.372 37.2609 139.956 37.2609C141.54 37.2609 142.824 38.3899 142.824 39.7826Z"
        fill="#060606"
      />
      <path
        d="M194.452 39.7826C194.452 41.1753 193.168 42.3044 191.584 42.3044C189.999 42.3044 188.715 41.1753 188.715 39.7826C188.715 38.3899 189.999 37.2609 191.584 37.2609C193.168 37.2609 194.452 38.3899 194.452 39.7826Z"
        fill="#060606"
      />
      <path
        d="M142.824 24.6522C142.824 26.0449 141.54 27.1739 139.956 27.1739C138.372 27.1739 137.088 26.0449 137.088 24.6522C137.088 23.2595 138.372 22.1304 139.956 22.1304C141.54 22.1304 142.824 23.2595 142.824 24.6522Z"
        fill="#060606"
      />
      <path
        d="M194.452 24.6522C194.452 26.0449 193.168 27.1739 191.584 27.1739C189.999 27.1739 188.715 26.0449 188.715 24.6522C188.715 23.2595 189.999 22.1304 191.584 22.1304C193.168 22.1304 194.452 23.2595 194.452 24.6522Z"
        fill="#060606"
      />
      <path
        d="M142.824 54.913C142.824 56.3058 141.54 57.4348 139.956 57.4348C138.372 57.4348 137.088 56.3058 137.088 54.913C137.088 53.5203 138.372 52.3913 139.956 52.3913C141.54 52.3913 142.824 53.5203 142.824 54.913Z"
        fill="#060606"
      />
      <path
        d="M194.452 54.913C194.452 56.3058 193.168 57.4348 191.584 57.4348C189.999 57.4348 188.715 56.3058 188.715 54.913C188.715 53.5203 189.999 52.3913 191.584 52.3913C193.168 52.3913 194.452 53.5203 194.452 54.913Z"
        fill="#060606"
      />
      <path
        d="M142.824 17.087C142.824 18.4797 141.54 19.6087 139.956 19.6087C138.372 19.6087 137.088 18.4797 137.088 17.087C137.088 15.6942 138.372 14.5652 139.956 14.5652C141.54 14.5652 142.824 15.6942 142.824 17.087Z"
        fill="#060606"
      />
      <path
        d="M194.452 17.087C194.452 18.4797 193.168 19.6087 191.584 19.6087C189.999 19.6087 188.715 18.4797 188.715 17.087C188.715 15.6942 189.999 14.5652 191.584 14.5652C193.168 14.5652 194.452 15.6942 194.452 17.087Z"
        fill="#060606"
      />
      <path
        d="M142.824 47.3478C142.824 48.7405 141.54 49.8696 139.956 49.8696C138.372 49.8696 137.088 48.7405 137.088 47.3478C137.088 45.9551 138.372 44.8261 139.956 44.8261C141.54 44.8261 142.824 45.9551 142.824 47.3478Z"
        fill="#060606"
      />
      <path
        d="M194.452 47.3478C194.452 48.7405 193.168 49.8696 191.584 49.8696C189.999 49.8696 188.715 48.7405 188.715 47.3478C188.715 45.9551 189.999 44.8261 191.584 44.8261C193.168 44.8261 194.452 45.9551 194.452 47.3478Z"
        fill="#060606"
      />
      <path
        d="M142.824 32.2174C142.824 33.6101 141.54 34.7391 139.956 34.7391C138.372 34.7391 137.088 33.6101 137.088 32.2174C137.088 30.8247 138.372 29.6957 139.956 29.6957C141.54 29.6957 142.824 30.8247 142.824 32.2174Z"
        fill="#060606"
      />
      <path
        d="M194.452 32.2174C194.452 33.6101 193.168 34.7391 191.584 34.7391C189.999 34.7391 188.715 33.6101 188.715 32.2174C188.715 30.8247 189.999 29.6957 191.584 29.6957C193.168 29.6957 194.452 30.8247 194.452 32.2174Z"
        fill="#060606"
      />
      <path
        d="M142.824 62.4783C142.824 63.871 141.54 65 139.956 65C138.372 65 137.088 63.871 137.088 62.4783C137.088 61.0855 138.372 59.9565 139.956 59.9565C141.54 59.9565 142.824 61.0855 142.824 62.4783Z"
        fill="#060606"
      />
      <path
        d="M194.452 62.4783C194.452 63.871 193.168 65 191.584 65C189.999 65 188.715 63.871 188.715 62.4783C188.715 61.0855 189.999 59.9565 191.584 59.9565C193.168 59.9565 194.452 61.0855 194.452 62.4783Z"
        fill="#060606"
      />
      <path
        d="M117.01 9.52174C117.01 10.9145 115.726 12.0435 114.142 12.0435C112.558 12.0435 111.274 10.9145 111.274 9.52174C111.274 8.12902 112.558 7 114.142 7C115.726 7 117.01 8.12902 117.01 9.52174Z"
        fill="#060606"
      />
      <path
        d="M168.638 9.52174C168.638 10.9145 167.354 12.0435 165.77 12.0435C164.186 12.0435 162.901 10.9145 162.901 9.52174C162.901 8.12902 164.186 7 165.77 7C167.354 7 168.638 8.12902 168.638 9.52174Z"
        fill="#060606"
      />
      <path
        d="M117.01 39.7826C117.01 41.1753 115.726 42.3044 114.142 42.3044C112.558 42.3044 111.274 41.1753 111.274 39.7826C111.274 38.3899 112.558 37.2609 114.142 37.2609C115.726 37.2609 117.01 38.3899 117.01 39.7826Z"
        fill="#060606"
      />
      <path
        d="M168.638 39.7826C168.638 41.1753 167.354 42.3044 165.77 42.3044C164.186 42.3044 162.901 41.1753 162.901 39.7826C162.901 38.3899 164.186 37.2609 165.77 37.2609C167.354 37.2609 168.638 38.3899 168.638 39.7826Z"
        fill="#060606"
      />
      <path
        d="M117.01 24.6522C117.01 26.0449 115.726 27.1739 114.142 27.1739C112.558 27.1739 111.274 26.0449 111.274 24.6522C111.274 23.2595 112.558 22.1304 114.142 22.1304C115.726 22.1304 117.01 23.2595 117.01 24.6522Z"
        fill="#060606"
      />
      <path
        d="M168.638 24.6522C168.638 26.0449 167.354 27.1739 165.77 27.1739C164.186 27.1739 162.901 26.0449 162.901 24.6522C162.901 23.2595 164.186 22.1304 165.77 22.1304C167.354 22.1304 168.638 23.2595 168.638 24.6522Z"
        fill="#060606"
      />
      <path
        d="M117.01 54.913C117.01 56.3058 115.726 57.4348 114.142 57.4348C112.558 57.4348 111.274 56.3058 111.274 54.913C111.274 53.5203 112.558 52.3913 114.142 52.3913C115.726 52.3913 117.01 53.5203 117.01 54.913Z"
        fill="#060606"
      />
      <path
        d="M168.638 54.913C168.638 56.3058 167.354 57.4348 165.77 57.4348C164.186 57.4348 162.901 56.3058 162.901 54.913C162.901 53.5203 164.186 52.3913 165.77 52.3913C167.354 52.3913 168.638 53.5203 168.638 54.913Z"
        fill="#060606"
      />
      <path
        d="M117.01 17.087C117.01 18.4797 115.726 19.6087 114.142 19.6087C112.558 19.6087 111.274 18.4797 111.274 17.087C111.274 15.6942 112.558 14.5652 114.142 14.5652C115.726 14.5652 117.01 15.6942 117.01 17.087Z"
        fill="#060606"
      />
      <path
        d="M168.638 17.087C168.638 18.4797 167.354 19.6087 165.77 19.6087C164.186 19.6087 162.901 18.4797 162.901 17.087C162.901 15.6942 164.186 14.5652 165.77 14.5652C167.354 14.5652 168.638 15.6942 168.638 17.087Z"
        fill="#060606"
      />
      <path
        d="M117.01 47.3478C117.01 48.7405 115.726 49.8696 114.142 49.8696C112.558 49.8696 111.274 48.7405 111.274 47.3478C111.274 45.9551 112.558 44.8261 114.142 44.8261C115.726 44.8261 117.01 45.9551 117.01 47.3478Z"
        fill="#060606"
      />
      <path
        d="M168.638 47.3478C168.638 48.7405 167.354 49.8696 165.77 49.8696C164.186 49.8696 162.901 48.7405 162.901 47.3478C162.901 45.9551 164.186 44.8261 165.77 44.8261C167.354 44.8261 168.638 45.9551 168.638 47.3478Z"
        fill="#060606"
      />
      <path
        d="M117.01 32.2174C117.01 33.6101 115.726 34.7391 114.142 34.7391C112.558 34.7391 111.274 33.6101 111.274 32.2174C111.274 30.8247 112.558 29.6957 114.142 29.6957C115.726 29.6957 117.01 30.8247 117.01 32.2174Z"
        fill="#060606"
      />
      <path
        d="M168.638 32.2174C168.638 33.6101 167.354 34.7391 165.77 34.7391C164.186 34.7391 162.901 33.6101 162.901 32.2174C162.901 30.8247 164.186 29.6957 165.77 29.6957C167.354 29.6957 168.638 30.8247 168.638 32.2174Z"
        fill="#060606"
      />
      <path
        d="M117.01 62.4783C117.01 63.871 115.726 65 114.142 65C112.558 65 111.274 63.871 111.274 62.4783C111.274 61.0855 112.558 59.9565 114.142 59.9565C115.726 59.9565 117.01 61.0855 117.01 62.4783Z"
        fill="#060606"
      />
      <path
        d="M168.638 62.4783C168.638 63.871 167.354 65 165.77 65C164.186 65 162.901 63.871 162.901 62.4783C162.901 61.0855 164.186 59.9565 165.77 59.9565C167.354 59.9565 168.638 61.0855 168.638 62.4783Z"
        fill="#060606"
      />
      <path
        d="M134.219 9.52174C134.219 10.9145 132.935 12.0435 131.351 12.0435C129.767 12.0435 128.483 10.9145 128.483 9.52174C128.483 8.12902 129.767 7 131.351 7C132.935 7 134.219 8.12902 134.219 9.52174Z"
        fill="#060606"
      />
      <path
        d="M185.847 9.52174C185.847 10.9145 184.563 12.0435 182.979 12.0435C181.395 12.0435 180.111 10.9145 180.111 9.52174C180.111 8.12902 181.395 7 182.979 7C184.563 7 185.847 8.12902 185.847 9.52174Z"
        fill="#060606"
      />
      <path
        d="M134.219 39.7826C134.219 41.1753 132.935 42.3044 131.351 42.3044C129.767 42.3044 128.483 41.1753 128.483 39.7826C128.483 38.3899 129.767 37.2609 131.351 37.2609C132.935 37.2609 134.219 38.3899 134.219 39.7826Z"
        fill="#060606"
      />
      <path
        d="M185.847 39.7826C185.847 41.1753 184.563 42.3044 182.979 42.3044C181.395 42.3044 180.111 41.1753 180.111 39.7826C180.111 38.3899 181.395 37.2609 182.979 37.2609C184.563 37.2609 185.847 38.3899 185.847 39.7826Z"
        fill="#060606"
      />
      <path
        d="M134.219 24.6522C134.219 26.0449 132.935 27.1739 131.351 27.1739C129.767 27.1739 128.483 26.0449 128.483 24.6522C128.483 23.2595 129.767 22.1304 131.351 22.1304C132.935 22.1304 134.219 23.2595 134.219 24.6522Z"
        fill="#060606"
      />
      <path
        d="M185.847 24.6522C185.847 26.0449 184.563 27.1739 182.979 27.1739C181.395 27.1739 180.111 26.0449 180.111 24.6522C180.111 23.2595 181.395 22.1304 182.979 22.1304C184.563 22.1304 185.847 23.2595 185.847 24.6522Z"
        fill="#060606"
      />
      <path
        d="M134.219 54.913C134.219 56.3058 132.935 57.4348 131.351 57.4348C129.767 57.4348 128.483 56.3058 128.483 54.913C128.483 53.5203 129.767 52.3913 131.351 52.3913C132.935 52.3913 134.219 53.5203 134.219 54.913Z"
        fill="#060606"
      />
      <path
        d="M185.847 54.913C185.847 56.3058 184.563 57.4348 182.979 57.4348C181.395 57.4348 180.111 56.3058 180.111 54.913C180.111 53.5203 181.395 52.3913 182.979 52.3913C184.563 52.3913 185.847 53.5203 185.847 54.913Z"
        fill="#060606"
      />
      <path
        d="M134.219 17.087C134.219 18.4797 132.935 19.6087 131.351 19.6087C129.767 19.6087 128.483 18.4797 128.483 17.087C128.483 15.6942 129.767 14.5652 131.351 14.5652C132.935 14.5652 134.219 15.6942 134.219 17.087Z"
        fill="#060606"
      />
      <path
        d="M185.847 17.087C185.847 18.4797 184.563 19.6087 182.979 19.6087C181.395 19.6087 180.111 18.4797 180.111 17.087C180.111 15.6942 181.395 14.5652 182.979 14.5652C184.563 14.5652 185.847 15.6942 185.847 17.087Z"
        fill="#060606"
      />
      <path
        d="M134.219 47.3478C134.219 48.7405 132.935 49.8696 131.351 49.8696C129.767 49.8696 128.483 48.7405 128.483 47.3478C128.483 45.9551 129.767 44.8261 131.351 44.8261C132.935 44.8261 134.219 45.9551 134.219 47.3478Z"
        fill="#060606"
      />
      <path
        d="M185.847 47.3478C185.847 48.7405 184.563 49.8696 182.979 49.8696C181.395 49.8696 180.111 48.7405 180.111 47.3478C180.111 45.9551 181.395 44.8261 182.979 44.8261C184.563 44.8261 185.847 45.9551 185.847 47.3478Z"
        fill="#060606"
      />
      <path
        d="M134.219 32.2174C134.219 33.6101 132.935 34.7391 131.351 34.7391C129.767 34.7391 128.483 33.6101 128.483 32.2174C128.483 30.8247 129.767 29.6957 131.351 29.6957C132.935 29.6957 134.219 30.8247 134.219 32.2174Z"
        fill="#060606"
      />
      <path
        d="M185.847 32.2174C185.847 33.6101 184.563 34.7391 182.979 34.7391C181.395 34.7391 180.111 33.6101 180.111 32.2174C180.111 30.8247 181.395 29.6957 182.979 29.6957C184.563 29.6957 185.847 30.8247 185.847 32.2174Z"
        fill="#060606"
      />
      <path
        d="M134.219 62.4783C134.219 63.871 132.935 65 131.351 65C129.767 65 128.483 63.871 128.483 62.4783C128.483 61.0855 129.767 59.9565 131.351 59.9565C132.935 59.9565 134.219 61.0855 134.219 62.4783Z"
        fill="#060606"
      />
      <path
        d="M185.847 62.4783C185.847 63.871 184.563 65 182.979 65C181.395 65 180.111 63.871 180.111 62.4783C180.111 61.0855 181.395 59.9565 182.979 59.9565C184.563 59.9565 185.847 61.0855 185.847 62.4783Z"
        fill="#060606"
      />
      <path
        d="M151.429 9.52174C151.429 10.9145 150.144 12.0435 148.56 12.0435C146.976 12.0435 145.692 10.9145 145.692 9.52174C145.692 8.12902 146.976 7 148.56 7C150.144 7 151.429 8.12902 151.429 9.52174Z"
        fill="#060606"
      />
      <path
        d="M203.056 9.52174C203.056 10.9145 201.772 12.0435 200.188 12.0435C198.604 12.0435 197.32 10.9145 197.32 9.52174C197.32 8.12902 198.604 7 200.188 7C201.772 7 203.056 8.12902 203.056 9.52174Z"
        fill="#060606"
      />
      <path
        d="M151.429 39.7826C151.429 41.1753 150.144 42.3044 148.56 42.3044C146.976 42.3044 145.692 41.1753 145.692 39.7826C145.692 38.3899 146.976 37.2609 148.56 37.2609C150.144 37.2609 151.429 38.3899 151.429 39.7826Z"
        fill="#060606"
      />
      <path
        d="M203.056 39.7826C203.056 41.1753 201.772 42.3044 200.188 42.3044C198.604 42.3044 197.32 41.1753 197.32 39.7826C197.32 38.3899 198.604 37.2609 200.188 37.2609C201.772 37.2609 203.056 38.3899 203.056 39.7826Z"
        fill="#060606"
      />
      <path
        d="M151.429 24.6522C151.429 26.0449 150.144 27.1739 148.56 27.1739C146.976 27.1739 145.692 26.0449 145.692 24.6522C145.692 23.2595 146.976 22.1304 148.56 22.1304C150.144 22.1304 151.429 23.2595 151.429 24.6522Z"
        fill="#060606"
      />
      <path
        d="M203.056 24.6522C203.056 26.0449 201.772 27.1739 200.188 27.1739C198.604 27.1739 197.32 26.0449 197.32 24.6522C197.32 23.2595 198.604 22.1304 200.188 22.1304C201.772 22.1304 203.056 23.2595 203.056 24.6522Z"
        fill="#060606"
      />
      <path
        d="M151.429 54.913C151.429 56.3058 150.144 57.4348 148.56 57.4348C146.976 57.4348 145.692 56.3058 145.692 54.913C145.692 53.5203 146.976 52.3913 148.56 52.3913C150.144 52.3913 151.429 53.5203 151.429 54.913Z"
        fill="#060606"
      />
      <path
        d="M203.056 54.913C203.056 56.3058 201.772 57.4348 200.188 57.4348C198.604 57.4348 197.32 56.3058 197.32 54.913C197.32 53.5203 198.604 52.3913 200.188 52.3913C201.772 52.3913 203.056 53.5203 203.056 54.913Z"
        fill="#060606"
      />
      <path
        d="M151.429 17.087C151.429 18.4797 150.144 19.6087 148.56 19.6087C146.976 19.6087 145.692 18.4797 145.692 17.087C145.692 15.6942 146.976 14.5652 148.56 14.5652C150.144 14.5652 151.429 15.6942 151.429 17.087Z"
        fill="#060606"
      />
      <path
        d="M203.056 17.087C203.056 18.4797 201.772 19.6087 200.188 19.6087C198.604 19.6087 197.32 18.4797 197.32 17.087C197.32 15.6942 198.604 14.5652 200.188 14.5652C201.772 14.5652 203.056 15.6942 203.056 17.087Z"
        fill="#060606"
      />
      <path
        d="M151.429 47.3478C151.429 48.7405 150.144 49.8696 148.56 49.8696C146.976 49.8696 145.692 48.7405 145.692 47.3478C145.692 45.9551 146.976 44.8261 148.56 44.8261C150.144 44.8261 151.429 45.9551 151.429 47.3478Z"
        fill="#060606"
      />
      <path
        d="M203.056 47.3478C203.056 48.7405 201.772 49.8696 200.188 49.8696C198.604 49.8696 197.32 48.7405 197.32 47.3478C197.32 45.9551 198.604 44.8261 200.188 44.8261C201.772 44.8261 203.056 45.9551 203.056 47.3478Z"
        fill="#060606"
      />
      <path
        d="M151.429 32.2174C151.429 33.6101 150.144 34.7391 148.56 34.7391C146.976 34.7391 145.692 33.6101 145.692 32.2174C145.692 30.8247 146.976 29.6957 148.56 29.6957C150.144 29.6957 151.429 30.8247 151.429 32.2174Z"
        fill="#060606"
      />
      <path
        d="M203.056 32.2174C203.056 33.6101 201.772 34.7391 200.188 34.7391C198.604 34.7391 197.32 33.6101 197.32 32.2174C197.32 30.8247 198.604 29.6957 200.188 29.6957C201.772 29.6957 203.056 30.8247 203.056 32.2174Z"
        fill="#060606"
      />
      <path
        d="M151.429 62.4783C151.429 63.871 150.144 65 148.56 65C146.976 65 145.692 63.871 145.692 62.4783C145.692 61.0855 146.976 59.9565 148.56 59.9565C150.144 59.9565 151.429 61.0855 151.429 62.4783Z"
        fill="#060606"
      />
      <path
        d="M203.056 62.4783C203.056 63.871 201.772 65 200.188 65C198.604 65 197.32 63.871 197.32 62.4783C197.32 61.0855 198.604 59.9565 200.188 59.9565C201.772 59.9565 203.056 61.0855 203.056 62.4783Z"
        fill="#060606"
      />
    </mask>
    <g mask="url(#mask0_1220_174861)">
      <path
        d="M-3.21094 49.388L78.8927 -44L199.874 10.9106L129.499 105L-3.21094 49.388Z"
        fill={color}
      />
    </g>
  </svg>
);

export default IconReportCard;
